!function e(t, n, r) {
  function s(o, a) {
    if (!n[o]) {
      if (!t[o]) {
        var l = "function" == typeof require && require;
        if (!a && l) return l(o, !0);
        if (i) return i(o, !0);
        var c = new Error("Cannot find module '" + o + "'");
        throw c.code = "MODULE_NOT_FOUND", c;
      }
      var p = n[o] = {
        exports: {}
      };
      t[o][0].call(p.exports, function (e) {
        return s(t[o][1][e] || e);
      }, p, p.exports, e, t, n, r);
    }
    return n[o].exports;
  }
  for (var i = "function" == typeof require && require, o = 0; o < r.length; o++) s(r[o]);
  return s;
}({
  1: [function (e, t, n) {
    "use strict";

    n.byteLength = function (e) {
      var t = l(e),
        n = t[0],
        r = t[1];
      return 3 * (n + r) / 4 - r;
    }, n.toByteArray = function (e) {
      var t,
        n,
        r = l(e),
        o = r[0],
        a = r[1],
        c = new i(function (e, t, n) {
          return 3 * (t + n) / 4 - n;
        }(0, o, a)),
        p = 0,
        h = a > 0 ? o - 4 : o;
      for (n = 0; n < h; n += 4) t = s[e.charCodeAt(n)] << 18 | s[e.charCodeAt(n + 1)] << 12 | s[e.charCodeAt(n + 2)] << 6 | s[e.charCodeAt(n + 3)], c[p++] = t >> 16 & 255, c[p++] = t >> 8 & 255, c[p++] = 255 & t;
      2 === a && (t = s[e.charCodeAt(n)] << 2 | s[e.charCodeAt(n + 1)] >> 4, c[p++] = 255 & t);
      1 === a && (t = s[e.charCodeAt(n)] << 10 | s[e.charCodeAt(n + 1)] << 4 | s[e.charCodeAt(n + 2)] >> 2, c[p++] = t >> 8 & 255, c[p++] = 255 & t);
      return c;
    }, n.fromByteArray = function (e) {
      for (var t, n = e.length, s = n % 3, i = [], o = 16383, a = 0, l = n - s; a < l; a += o) i.push(c(e, a, a + o > l ? l : a + o));
      1 === s ? (t = e[n - 1], i.push(r[t >> 2] + r[t << 4 & 63] + "==")) : 2 === s && (t = (e[n - 2] << 8) + e[n - 1], i.push(r[t >> 10] + r[t >> 4 & 63] + r[t << 2 & 63] + "="));
      return i.join("");
    };
    for (var r = [], s = [], i = "undefined" != typeof Uint8Array ? Uint8Array : Array, o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", a = 0; a < 64; ++a) r[a] = o[a], s[o.charCodeAt(a)] = a;
    function l(e) {
      var t = e.length;
      if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      var n = e.indexOf("=");
      return -1 === n && (n = t), [n, n === t ? 0 : 4 - n % 4];
    }
    function c(e, t, n) {
      for (var s, i, o = [], a = t; a < n; a += 3) s = (e[a] << 16 & 16711680) + (e[a + 1] << 8 & 65280) + (255 & e[a + 2]), o.push(r[(i = s) >> 18 & 63] + r[i >> 12 & 63] + r[i >> 6 & 63] + r[63 & i]);
      return o.join("");
    }
    s["-".charCodeAt(0)] = 62, s["_".charCodeAt(0)] = 63;
  }, {}],
  2: [function (e, t, n) {
    (function (t) {
      (function () {
        /*!
         * The buffer module from node.js, for the browser.
         *
         * @author   Feross Aboukhadijeh <https://feross.org>
         * @license  MIT
         */
        "use strict";

        var t = e("base64-js"),
          r = e("ieee754");
        n.Buffer = o, n.SlowBuffer = function (e) {
          +e != e && (e = 0);
          return o.alloc(+e);
        }, n.INSPECT_MAX_BYTES = 50;
        var s = 2147483647;
        function i(e) {
          if (e > s) throw new RangeError('The value "' + e + '" is invalid for option "size"');
          var t = new Uint8Array(e);
          return t.__proto__ = o.prototype, t;
        }
        function o(e, t, n) {
          if ("number" == typeof e) {
            if ("string" == typeof t) throw new TypeError('The "string" argument must be of type string. Received type number');
            return c(e);
          }
          return a(e, t, n);
        }
        function a(e, t, n) {
          if ("string" == typeof e) return function (e, t) {
            "string" == typeof t && "" !== t || (t = "utf8");
            if (!o.isEncoding(t)) throw new TypeError("Unknown encoding: " + t);
            var n = 0 | u(e, t),
              r = i(n),
              s = r.write(e, t);
            s !== n && (r = r.slice(0, s));
            return r;
          }(e, t);
          if (ArrayBuffer.isView(e)) return p(e);
          if (null == e) throw TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
          if (U(e, ArrayBuffer) || e && U(e.buffer, ArrayBuffer)) return function (e, t, n) {
            if (t < 0 || e.byteLength < t) throw new RangeError('"offset" is outside of buffer bounds');
            if (e.byteLength < t + (n || 0)) throw new RangeError('"length" is outside of buffer bounds');
            var r;
            r = void 0 === t && void 0 === n ? new Uint8Array(e) : void 0 === n ? new Uint8Array(e, t) : new Uint8Array(e, t, n);
            return r.__proto__ = o.prototype, r;
          }(e, t, n);
          if ("number" == typeof e) throw new TypeError('The "value" argument must not be of type number. Received type number');
          var r = e.valueOf && e.valueOf();
          if (null != r && r !== e) return o.from(r, t, n);
          var s = function (e) {
            if (o.isBuffer(e)) {
              var t = 0 | h(e.length),
                n = i(t);
              return 0 === n.length || e.copy(n, 0, 0, t), n;
            }
            if (void 0 !== e.length) return "number" != typeof e.length || F(e.length) ? i(0) : p(e);
            if ("Buffer" === e.type && Array.isArray(e.data)) return p(e.data);
          }(e);
          if (s) return s;
          if ("undefined" != typeof Symbol && null != Symbol.toPrimitive && "function" == typeof e[Symbol.toPrimitive]) return o.from(e[Symbol.toPrimitive]("string"), t, n);
          throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof e);
        }
        function l(e) {
          if ("number" != typeof e) throw new TypeError('"size" argument must be of type number');
          if (e < 0) throw new RangeError('The value "' + e + '" is invalid for option "size"');
        }
        function c(e) {
          return l(e), i(e < 0 ? 0 : 0 | h(e));
        }
        function p(e) {
          for (var t = e.length < 0 ? 0 : 0 | h(e.length), n = i(t), r = 0; r < t; r += 1) n[r] = 255 & e[r];
          return n;
        }
        function h(e) {
          if (e >= s) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s.toString(16) + " bytes");
          return 0 | e;
        }
        function u(e, t) {
          if (o.isBuffer(e)) return e.length;
          if (ArrayBuffer.isView(e) || U(e, ArrayBuffer)) return e.byteLength;
          if ("string" != typeof e) throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof e);
          var n = e.length,
            r = arguments.length > 2 && !0 === arguments[2];
          if (!r && 0 === n) return 0;
          for (var s = !1;;) switch (t) {
            case "ascii":
            case "latin1":
            case "binary":
              return n;
            case "utf8":
            case "utf-8":
              return P(e).length;
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return 2 * n;
            case "hex":
              return n >>> 1;
            case "base64":
              return I(e).length;
            default:
              if (s) return r ? -1 : P(e).length;
              t = ("" + t).toLowerCase(), s = !0;
          }
        }
        function d(e, t, n) {
          var r = !1;
          if ((void 0 === t || t < 0) && (t = 0), t > this.length) return "";
          if ((void 0 === n || n > this.length) && (n = this.length), n <= 0) return "";
          if ((n >>>= 0) <= (t >>>= 0)) return "";
          for (e || (e = "utf8");;) switch (e) {
            case "hex":
              return O(this, t, n);
            case "utf8":
            case "utf-8":
              return k(this, t, n);
            case "ascii":
              return S(this, t, n);
            case "latin1":
            case "binary":
              return M(this, t, n);
            case "base64":
              return A(this, t, n);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return $(this, t, n);
            default:
              if (r) throw new TypeError("Unknown encoding: " + e);
              e = (e + "").toLowerCase(), r = !0;
          }
        }
        function f(e, t, n) {
          var r = e[t];
          e[t] = e[n], e[n] = r;
        }
        function g(e, t, n, r, s) {
          if (0 === e.length) return -1;
          if ("string" == typeof n ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), F(n = +n) && (n = s ? 0 : e.length - 1), n < 0 && (n = e.length + n), n >= e.length) {
            if (s) return -1;
            n = e.length - 1;
          } else if (n < 0) {
            if (!s) return -1;
            n = 0;
          }
          if ("string" == typeof t && (t = o.from(t, r)), o.isBuffer(t)) return 0 === t.length ? -1 : m(e, t, n, r, s);
          if ("number" == typeof t) return t &= 255, "function" == typeof Uint8Array.prototype.indexOf ? s ? Uint8Array.prototype.indexOf.call(e, t, n) : Uint8Array.prototype.lastIndexOf.call(e, t, n) : m(e, [t], n, r, s);
          throw new TypeError("val must be string, number or Buffer");
        }
        function m(e, t, n, r, s) {
          var i,
            o = 1,
            a = e.length,
            l = t.length;
          if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
            if (e.length < 2 || t.length < 2) return -1;
            o = 2, a /= 2, l /= 2, n /= 2;
          }
          function c(e, t) {
            return 1 === o ? e[t] : e.readUInt16BE(t * o);
          }
          if (s) {
            var p = -1;
            for (i = n; i < a; i++) if (c(e, i) === c(t, -1 === p ? 0 : i - p)) {
              if (-1 === p && (p = i), i - p + 1 === l) return p * o;
            } else -1 !== p && (i -= i - p), p = -1;
          } else for (n + l > a && (n = a - l), i = n; i >= 0; i--) {
            for (var h = !0, u = 0; u < l; u++) if (c(e, i + u) !== c(t, u)) {
              h = !1;
              break;
            }
            if (h) return i;
          }
          return -1;
        }
        function b(e, t, n, r) {
          n = Number(n) || 0;
          var s = e.length - n;
          r ? (r = Number(r)) > s && (r = s) : r = s;
          var i = t.length;
          r > i / 2 && (r = i / 2);
          for (var o = 0; o < r; ++o) {
            var a = parseInt(t.substr(2 * o, 2), 16);
            if (F(a)) return o;
            e[n + o] = a;
          }
          return o;
        }
        function y(e, t, n, r) {
          return H(P(t, e.length - n), e, n, r);
        }
        function T(e, t, n, r) {
          return H(function (e) {
            for (var t = [], n = 0; n < e.length; ++n) t.push(255 & e.charCodeAt(n));
            return t;
          }(t), e, n, r);
        }
        function E(e, t, n, r) {
          return T(e, t, n, r);
        }
        function x(e, t, n, r) {
          return H(I(t), e, n, r);
        }
        function w(e, t, n, r) {
          return H(function (e, t) {
            for (var n, r, s, i = [], o = 0; o < e.length && !((t -= 2) < 0); ++o) r = (n = e.charCodeAt(o)) >> 8, s = n % 256, i.push(s), i.push(r);
            return i;
          }(t, e.length - n), e, n, r);
        }
        function A(e, n, r) {
          return 0 === n && r === e.length ? t.fromByteArray(e) : t.fromByteArray(e.slice(n, r));
        }
        function k(e, t, n) {
          n = Math.min(e.length, n);
          for (var r = [], s = t; s < n;) {
            var i,
              o,
              a,
              l,
              c = e[s],
              p = null,
              h = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
            if (s + h <= n) switch (h) {
              case 1:
                c < 128 && (p = c);
                break;
              case 2:
                128 == (192 & (i = e[s + 1])) && (l = (31 & c) << 6 | 63 & i) > 127 && (p = l);
                break;
              case 3:
                i = e[s + 1], o = e[s + 2], 128 == (192 & i) && 128 == (192 & o) && (l = (15 & c) << 12 | (63 & i) << 6 | 63 & o) > 2047 && (l < 55296 || l > 57343) && (p = l);
                break;
              case 4:
                i = e[s + 1], o = e[s + 2], a = e[s + 3], 128 == (192 & i) && 128 == (192 & o) && 128 == (192 & a) && (l = (15 & c) << 18 | (63 & i) << 12 | (63 & o) << 6 | 63 & a) > 65535 && l < 1114112 && (p = l);
            }
            null === p ? (p = 65533, h = 1) : p > 65535 && (p -= 65536, r.push(p >>> 10 & 1023 | 55296), p = 56320 | 1023 & p), r.push(p), s += h;
          }
          return function (e) {
            var t = e.length;
            if (t <= C) return String.fromCharCode.apply(String, e);
            var n = "",
              r = 0;
            for (; r < t;) n += String.fromCharCode.apply(String, e.slice(r, r += C));
            return n;
          }(r);
        }
        n.kMaxLength = s, o.TYPED_ARRAY_SUPPORT = function () {
          try {
            var e = new Uint8Array(1);
            return e.__proto__ = {
              __proto__: Uint8Array.prototype,
              foo: function () {
                return 42;
              }
            }, 42 === e.foo();
          } catch (e) {
            return !1;
          }
        }(), o.TYPED_ARRAY_SUPPORT || "undefined" == typeof console || "function" != typeof console.error || console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."), Object.defineProperty(o.prototype, "parent", {
          enumerable: !0,
          get: function () {
            if (o.isBuffer(this)) return this.buffer;
          }
        }), Object.defineProperty(o.prototype, "offset", {
          enumerable: !0,
          get: function () {
            if (o.isBuffer(this)) return this.byteOffset;
          }
        }), "undefined" != typeof Symbol && null != Symbol.species && o[Symbol.species] === o && Object.defineProperty(o, Symbol.species, {
          value: null,
          configurable: !0,
          enumerable: !1,
          writable: !1
        }), o.poolSize = 8192, o.from = function (e, t, n) {
          return a(e, t, n);
        }, o.prototype.__proto__ = Uint8Array.prototype, o.__proto__ = Uint8Array, o.alloc = function (e, t, n) {
          return function (e, t, n) {
            return l(e), e <= 0 ? i(e) : void 0 !== t ? "string" == typeof n ? i(e).fill(t, n) : i(e).fill(t) : i(e);
          }(e, t, n);
        }, o.allocUnsafe = function (e) {
          return c(e);
        }, o.allocUnsafeSlow = function (e) {
          return c(e);
        }, o.isBuffer = function (e) {
          return null != e && !0 === e._isBuffer && e !== o.prototype;
        }, o.compare = function (e, t) {
          if (U(e, Uint8Array) && (e = o.from(e, e.offset, e.byteLength)), U(t, Uint8Array) && (t = o.from(t, t.offset, t.byteLength)), !o.isBuffer(e) || !o.isBuffer(t)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
          if (e === t) return 0;
          for (var n = e.length, r = t.length, s = 0, i = Math.min(n, r); s < i; ++s) if (e[s] !== t[s]) {
            n = e[s], r = t[s];
            break;
          }
          return n < r ? -1 : r < n ? 1 : 0;
        }, o.isEncoding = function (e) {
          switch (String(e).toLowerCase()) {
            case "hex":
            case "utf8":
            case "utf-8":
            case "ascii":
            case "latin1":
            case "binary":
            case "base64":
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return !0;
            default:
              return !1;
          }
        }, o.concat = function (e, t) {
          if (!Array.isArray(e)) throw new TypeError('"list" argument must be an Array of Buffers');
          if (0 === e.length) return o.alloc(0);
          var n;
          if (void 0 === t) for (t = 0, n = 0; n < e.length; ++n) t += e[n].length;
          var r = o.allocUnsafe(t),
            s = 0;
          for (n = 0; n < e.length; ++n) {
            var i = e[n];
            if (U(i, Uint8Array) && (i = o.from(i)), !o.isBuffer(i)) throw new TypeError('"list" argument must be an Array of Buffers');
            i.copy(r, s), s += i.length;
          }
          return r;
        }, o.byteLength = u, o.prototype._isBuffer = !0, o.prototype.swap16 = function () {
          var e = this.length;
          if (e % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
          for (var t = 0; t < e; t += 2) f(this, t, t + 1);
          return this;
        }, o.prototype.swap32 = function () {
          var e = this.length;
          if (e % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
          for (var t = 0; t < e; t += 4) f(this, t, t + 3), f(this, t + 1, t + 2);
          return this;
        }, o.prototype.swap64 = function () {
          var e = this.length;
          if (e % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
          for (var t = 0; t < e; t += 8) f(this, t, t + 7), f(this, t + 1, t + 6), f(this, t + 2, t + 5), f(this, t + 3, t + 4);
          return this;
        }, o.prototype.toString = function () {
          var e = this.length;
          return 0 === e ? "" : 0 === arguments.length ? k(this, 0, e) : d.apply(this, arguments);
        }, o.prototype.toLocaleString = o.prototype.toString, o.prototype.equals = function (e) {
          if (!o.isBuffer(e)) throw new TypeError("Argument must be a Buffer");
          return this === e || 0 === o.compare(this, e);
        }, o.prototype.inspect = function () {
          var e = "",
            t = n.INSPECT_MAX_BYTES;
          return e = this.toString("hex", 0, t).replace(/(.{2})/g, "$1 ").trim(), this.length > t && (e += " ... "), "<Buffer " + e + ">";
        }, o.prototype.compare = function (e, t, n, r, s) {
          if (U(e, Uint8Array) && (e = o.from(e, e.offset, e.byteLength)), !o.isBuffer(e)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof e);
          if (void 0 === t && (t = 0), void 0 === n && (n = e ? e.length : 0), void 0 === r && (r = 0), void 0 === s && (s = this.length), t < 0 || n > e.length || r < 0 || s > this.length) throw new RangeError("out of range index");
          if (r >= s && t >= n) return 0;
          if (r >= s) return -1;
          if (t >= n) return 1;
          if (this === e) return 0;
          for (var i = (s >>>= 0) - (r >>>= 0), a = (n >>>= 0) - (t >>>= 0), l = Math.min(i, a), c = this.slice(r, s), p = e.slice(t, n), h = 0; h < l; ++h) if (c[h] !== p[h]) {
            i = c[h], a = p[h];
            break;
          }
          return i < a ? -1 : a < i ? 1 : 0;
        }, o.prototype.includes = function (e, t, n) {
          return -1 !== this.indexOf(e, t, n);
        }, o.prototype.indexOf = function (e, t, n) {
          return g(this, e, t, n, !0);
        }, o.prototype.lastIndexOf = function (e, t, n) {
          return g(this, e, t, n, !1);
        }, o.prototype.write = function (e, t, n, r) {
          if (void 0 === t) r = "utf8", n = this.length, t = 0;else if (void 0 === n && "string" == typeof t) r = t, n = this.length, t = 0;else {
            if (!isFinite(t)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
            t >>>= 0, isFinite(n) ? (n >>>= 0, void 0 === r && (r = "utf8")) : (r = n, n = void 0);
          }
          var s = this.length - t;
          if ((void 0 === n || n > s) && (n = s), e.length > 0 && (n < 0 || t < 0) || t > this.length) throw new RangeError("Attempt to write outside buffer bounds");
          r || (r = "utf8");
          for (var i = !1;;) switch (r) {
            case "hex":
              return b(this, e, t, n);
            case "utf8":
            case "utf-8":
              return y(this, e, t, n);
            case "ascii":
              return T(this, e, t, n);
            case "latin1":
            case "binary":
              return E(this, e, t, n);
            case "base64":
              return x(this, e, t, n);
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return w(this, e, t, n);
            default:
              if (i) throw new TypeError("Unknown encoding: " + r);
              r = ("" + r).toLowerCase(), i = !0;
          }
        }, o.prototype.toJSON = function () {
          return {
            type: "Buffer",
            data: Array.prototype.slice.call(this._arr || this, 0)
          };
        };
        var C = 4096;
        function S(e, t, n) {
          var r = "";
          n = Math.min(e.length, n);
          for (var s = t; s < n; ++s) r += String.fromCharCode(127 & e[s]);
          return r;
        }
        function M(e, t, n) {
          var r = "";
          n = Math.min(e.length, n);
          for (var s = t; s < n; ++s) r += String.fromCharCode(e[s]);
          return r;
        }
        function O(e, t, n) {
          var r = e.length;
          (!t || t < 0) && (t = 0), (!n || n < 0 || n > r) && (n = r);
          for (var s = "", i = t; i < n; ++i) s += D(e[i]);
          return s;
        }
        function $(e, t, n) {
          for (var r = e.slice(t, n), s = "", i = 0; i < r.length; i += 2) s += String.fromCharCode(r[i] + 256 * r[i + 1]);
          return s;
        }
        function L(e, t, n) {
          if (e % 1 != 0 || e < 0) throw new RangeError("offset is not uint");
          if (e + t > n) throw new RangeError("Trying to access beyond buffer length");
        }
        function B(e, t, n, r, s, i) {
          if (!o.isBuffer(e)) throw new TypeError('"buffer" argument must be a Buffer instance');
          if (t > s || t < i) throw new RangeError('"value" argument is out of bounds');
          if (n + r > e.length) throw new RangeError("Index out of range");
        }
        function R(e, t, n, r, s, i) {
          if (n + r > e.length) throw new RangeError("Index out of range");
          if (n < 0) throw new RangeError("Index out of range");
        }
        function N(e, t, n, s, i) {
          return t = +t, n >>>= 0, i || R(e, 0, n, 4), r.write(e, t, n, s, 23, 4), n + 4;
        }
        function v(e, t, n, s, i) {
          return t = +t, n >>>= 0, i || R(e, 0, n, 8), r.write(e, t, n, s, 52, 8), n + 8;
        }
        o.prototype.slice = function (e, t) {
          var n = this.length;
          (e = ~~e) < 0 ? (e += n) < 0 && (e = 0) : e > n && (e = n), (t = void 0 === t ? n : ~~t) < 0 ? (t += n) < 0 && (t = 0) : t > n && (t = n), t < e && (t = e);
          var r = this.subarray(e, t);
          return r.__proto__ = o.prototype, r;
        }, o.prototype.readUIntLE = function (e, t, n) {
          e >>>= 0, t >>>= 0, n || L(e, t, this.length);
          for (var r = this[e], s = 1, i = 0; ++i < t && (s *= 256);) r += this[e + i] * s;
          return r;
        }, o.prototype.readUIntBE = function (e, t, n) {
          e >>>= 0, t >>>= 0, n || L(e, t, this.length);
          for (var r = this[e + --t], s = 1; t > 0 && (s *= 256);) r += this[e + --t] * s;
          return r;
        }, o.prototype.readUInt8 = function (e, t) {
          return e >>>= 0, t || L(e, 1, this.length), this[e];
        }, o.prototype.readUInt16LE = function (e, t) {
          return e >>>= 0, t || L(e, 2, this.length), this[e] | this[e + 1] << 8;
        }, o.prototype.readUInt16BE = function (e, t) {
          return e >>>= 0, t || L(e, 2, this.length), this[e] << 8 | this[e + 1];
        }, o.prototype.readUInt32LE = function (e, t) {
          return e >>>= 0, t || L(e, 4, this.length), (this[e] | this[e + 1] << 8 | this[e + 2] << 16) + 16777216 * this[e + 3];
        }, o.prototype.readUInt32BE = function (e, t) {
          return e >>>= 0, t || L(e, 4, this.length), 16777216 * this[e] + (this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3]);
        }, o.prototype.readIntLE = function (e, t, n) {
          e >>>= 0, t >>>= 0, n || L(e, t, this.length);
          for (var r = this[e], s = 1, i = 0; ++i < t && (s *= 256);) r += this[e + i] * s;
          return r >= (s *= 128) && (r -= Math.pow(2, 8 * t)), r;
        }, o.prototype.readIntBE = function (e, t, n) {
          e >>>= 0, t >>>= 0, n || L(e, t, this.length);
          for (var r = t, s = 1, i = this[e + --r]; r > 0 && (s *= 256);) i += this[e + --r] * s;
          return i >= (s *= 128) && (i -= Math.pow(2, 8 * t)), i;
        }, o.prototype.readInt8 = function (e, t) {
          return e >>>= 0, t || L(e, 1, this.length), 128 & this[e] ? -1 * (255 - this[e] + 1) : this[e];
        }, o.prototype.readInt16LE = function (e, t) {
          e >>>= 0, t || L(e, 2, this.length);
          var n = this[e] | this[e + 1] << 8;
          return 32768 & n ? 4294901760 | n : n;
        }, o.prototype.readInt16BE = function (e, t) {
          e >>>= 0, t || L(e, 2, this.length);
          var n = this[e + 1] | this[e] << 8;
          return 32768 & n ? 4294901760 | n : n;
        }, o.prototype.readInt32LE = function (e, t) {
          return e >>>= 0, t || L(e, 4, this.length), this[e] | this[e + 1] << 8 | this[e + 2] << 16 | this[e + 3] << 24;
        }, o.prototype.readInt32BE = function (e, t) {
          return e >>>= 0, t || L(e, 4, this.length), this[e] << 24 | this[e + 1] << 16 | this[e + 2] << 8 | this[e + 3];
        }, o.prototype.readFloatLE = function (e, t) {
          return e >>>= 0, t || L(e, 4, this.length), r.read(this, e, !0, 23, 4);
        }, o.prototype.readFloatBE = function (e, t) {
          return e >>>= 0, t || L(e, 4, this.length), r.read(this, e, !1, 23, 4);
        }, o.prototype.readDoubleLE = function (e, t) {
          return e >>>= 0, t || L(e, 8, this.length), r.read(this, e, !0, 52, 8);
        }, o.prototype.readDoubleBE = function (e, t) {
          return e >>>= 0, t || L(e, 8, this.length), r.read(this, e, !1, 52, 8);
        }, o.prototype.writeUIntLE = function (e, t, n, r) {
          (e = +e, t >>>= 0, n >>>= 0, r) || B(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
          var s = 1,
            i = 0;
          for (this[t] = 255 & e; ++i < n && (s *= 256);) this[t + i] = e / s & 255;
          return t + n;
        }, o.prototype.writeUIntBE = function (e, t, n, r) {
          (e = +e, t >>>= 0, n >>>= 0, r) || B(this, e, t, n, Math.pow(2, 8 * n) - 1, 0);
          var s = n - 1,
            i = 1;
          for (this[t + s] = 255 & e; --s >= 0 && (i *= 256);) this[t + s] = e / i & 255;
          return t + n;
        }, o.prototype.writeUInt8 = function (e, t, n) {
          return e = +e, t >>>= 0, n || B(this, e, t, 1, 255, 0), this[t] = 255 & e, t + 1;
        }, o.prototype.writeUInt16LE = function (e, t, n) {
          return e = +e, t >>>= 0, n || B(this, e, t, 2, 65535, 0), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
        }, o.prototype.writeUInt16BE = function (e, t, n) {
          return e = +e, t >>>= 0, n || B(this, e, t, 2, 65535, 0), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
        }, o.prototype.writeUInt32LE = function (e, t, n) {
          return e = +e, t >>>= 0, n || B(this, e, t, 4, 4294967295, 0), this[t + 3] = e >>> 24, this[t + 2] = e >>> 16, this[t + 1] = e >>> 8, this[t] = 255 & e, t + 4;
        }, o.prototype.writeUInt32BE = function (e, t, n) {
          return e = +e, t >>>= 0, n || B(this, e, t, 4, 4294967295, 0), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
        }, o.prototype.writeIntLE = function (e, t, n, r) {
          if (e = +e, t >>>= 0, !r) {
            var s = Math.pow(2, 8 * n - 1);
            B(this, e, t, n, s - 1, -s);
          }
          var i = 0,
            o = 1,
            a = 0;
          for (this[t] = 255 & e; ++i < n && (o *= 256);) e < 0 && 0 === a && 0 !== this[t + i - 1] && (a = 1), this[t + i] = (e / o >> 0) - a & 255;
          return t + n;
        }, o.prototype.writeIntBE = function (e, t, n, r) {
          if (e = +e, t >>>= 0, !r) {
            var s = Math.pow(2, 8 * n - 1);
            B(this, e, t, n, s - 1, -s);
          }
          var i = n - 1,
            o = 1,
            a = 0;
          for (this[t + i] = 255 & e; --i >= 0 && (o *= 256);) e < 0 && 0 === a && 0 !== this[t + i + 1] && (a = 1), this[t + i] = (e / o >> 0) - a & 255;
          return t + n;
        }, o.prototype.writeInt8 = function (e, t, n) {
          return e = +e, t >>>= 0, n || B(this, e, t, 1, 127, -128), e < 0 && (e = 255 + e + 1), this[t] = 255 & e, t + 1;
        }, o.prototype.writeInt16LE = function (e, t, n) {
          return e = +e, t >>>= 0, n || B(this, e, t, 2, 32767, -32768), this[t] = 255 & e, this[t + 1] = e >>> 8, t + 2;
        }, o.prototype.writeInt16BE = function (e, t, n) {
          return e = +e, t >>>= 0, n || B(this, e, t, 2, 32767, -32768), this[t] = e >>> 8, this[t + 1] = 255 & e, t + 2;
        }, o.prototype.writeInt32LE = function (e, t, n) {
          return e = +e, t >>>= 0, n || B(this, e, t, 4, 2147483647, -2147483648), this[t] = 255 & e, this[t + 1] = e >>> 8, this[t + 2] = e >>> 16, this[t + 3] = e >>> 24, t + 4;
        }, o.prototype.writeInt32BE = function (e, t, n) {
          return e = +e, t >>>= 0, n || B(this, e, t, 4, 2147483647, -2147483648), e < 0 && (e = 4294967295 + e + 1), this[t] = e >>> 24, this[t + 1] = e >>> 16, this[t + 2] = e >>> 8, this[t + 3] = 255 & e, t + 4;
        }, o.prototype.writeFloatLE = function (e, t, n) {
          return N(this, e, t, !0, n);
        }, o.prototype.writeFloatBE = function (e, t, n) {
          return N(this, e, t, !1, n);
        }, o.prototype.writeDoubleLE = function (e, t, n) {
          return v(this, e, t, !0, n);
        }, o.prototype.writeDoubleBE = function (e, t, n) {
          return v(this, e, t, !1, n);
        }, o.prototype.copy = function (e, t, n, r) {
          if (!o.isBuffer(e)) throw new TypeError("argument should be a Buffer");
          if (n || (n = 0), r || 0 === r || (r = this.length), t >= e.length && (t = e.length), t || (t = 0), r > 0 && r < n && (r = n), r === n) return 0;
          if (0 === e.length || 0 === this.length) return 0;
          if (t < 0) throw new RangeError("targetStart out of bounds");
          if (n < 0 || n >= this.length) throw new RangeError("Index out of range");
          if (r < 0) throw new RangeError("sourceEnd out of bounds");
          r > this.length && (r = this.length), e.length - t < r - n && (r = e.length - t + n);
          var s = r - n;
          if (this === e && "function" == typeof Uint8Array.prototype.copyWithin) this.copyWithin(t, n, r);else if (this === e && n < t && t < r) for (var i = s - 1; i >= 0; --i) e[i + t] = this[i + n];else Uint8Array.prototype.set.call(e, this.subarray(n, r), t);
          return s;
        }, o.prototype.fill = function (e, t, n, r) {
          if ("string" == typeof e) {
            if ("string" == typeof t ? (r = t, t = 0, n = this.length) : "string" == typeof n && (r = n, n = this.length), void 0 !== r && "string" != typeof r) throw new TypeError("encoding must be a string");
            if ("string" == typeof r && !o.isEncoding(r)) throw new TypeError("Unknown encoding: " + r);
            if (1 === e.length) {
              var s = e.charCodeAt(0);
              ("utf8" === r && s < 128 || "latin1" === r) && (e = s);
            }
          } else "number" == typeof e && (e &= 255);
          if (t < 0 || this.length < t || this.length < n) throw new RangeError("Out of range index");
          if (n <= t) return this;
          var i;
          if (t >>>= 0, n = void 0 === n ? this.length : n >>> 0, e || (e = 0), "number" == typeof e) for (i = t; i < n; ++i) this[i] = e;else {
            var a = o.isBuffer(e) ? e : o.from(e, r),
              l = a.length;
            if (0 === l) throw new TypeError('The value "' + e + '" is invalid for argument "value"');
            for (i = 0; i < n - t; ++i) this[i + t] = a[i % l];
          }
          return this;
        };
        var _ = /[^+/0-9A-Za-z-_]/g;
        function D(e) {
          return e < 16 ? "0" + e.toString(16) : e.toString(16);
        }
        function P(e, t) {
          var n;
          t = t || 1 / 0;
          for (var r = e.length, s = null, i = [], o = 0; o < r; ++o) {
            if ((n = e.charCodeAt(o)) > 55295 && n < 57344) {
              if (!s) {
                if (n > 56319) {
                  (t -= 3) > -1 && i.push(239, 191, 189);
                  continue;
                }
                if (o + 1 === r) {
                  (t -= 3) > -1 && i.push(239, 191, 189);
                  continue;
                }
                s = n;
                continue;
              }
              if (n < 56320) {
                (t -= 3) > -1 && i.push(239, 191, 189), s = n;
                continue;
              }
              n = 65536 + (s - 55296 << 10 | n - 56320);
            } else s && (t -= 3) > -1 && i.push(239, 191, 189);
            if (s = null, n < 128) {
              if ((t -= 1) < 0) break;
              i.push(n);
            } else if (n < 2048) {
              if ((t -= 2) < 0) break;
              i.push(n >> 6 | 192, 63 & n | 128);
            } else if (n < 65536) {
              if ((t -= 3) < 0) break;
              i.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128);
            } else {
              if (!(n < 1114112)) throw new Error("Invalid code point");
              if ((t -= 4) < 0) break;
              i.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128);
            }
          }
          return i;
        }
        function I(e) {
          return t.toByteArray(function (e) {
            if ((e = (e = e.split("=")[0]).trim().replace(_, "")).length < 2) return "";
            for (; e.length % 4 != 0;) e += "=";
            return e;
          }(e));
        }
        function H(e, t, n, r) {
          for (var s = 0; s < r && !(s + n >= t.length || s >= e.length); ++s) t[s + n] = e[s];
          return s;
        }
        function U(e, t) {
          return e instanceof t || null != e && null != e.constructor && null != e.constructor.name && e.constructor.name === t.name;
        }
        function F(e) {
          return e != e;
        }
      }).call(this);
    }).call(this, e("buffer").Buffer);
  }, {
    "base64-js": 1,
    buffer: 2,
    ieee754: 3
  }],
  3: [function (e, t, n) {
    /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
    n.read = function (e, t, n, r, s) {
      var i,
        o,
        a = 8 * s - r - 1,
        l = (1 << a) - 1,
        c = l >> 1,
        p = -7,
        h = n ? s - 1 : 0,
        u = n ? -1 : 1,
        d = e[t + h];
      for (h += u, i = d & (1 << -p) - 1, d >>= -p, p += a; p > 0; i = 256 * i + e[t + h], h += u, p -= 8);
      for (o = i & (1 << -p) - 1, i >>= -p, p += r; p > 0; o = 256 * o + e[t + h], h += u, p -= 8);
      if (0 === i) i = 1 - c;else {
        if (i === l) return o ? NaN : 1 / 0 * (d ? -1 : 1);
        o += Math.pow(2, r), i -= c;
      }
      return (d ? -1 : 1) * o * Math.pow(2, i - r);
    }, n.write = function (e, t, n, r, s, i) {
      var o,
        a,
        l,
        c = 8 * i - s - 1,
        p = (1 << c) - 1,
        h = p >> 1,
        u = 23 === s ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
        d = r ? 0 : i - 1,
        f = r ? 1 : -1,
        g = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
      for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, o = p) : (o = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), (t += o + h >= 1 ? u / l : u * Math.pow(2, 1 - h)) * l >= 2 && (o++, l /= 2), o + h >= p ? (a = 0, o = p) : o + h >= 1 ? (a = (t * l - 1) * Math.pow(2, s), o += h) : (a = t * Math.pow(2, h - 1) * Math.pow(2, s), o = 0)); s >= 8; e[n + d] = 255 & a, d += f, a /= 256, s -= 8);
      for (o = o << s | a, c += s; c > 0; e[n + d] = 255 & o, d += f, o /= 256, c -= 8);
      e[n + d - f] |= 128 * g;
    };
  }, {}],
  4: [function (e, t, n) {
    t.exports = function (t) {
      const {
          Buffer: n
        } = e("buffer"),
        r = "api.js: ",
        s = this,
        i = e("../apg-lib/node-exports"),
        o = e("../apg-conv-api/converter"),
        a = e("./scanner"),
        l = new (e("./parser"))(),
        {
          attributes: c,
          showAttributes: p,
          showAttributeErrors: h,
          showRuleDependencies: u
        } = e("./attributes"),
        d = e("./show-rules"),
        f = function (e, t, n) {
          const r = `<span class="${i.style.CLASS_CTRLCHAR}">`,
            s = "</span>",
            o = `<span class="${i.style.CLASS_NOMATCH}">`,
            a = "</span>";
          let l,
            c = "";
          for (; Array.isArray(e) && 0 !== e.length;) {
            if ("number" != typeof t) throw new Error("abnfToHtml: beg must be type number");
            if (t >= e.length) break;
            l = "number" != typeof n || t + n >= e.length ? e.length : t + n;
            let p = 0;
            for (let n = t; n < l; n += 1) {
              const t = e[n];
              if (t >= 32 && t <= 126) switch (1 === p ? (c += s, p = 0) : 2 === p && (c += a, p = 0), t) {
                case 32:
                  c += "&nbsp;";
                  break;
                case 60:
                  c += "&lt;";
                  break;
                case 62:
                  c += "&gt;";
                  break;
                case 38:
                  c += "&amp;";
                  break;
                case 34:
                  c += "&quot;";
                  break;
                case 39:
                  c += "&#039;";
                  break;
                case 92:
                  c += "&#092;";
                  break;
                default:
                  c += String.fromCharCode(t);
              } else 9 === t || 10 === t || 13 === t ? (0 === p ? (c += r, p = 1) : 2 === p && (c += a + r, p = 1), 9 === t && (c += "TAB"), 10 === t && (c += "LF"), 13 === t && (c += "CR")) : (0 === p ? (c += o, p = 2) : 1 === p && (c += s + o, p = 2), c += `\\x${i.utils.charToHex(t)}`);
            }
            2 === p && (c += a), 1 === p && (c += s);
            break;
          }
          return c;
        },
        g = function (e, t, n) {
          let r = "";
          for (let s = t; s < t + n; s += 1) {
            const t = e[s];
            if (t >= 32 && t <= 126) r += String.fromCharCode(t);else switch (t) {
              case 9:
                r += "\\t";
                break;
              case 10:
                r += "\\n";
                break;
              case 13:
                r += "\\r";
                break;
              default:
                r += "\\unknown";
            }
          }
          return r;
        };
      let m,
        b = !1,
        y = !1,
        T = !1,
        E = !1,
        x = 0;
      if (this.errors = [], n.isBuffer(t)) this.chars = o.decode("BINARY", t);else if (Array.isArray(t)) this.chars = t.slice();else {
        if ("string" != typeof t) throw new Error(`${r}input source is not a string, byte Buffer or character array`);
        this.chars = o.decode("STRING", t);
      }
      this.sabnf = o.encode("STRING", this.chars), this.scan = function (e, t) {
        this.lines = a(this.chars, this.errors, e, t), b = !0;
      }, this.parse = function (e, t, n) {
        if (!b) throw new Error(`${r}grammar not scanned`);
        l.syntax(this.chars, this.lines, this.errors, e, t, n), y = !0;
      }, this.translate = function () {
        if (!y) throw new Error(`${r}grammar not scanned and parsed`);
        const e = l.semantic(this.chars, this.lines, this.errors);
        0 === this.errors.length && (this.rules = e.rules, this.udts = e.udts, m = e.lineMap, T = !0);
      }, this.attributes = function () {
        if (!T) throw new Error(`${r}grammar not scanned, parsed and translated`);
        return x = c(this.rules, this.udts, m, this.errors), E = !0, x;
      }, this.generate = function (e) {
        if (this.lines = a(this.chars, this.errors, e), this.errors.length) return;
        if (l.syntax(this.chars, this.lines, this.errors, e), this.errors.length) return;
        const t = l.semantic(this.chars, this.lines, this.errors);
        this.errors.length || (this.rules = t.rules, this.udts = t.udts, m = t.lineMap, x = c(this.rules, this.udts, m, this.errors), E = !0);
      }, this.displayRules = function () {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "index";
        if (!T) throw new Error(`${r}grammar not scanned, parsed and translated`);
        return d(this.rules, this.udts, e);
      }, this.displayRuleDependencies = function () {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "index";
        if (!E) throw new Error(`${r}no attributes - must be preceeded by call to attributes()`);
        return u(e);
      }, this.displayAttributes = function () {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "index";
        if (!E) throw new Error(`${r}no attributes - must be preceeded by call to attributes()`);
        return x && h(e), p(e);
      }, this.displayAttributeErrors = function () {
        if (!E) throw new Error(`${r}no attributes - must be preceeded by call to attributes()`);
        return h();
      }, this.toSource = function (e, t) {
        if (!E) throw new Error(`${r}can't generate parser source - must be preceeded by call to attributes()`);
        if (x) throw new Error(`${r}can't generate parser source - attributes have ${x} errors`);
        return l.generateSource(this.chars, this.lines, this.rules, this.udts, e, t);
      }, this.toObject = function () {
        if (!E) throw new Error(`${r}can't generate parser source - must be preceeded by call to attributes()`);
        if (x) throw new Error(`${r}can't generate parser source - attributes have ${x} errors`);
        return l.generateObject(this.sabnf, this.rules, this.udts);
      }, this.errorsToAscii = function () {
        return function (e, t, n) {
          let r, s, i, o;
          return r = "", e.forEach(e => {
            s = t[e.line], r += `${s.lineNo}: `, r += `${s.beginChar}: `, r += e.char - s.beginChar + ": ", i = s.beginChar, o = e.char - s.beginChar, r += g(n, i, o), r += " >> ", i = e.char, o = s.beginChar + s.length - e.char, r += g(n, i, o), r += "\n", r += `${s.lineNo}: `, r += `${s.beginChar}: `, r += e.char - s.beginChar + ": ", r += "error: ", r += e.msg, r += "\n";
          }), r;
        }(this.errors, this.lines, this.chars);
      }, this.errorsToHtml = function (e) {
        return function (e, t, n, r) {
          const [s] = i;
          let o = "";
          const a = `<span class="${s.CLASS_NOMATCH}">&raquo;</span>`;
          return o += `<p><table class="${s.CLASS_GRAMMAR}">\n`, r && "string" == typeof r && (o += `<caption>${r}</caption>\n`), o += "<tr><th>line<br>no.</th><th>line<br>offset</th><th>error<br>offset</th><th><br>text</th></tr>\n", e.forEach(e => {
            let r,
              s,
              l,
              c,
              p,
              h = "",
              u = "";
            0 === t.length ? (p = a, s = 0) : (r = t[e.line], l = r.beginChar, e.char > l && (h = f(n, l, e.char - l)), l = e.char, c = r.beginChar + r.length, l < c && (u = f(n, l, c - l)), p = h + a + u, s = e.char - r.beginChar, o += "<tr>", o += `<td>${e.line}</td><td>${r.beginChar}</td><td>${s}</td><td>${p}</td>`, o += "</tr>\n", o += "<tr>", o += `<td colspan="3"></td><td>&uarr;:&nbsp;${i.utils.stringToAsciiHtml(e.msg)}</td>`, o += "</tr>\n");
          }), o += "</table></p>\n", o;
        }(this.errors, this.lines, this.chars, e);
      }, this.linesToAscii = function () {
        return function (e) {
          let t = "Annotated Input Grammar";
          return e.forEach(e => {
            t += "\n", t += `line no: ${e.lineNo}`, t += ` : char index: ${e.beginChar}`, t += ` : length: ${e.length}`, t += ` : abnf: ${g(s.chars, e.beginChar, e.length)}`;
          }), t += "\n", t;
        }(this.lines);
      }, this.linesToHtml = function () {
        return function (e) {
          let t = "";
          return t += `<table class="${i.style.CLASS_GRAMMAR}">\n`, t += "<caption>Annotated Input Grammar</caption>\n", t += "<tr>", t += "<th>line<br>no.</th><th>first<br>char</th><th><br>length</th><th><br>text</th>", t += "</tr>\n", e.forEach(e => {
            t += "<tr>", t += `<td>${e.lineNo}`, t += `</td><td>${e.beginChar}`, t += `</td><td>${e.length}`, t += `</td><td>${f(s.chars, e.beginChar, e.length)}`, t += "</td>", t += "</tr>\n";
          }), t += "</table>\n", t;
        }(this.lines);
      };
    };
  }, {
    "../apg-conv-api/converter": 17,
    "../apg-lib/node-exports": 24,
    "./attributes": 5,
    "./parser": 6,
    "./scanner": 12,
    "./show-rules": 14,
    buffer: 2
  }],
  5: [function (e, t, n) {
    t.exports = function () {
      const t = e("../apg-lib/identifiers"),
        {
          ruleAttributes: n,
          showAttributes: r,
          showAttributeErrors: s
        } = e("./rule-attributes"),
        {
          ruleDependencies: i,
          showRuleDependencies: o
        } = e("./rule-dependencies");
      class a {
        constructor(e, t) {
          this.rules = e, this.udts = t, this.ruleCount = e.length, this.udtCount = t.length, this.startRule = 0, this.dependenciesComplete = !1, this.attributesComplete = !1, this.isMutuallyRecursive = !1, this.ruleIndexes = this.indexArray(this.ruleCount), this.ruleAlphaIndexes = this.indexArray(this.ruleCount), this.ruleTypeIndexes = this.indexArray(this.ruleCount), this.udtIndexes = this.indexArray(this.udtCount), this.udtAlphaIndexes = this.indexArray(this.udtCount), this.attrsErrorCount = 0, this.attrs = [], this.attrsErrors = [], this.attrsWorking = [], this.ruleDeps = [];
          for (let t = 0; t < this.ruleCount; t += 1) this.attrs.push(this.attrGen(this.rules[t])), this.attrsWorking.push(this.attrGen(this.rules[t])), this.ruleDeps.push(this.rdGen(e[t], this.ruleCount, this.udtCount));
          this.compRulesAlpha = this.compRulesAlpha.bind(this), this.compUdtsAlpha = this.compUdtsAlpha.bind(this), this.compRulesType = this.compRulesType.bind(this), this.compRulesGroup = this.compRulesGroup.bind(this);
        }
        attrGen(e) {
          return {
            left: !1,
            nested: !1,
            right: !1,
            empty: !1,
            finite: !1,
            cyclic: !1,
            leaf: !1,
            isOpen: !1,
            isComplete: !1,
            rule: e
          };
        }
        attrInit(e) {
          e.left = !1, e.nested = !1, e.right = !1, e.empty = !1, e.finite = !1, e.cyclic = !1, e.leaf = !1, e.isOpen = !1, e.isComplete = !1;
        }
        attrCopy(e, t) {
          e.left = t.left, e.nested = t.nested, e.right = t.right, e.empty = t.empty, e.finite = t.finite, e.cyclic = t.cyclic, e.leaf = t.leaf, e.isOpen = t.isOpen, e.isComplete = t.isComplete, e.rule = t.rule;
        }
        rdGen(e, n, r) {
          return {
            rule: e,
            recursiveType: t.ATTR_N,
            groupNumber: -1,
            refersTo: this.falseArray(n),
            refersToUdt: this.falseArray(r),
            referencedBy: this.falseArray(n)
          };
        }
        typeToString(e) {
          switch (e) {
            case t.ATTR_N:
              return " N";
            case t.ATTR_R:
              return " R";
            case t.ATTR_MR:
              return "MR";
            default:
              return "UNKNOWN";
          }
        }
        falseArray(e) {
          const t = [];
          if (e > 0) for (let n = 0; n < e; n += 1) t.push(!1);
          return t;
        }
        falsifyArray(e) {
          for (let t = 0; t < e.length; t += 1) e[t] = !1;
        }
        indexArray(e) {
          const t = [];
          if (e > 0) for (let n = 0; n < e; n += 1) t.push(n);
          return t;
        }
        compRulesAlpha(e, t) {
          return this.rules[e].lower < this.rules[t].lower ? -1 : this.rules[e].lower > this.rules[t].lower ? 1 : 0;
        }
        compUdtsAlpha(e, t) {
          return this.udts[e].lower < this.udts[t].lower ? -1 : this.udts[e].lower > this.udts[t].lower ? 1 : 0;
        }
        compRulesType(e, t) {
          return this.ruleDeps[e].recursiveType < this.ruleDeps[t].recursiveType ? -1 : this.ruleDeps[e].recursiveType > this.ruleDeps[t].recursiveType ? 1 : 0;
        }
        compRulesGroup(e, n) {
          if (this.ruleDeps[e].recursiveType === t.ATTR_MR && this.ruleDeps[n].recursiveType === t.ATTR_MR) {
            if (this.ruleDeps[e].groupNumber < this.ruleDeps[n].groupNumber) return -1;
            if (this.ruleDeps[e].groupNumber > this.ruleDeps[n].groupNumber) return 1;
          }
          return 0;
        }
      }
      return {
        attributes: function () {
          let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
          let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
          let s = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
          const o = new a(e, t);
          return i(o), n(o), o.attrsErrorCount && s.push({
            line: 0,
            char: 0,
            msg: `${o.attrsErrorCount} attribute errors`
          }), o.attrsErrorCount;
        },
        showAttributes: r,
        showAttributeErrors: s,
        showRuleDependencies: o
      };
    }();
  }, {
    "../apg-lib/identifiers": 23,
    "./rule-attributes": 7,
    "./rule-dependencies": 8
  }],
  6: [function (e, t, n) {
    t.exports = function () {
      const t = e("../apg-lib/node-exports"),
        n = t.ids,
        r = new (e("./syntax-callbacks"))(),
        s = new (e("./semantic-callbacks"))(),
        i = new (e("./sabnf-grammar"))(),
        o = new t.parser();
      o.ast = new t.ast(), o.callbacks = r.callbacks, o.ast.callbacks = s.callbacks;
      const a = function (e, t, n) {
          if (t < 0 || t >= n) return -1;
          for (let n = 0; n < e.length; n += 1) if (t >= e[n].beginChar && t < e[n].beginChar + e[n].length) return n;
          return -1;
        },
        l = function (e, t) {
          let n = -1;
          if (t < e.length) for (let r = t; r < e.length; r += 1) if (null !== e[r]) {
            n = e[r];
            break;
          }
          return n;
        };
      this.syntax = function (e, t, n, r, s, l) {
        if (l) {
          if ("traceObject" !== l.traceObject) throw new TypeError("parser: trace argument is not a trace object");
          o.trace = l;
        }
        const c = {};
        c.errors = n, c.strict = !!r, c.lite = !!s, c.lines = t, c.findLine = a, c.charsLength = e.length, c.ruleCount = 0;
        o.parse(i, "file", e, c).success || n.push({
          line: 0,
          char: 0,
          msg: "syntax analysis of input grammar failed"
        });
      }, this.semantic = function (e, t, r) {
        const s = {};
        return s.errors = r, s.lines = t, s.findLine = a, s.charsLength = e.length, o.ast.translate(s), r.length ? null : (s.rules.forEach(e => {
          const t = [],
            r = [];
          let s = 0;
          e.opcodes.forEach(e => {
            e.type === n.ALT && 1 === e.children.length || e.type === n.CAT && 1 === e.children.length || e.type === n.REP && 1 === e.min && 1 === e.max ? r.push(null) : (r.push(s), t.push(e), s += 1);
          }), r.push(s), t.forEach(e => {
            if (e.type === n.ALT || e.type === n.CAT) for (let t = 0; t < e.children.length; t += 1) e.children[t] = l(r, e.children[t]);
          }), e.opcodes = t;
        }), {
          rules: s.rules,
          udts: s.udts,
          lineMap: s.rulesLineMap
        });
      }, this.generateSource = function (e, t, r, s, i, o) {
        let a,
          l,
          c,
          p = "",
          h = 0,
          u = 1 / 0,
          d = 0;
        const f = [],
          g = [];
        let m,
          b = 0,
          y = 0,
          T = 0,
          E = 0,
          x = 0,
          w = 0,
          A = 0,
          k = 0,
          C = 0,
          S = 0,
          M = 0,
          O = 0,
          $ = 0,
          L = 0,
          B = 0;
        return r.forEach(e => {
          f.push(e.lower), h += e.opcodes.length, e.opcodes.forEach(e => {
            switch (e.type) {
              case n.ALT:
                b += 1;
                break;
              case n.CAT:
                y += 1;
                break;
              case n.RNM:
                T += 1;
                break;
              case n.UDT:
                E += 1;
                break;
              case n.REP:
                x += 1;
                break;
              case n.AND:
                w += 1;
                break;
              case n.NOT:
                A += 1;
                break;
              case n.BKA:
                O += 1;
                break;
              case n.BKN:
                $ += 1;
                break;
              case n.BKR:
                M += 1;
                break;
              case n.ABG:
                L += 1;
                break;
              case n.AEN:
                B += 1;
                break;
              case n.TLS:
                for (k += 1, a = 0; a < e.string.length; a += 1) e.string[a] < u && (u = e.string[a]), e.string[a] > d && (d = e.string[a]);
                break;
              case n.TBS:
                for (C += 1, a = 0; a < e.string.length; a += 1) e.string[a] < u && (u = e.string[a]), e.string[a] > d && (d = e.string[a]);
                break;
              case n.TRG:
                S += 1, e.min < u && (u = e.min), e.max > d && (d = e.max);
                break;
              default:
                throw new Error("generateSource: unrecognized opcode");
            }
          });
        }), f.sort(), s.length > 0 && (s.forEach(e => {
          g.push(e.lower);
        }), g.sort()), p += "// copyright: Copyright (c) 2023 Lowell D. Thomas, all rights reserved<br>\n", p += "//   license: BSD-2-Clause (https://opensource.org/licenses/BSD-2-Clause)<br>\n", p += "//\n", p += "// Generated by apg-js, Version 4.3.0 [apg-js](https://github.com/ldthomas/apg-js)\n", p += o && "string" == typeof o ? `const ${o} = function grammar(){\n` : i ? "export default function grammar(){\n" : "module.exports = function grammar(){\n", p += "  // ```\n", p += "  // SUMMARY\n", p += `  //      rules = ${r.length}\n`, p += `  //       udts = ${s.length}\n`, p += `  //    opcodes = ${h}\n`, p += "  //        ---   ABNF original opcodes\n", p += `  //        ALT = ${b}\n`, p += `  //        CAT = ${y}\n`, p += `  //        REP = ${x}\n`, p += `  //        RNM = ${T}\n`, p += `  //        TLS = ${k}\n`, p += `  //        TBS = ${C}\n`, p += `  //        TRG = ${S}\n`, p += "  //        ---   SABNF superset opcodes\n", p += `  //        UDT = ${E}\n`, p += `  //        AND = ${w}\n`, p += `  //        NOT = ${A}\n`, i || (p += `  //        BKA = ${O}\n`, p += `  //        BKN = ${$}\n`, p += `  //        BKR = ${M}\n`, p += `  //        ABG = ${L}\n`, p += `  //        AEN = ${B}\n`), p += "  // characters = [", p += k + C + S === 0 ? " none defined ]" : `${u} - ${d}]`, E > 0 && (p += " + user defined"), p += "\n", p += "  // ```\n", i || (p += "  /* OBJECT IDENTIFIER (for internal parser use) */\n", p += "  this.grammarObject = 'grammarObject';\n"), p += "\n", p += "  /* RULES */\n", p += "  this.rules = [];\n", r.forEach((e, t) => {
          let n = "  this.rules[";
          n += t, n += "] = {name: '", n += e.name, n += "', lower: '", n += e.lower, n += "', index: ", n += e.index, n += ", isBkr: ", n += e.isBkr, n += "};\n", p += n;
        }), p += "\n", p += "  /* UDTS */\n", p += "  this.udts = [];\n", s.length > 0 && s.forEach((e, t) => {
          let n = "  this.udts[";
          n += t, n += "] = {name: '", n += e.name, n += "', lower: '", n += e.lower, n += "', index: ", n += e.index, n += ", empty: ", n += e.empty, n += ", isBkr: ", n += e.isBkr, n += "};\n", p += n;
        }), p += "\n", p += "  /* OPCODES */\n", r.forEach((e, t) => {
          t > 0 && (p += "\n"), p += `  /* ${e.name} */\n`, p += `  this.rules[${t}].opcodes = [];\n`, e.opcodes.forEach((e, i) => {
            let o;
            switch (e.type) {
              case n.ALT:
                p += `  this.rules[${t}].opcodes[${i}] = {type: ${e.type}, children: [${e.children.toString()}]};// ALT\n`;
                break;
              case n.CAT:
                p += `  this.rules[${t}].opcodes[${i}] = {type: ${e.type}, children: [${e.children.toString()}]};// CAT\n`;
                break;
              case n.RNM:
                p += `  this.rules[${t}].opcodes[${i}] = {type: ${e.type}, index: ${e.index}};// RNM(${r[e.index].name})\n`;
                break;
              case n.BKR:
                e.index >= r.length ? (l = s[e.index - r.length].name, c = s[e.index - r.length].lower) : (l = r[e.index].name, c = r[e.index].lower), o = "%i", e.bkrCase === n.BKR_MODE_CS && (o = "%s"), e.bkrMode === n.BKR_MODE_UM ? o += "%u" : o += "%p", l = o + l, p += `  this.rules[${t}].opcodes[${i}] = {type: ${e.type}, index: ${e.index}, lower: '${c}', bkrCase: ${e.bkrCase}, bkrMode: ${e.bkrMode}};// BKR(\\${l})\n`;
                break;
              case n.UDT:
                p += `  this.rules[${t}].opcodes[${i}] = {type: ${e.type}, empty: ${e.empty}, index: ${e.index}};// UDT(${s[e.index].name})\n`;
                break;
              case n.REP:
                p += `  this.rules[${t}].opcodes[${i}] = {type: ${e.type}, min: ${e.min}, max: ${e.max}};// REP\n`;
                break;
              case n.AND:
                p += `  this.rules[${t}].opcodes[${i}] = {type: ${e.type}};// AND\n`;
                break;
              case n.NOT:
                p += `  this.rules[${t}].opcodes[${i}] = {type: ${e.type}};// NOT\n`;
                break;
              case n.ABG:
                p += `  this.rules[${t}].opcodes[${i}] = {type: ${e.type}};// ABG(%^)\n`;
                break;
              case n.AEN:
                p += `  this.rules[${t}].opcodes[${i}] = {type: ${e.type}};// AEN(%$)\n`;
                break;
              case n.BKA:
                p += `  this.rules[${t}].opcodes[${i}] = {type: ${e.type}};// BKA\n`;
                break;
              case n.BKN:
                p += `  this.rules[${t}].opcodes[${i}] = {type: ${e.type}};// BKN\n`;
                break;
              case n.TLS:
                p += `  this.rules[${t}].opcodes[${i}] = {type: ${e.type}, string: [${e.string.toString()}]};// TLS\n`;
                break;
              case n.TBS:
                p += `  this.rules[${t}].opcodes[${i}] = {type: ${e.type}, string: [${e.string.toString()}]};// TBS\n`;
                break;
              case n.TRG:
                p += `  this.rules[${t}].opcodes[${i}] = {type: ${e.type}, min: ${e.min}, max: ${e.max}};// TRG\n`;
                break;
              default:
                throw new Error("parser.js: ~143: unrecognized opcode");
            }
          });
        }), p += "\n", p += "  // The `toString()` function will display the original grammar file(s) that produced these opcodes.\n", p += "  this.toString = function toString(){\n", p += '    let str = "";\n', t.forEach(t => {
          const n = t.beginChar + t.length;
          m = "", p += '    str += "';
          for (let r = t.beginChar; r < n; r += 1) {
            switch (e[r]) {
              case 9:
                m = " ";
                break;
              case 10:
                m = "\\n";
                break;
              case 13:
                m = "\\r";
                break;
              case 34:
                m = '\\"';
                break;
              case 92:
                m = "\\\\";
                break;
              default:
                m = String.fromCharCode(e[r]);
            }
            p += m;
          }
          p += '";\n';
        }), p += "    return str;\n", p += "  }\n", p += "}\n", p;
      }, this.generateObject = function (e, t, n) {
        const r = {},
          s = [],
          i = [],
          o = e.slice(0);
        return r.grammarObject = "grammarObject", t.forEach(e => {
          s.push(e.lower);
        }), s.sort(), n.length > 0 && (n.forEach(e => {
          i.push(e.lower);
        }), i.sort()), r.callbacks = [], s.forEach(e => {
          r.callbacks[e] = !1;
        }), n.length > 0 && i.forEach(e => {
          r.callbacks[e] = !1;
        }), r.rules = t, r.udts = n, r.toString = function () {
          return o;
        }, r;
      };
    };
  }, {
    "../apg-lib/node-exports": 24,
    "./sabnf-grammar": 9,
    "./semantic-callbacks": 13,
    "./syntax-callbacks": 15
  }],
  7: [function (e, t, n) {
    t.exports = function () {
      const t = e("../apg-lib/identifiers");
      let n = null;
      function r(e) {
        return !(e.left || e.nested || e.right || e.cyclic) && e.empty;
      }
      function s(e) {
        return !!(e.left || e.nested || e.right || e.cyclic);
      }
      function i(e, t, n, i) {
        let a = 0;
        const l = t[n],
          c = l.children.length,
          p = [];
        for (a = 0; a < c; a += 1) p.push(e.attrGen());
        for (a = 0; a < c; a += 1) o(e, t, l.children[a], p[a]);
        i.left = function (e, t) {
          for (let n = 0; n < t; n += 1) {
            if (e[n].left) return !0;
            if (!e[n].empty) return !1;
          }
          return !1;
        }(p, c), i.right = function (e, t) {
          for (let n = t - 1; n >= 0; n -= 1) {
            if (e[n].right) return !0;
            if (!e[n].empty) return !1;
          }
          return !1;
        }(p, c), i.nested = function (e, t) {
          let n = 0,
            i = 0,
            o = 0;
          for (n = 0; n < t; n += 1) if (e[n].nested) return !0;
          for (n = 0; n < t; n += 1) if (e[n].right && !e[n].leaf) for (i = n + 1; i < t; i += 1) if (!r(e[i])) return !0;
          for (n = t - 1; n >= 0; n -= 1) if (e[n].left && !e[n].leaf) for (i = n - 1; i >= 0; i -= 1) if (!r(e[i])) return !0;
          for (n = 0; n < t; n += 1) if (!e[n].empty && !s(e[n])) for (i = n + 1; i < t; i += 1) if (s(e[i])) for (o = i + 1; o < t; o += 1) if (!e[o].empty && !s(e[o])) return !0;
          return !1;
        }(p, c), i.empty = function (e, t) {
          for (let n = 0; n < t; n += 1) if (!e[n].empty) return !1;
          return !0;
        }(p, c), i.finite = function (e, t) {
          for (let n = 0; n < t; n += 1) if (!e[n].finite) return !1;
          return !0;
        }(p, c), i.cyclic = function (e, t) {
          for (let n = 0; n < t; n += 1) if (!e[n].cyclic) return !1;
          return !0;
        }(p, c);
      }
      function o(e, n, r, s) {
        e.attrInit(s);
        const l = n[r];
        switch (l.type) {
          case t.ALT:
            !function (e, t, n, r) {
              let s = 0;
              const i = t[n],
                a = i.children.length,
                l = [];
              for (s = 0; s < a; s += 1) l.push(e.attrGen());
              for (s = 0; s < a; s += 1) o(e, t, i.children[s], l[s]);
              for (r.left = !1, r.right = !1, r.nested = !1, r.empty = !1, r.finite = !1, r.cyclic = !1, s = 0; s < a; s += 1) l[s].left && (r.left = !0), l[s].nested && (r.nested = !0), l[s].right && (r.right = !0), l[s].empty && (r.empty = !0), l[s].finite && (r.finite = !0), l[s].cyclic && (r.cyclic = !0);
            }(e, n, r, s);
            break;
          case t.CAT:
            i(e, n, r, s);
            break;
          case t.REP:
            o(e, n, r + 1, s), 0 === l.min && (s.empty = !0, s.finite = !0);
            break;
          case t.RNM:
            a(e, n[r].index, s);
            break;
          case t.BKR:
            !function (e, t, n, r) {
              const s = t[n];
              s.index >= e.ruleCount ? (r.empty = e.udts[s.index - e.ruleCount].empty, r.finite = !0) : (a(e, s.index, r), r.left = !1, r.nested = !1, r.right = !1, r.cyclic = !1);
            }(e, n, r, s);
            break;
          case t.AND:
          case t.NOT:
          case t.BKA:
          case t.BKN:
            o(e, n, r + 1, s), s.empty = !0;
            break;
          case t.TLS:
            s.empty = !n[r].string.length, s.finite = !0, s.cyclic = !1;
            break;
          case t.TBS:
          case t.TRG:
            s.empty = !1, s.finite = !0, s.cyclic = !1;
            break;
          case t.UDT:
            s.empty = l.empty, s.finite = !0, s.cyclic = !1;
            break;
          case t.ABG:
          case t.AEN:
            s.empty = !0, s.finite = !0, s.cyclic = !1;
            break;
          default:
            throw new Error(`unknown opcode type: ${l}`);
        }
      }
      function a(e, t, n) {
        const r = e.attrsWorking[t];
        r.isComplete ? e.attrCopy(n, r) : r.isOpen ? t === e.startRule ? t === e.startRule && (n.left = !0, n.right = !0, n.cyclic = !0, n.leaf = !0) : n.finite = !0 : (r.isOpen = !0, o(e, r.rule.opcodes, 0, n), r.left = n.left, r.right = n.right, r.nested = n.nested, r.empty = n.empty, r.finite = n.finite, r.cyclic = n.cyclic, r.leaf = !1, r.isOpen = !1, r.isComplete = !0);
      }
      const l = e => e ? "t" : "f",
        c = e => e ? "e" : "f",
        p = (e, r, s, i) => {
          let o = `${e}:${r}:`;
          return o += `${c(s.left)} `, o += `${l(s.nested)} `, o += `${l(s.right)} `, o += `${c(s.cyclic)} `, o += (s.finite ? "t" : "e") + " ", o += `${l(s.empty)}:`, o += `${n.typeToString(i.recursiveType)}:`, o += i.recursiveType === t.ATTR_MR ? i.groupNumber : "-", o += `:${s.rule.name}\n`, o;
        },
        h = () => {
          let e = "LEGEND - t=true, f=false, e=error\n";
          return e += "sequence:rule index:left nested right cyclic finite empty:type:group number:rule name\n", "LEGEND - t=true, f=false, e=error\nsequence:rule index:left nested right cyclic finite empty:type:group number:rule name\n";
        },
        u = e => {
          let t = 0,
            r = 0,
            s = null,
            i = null,
            o = "",
            {
              ruleIndexes: a
            } = n;
          for (97 === e ? a = n.ruleAlphaIndexes : 116 === e && (a = n.ruleTypeIndexes), t = 0; t < n.ruleCount; t += 1) r = a[t], s = n.attrs[r], i = n.ruleDeps[r], o += p(t, r, s, i);
          return o;
        };
      return {
        ruleAttributes: e => {
          n = e;
          let t = 0,
            r = 0;
          const s = n.attrGen();
          for (t = 0; t < n.ruleCount; t += 1) {
            for (r = 0; r < n.ruleCount; r += 1) n.attrInit(n.attrsWorking[r]);
            n.startRule = t, a(n, t, s), n.attrCopy(n.attrs[t], n.attrsWorking[t]);
          }
          n.attributesComplete = !0;
          let i = null;
          for (t = 0; t < n.ruleCount; t += 1) if (i = n.attrs[t], i.left || !i.finite || i.cyclic) {
            const e = n.attrGen(i.rule);
            n.attrCopy(e, i), n.attrsErrors.push(e), n.attrsErrorCount += 1;
          }
        },
        showAttributes: function () {
          let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "index";
          if (!n.attributesComplete) throw new Error("rule-attributes.js:showAttributes: attributes not available");
          let t = "";
          const r = "RULE ATTRIBUTES\n";
          return 97 === e.charCodeAt(0) ? (t += "alphabetical by rule name\n", t += r, t += h(), t += u(97)) : 116 === e.charCodeAt(0) ? (t += "ordered by rule type\n", t += r, t += h(), t += u(116)) : (t += "ordered by rule index\n", t += r, t += h(), t += u()), t;
        },
        showAttributeErrors: () => {
          let e = null,
            t = null,
            r = "";
          if (r += "RULE ATTRIBUTES WITH ERRORS\n", r += h(), n.attrsErrorCount) for (let s = 0; s < n.attrsErrorCount; s += 1) e = n.attrsErrors[s], t = n.ruleDeps[e.rule.index], r += p(s, e.rule.index, e, t);else r += "<none>\n";
          return r;
        }
      };
    }();
  }, {
    "../apg-lib/identifiers": 23
  }],
  8: [function (e, t, n) {
    t.exports = (() => {
      const t = e("../apg-lib/identifiers");
      let n = null;
      const r = (e, n, s, i) => {
          let o = 0,
            a = 0;
          const l = n[s];
          i[s] = !0;
          const c = l.rule.opcodes;
          for (o = 0; o < c.length; o += 1) {
            const s = c[o];
            if (s.type === t.RNM) for (l.refersTo[s.index] = !0, i[s.index] || r(e, n, s.index, i), a = 0; a < e; a += 1) n[s.index].refersTo[a] && (l.refersTo[a] = !0);else s.type === t.UDT ? l.refersToUdt[s.index] = !0 : s.type === t.BKR && (s.index < e ? (l.refersTo[s.index] = !0, i[s.index] || r(e, n, s.index, i)) : l.refersToUdt[e - s.index] = !0);
          }
        },
        s = function () {
          let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
          let t = 0,
            r = 0,
            s = 0,
            i = 0;
          const o = n.ruleCount - 1,
            a = n.udtCount - 1;
          let l = "",
            c = "";
          const p = "=> ";
          let h = !1,
            u = null,
            {
              ruleIndexes: d
            } = n,
            {
              udtIndexes: f
            } = n;
          for (97 === e ? (d = n.ruleAlphaIndexes, f = n.udtAlphaIndexes) : 116 === e && (d = n.ruleTypeIndexes, f = n.udtAlphaIndexes), t = 0; t < n.ruleCount; t += 1) {
            for (u = n.ruleDeps[d[t]], c = `${d[t]}:${n.typeToString(u.recursiveType)}:`, n.isMutuallyRecursive && (c += u.groupNumber > -1 ? u.groupNumber : "-", c += ":"), c += " ", l += `${c + n.rules[d[t]].name}\n`, h = !0, s = 0, i = l.length, l += c, r = 0; r < n.ruleCount; r += 1) u.refersTo[d[r]] && (h ? (l += p, h = !1, l += n.ruleDeps[d[r]].rule.name) : l += `, ${n.ruleDeps[d[r]].rule.name}`, s += 1), l.length - i > 100 && r !== o && (l += `\n${c}${p}`, i = l.length);
            if (n.udtCount) for (r = 0; r < n.udtCount; r += 1) u.refersToUdt[f[r]] && (h ? (l += p, h = !1, l += n.udts[f[r]].name) : l += `, ${n.udts[f[r]].name}`, s += 1), l.length - i > 100 && r !== a && (l += `\n${c}${p}`, i = l.length);
            for (0 === s && (l += "=> <none>\n"), !1 === h && (l += "\n"), h = !0, s = 0, i = l.length, l += c, r = 0; r < n.ruleCount; r += 1) u.referencedBy[d[r]] && (h ? (l += "<= ", h = !1, l += n.ruleDeps[d[r]].rule.name) : l += `, ${n.ruleDeps[d[r]].rule.name}`, s += 1), l.length - i > 100 && r !== o && (l += `\n${c}${p}`, i = l.length);
            0 === s && (l += "<= <none>\n"), !1 === h && (l += "\n"), l += "\n";
          }
          return l;
        };
      return {
        ruleDependencies: e => {
          n = e;
          let s = 0,
            i = 0,
            o = 0,
            a = null,
            l = null,
            c = !1;
          n.dependenciesComplete = !1;
          const p = n.falseArray(n.ruleCount);
          for (s = 0; s < n.ruleCount; s += 1) n.falsifyArray(p), r(n.ruleCount, n.ruleDeps, s, p);
          for (s = 0; s < n.ruleCount; s += 1) for (i = 0; i < n.ruleCount; i += 1) s !== i && n.ruleDeps[i].refersTo[s] && (n.ruleDeps[s].referencedBy[i] = !0);
          for (s = 0; s < n.ruleCount; s += 1) n.ruleDeps[s].recursiveType = t.ATTR_N, n.ruleDeps[s].refersTo[s] && (n.ruleDeps[s].recursiveType = t.ATTR_R);
          for (o = -1, s = 0; s < n.ruleCount; s += 1) if (a = n.ruleDeps[s], a.recursiveType === t.ATTR_R) for (c = !0, i = 0; i < n.ruleCount; i += 1) s !== i && (l = n.ruleDeps[i], l.recursiveType === t.ATTR_R && a.refersTo[i] && l.refersTo[s] && (c && (o += 1, a.recursiveType = t.ATTR_MR, a.groupNumber = o, c = !1), l.recursiveType = t.ATTR_MR, l.groupNumber = o));
          n.isMutuallyRecursive = o > -1, n.ruleAlphaIndexes.sort(n.compRulesAlpha), n.ruleTypeIndexes.sort(n.compRulesAlpha), n.ruleTypeIndexes.sort(n.compRulesType), n.isMutuallyRecursive && n.ruleTypeIndexes.sort(n.compRulesGroup), n.udtCount && n.udtAlphaIndexes.sort(n.compUdtsAlpha), n.dependenciesComplete = !0;
        },
        showRuleDependencies: function () {
          let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "index";
          let t = "RULE DEPENDENCIES(index:type:[group number:])\n";
          return t += "=> refers to rule names\n", t += "<= referenced by rule names\n", n.dependenciesComplete ? (97 === e.charCodeAt(0) ? (t += "alphabetical by rule name\n", t += s(97)) : 116 === e.charCodeAt(0) ? (t += "ordered by rule type\n", t += s(116)) : (t += "ordered by rule index\n", t += s(null)), t) : t;
        }
      };
    })();
  }, {
    "../apg-lib/identifiers": 23
  }],
  9: [function (e, t, n) {
    t.exports = function () {
      this.grammarObject = "grammarObject", this.rules = [], this.rules[0] = {
        name: "File",
        lower: "file",
        index: 0,
        isBkr: !1
      }, this.rules[1] = {
        name: "BlankLine",
        lower: "blankline",
        index: 1,
        isBkr: !1
      }, this.rules[2] = {
        name: "Rule",
        lower: "rule",
        index: 2,
        isBkr: !1
      }, this.rules[3] = {
        name: "RuleLookup",
        lower: "rulelookup",
        index: 3,
        isBkr: !1
      }, this.rules[4] = {
        name: "RuleNameTest",
        lower: "rulenametest",
        index: 4,
        isBkr: !1
      }, this.rules[5] = {
        name: "RuleName",
        lower: "rulename",
        index: 5,
        isBkr: !1
      }, this.rules[6] = {
        name: "RuleNameError",
        lower: "rulenameerror",
        index: 6,
        isBkr: !1
      }, this.rules[7] = {
        name: "DefinedAsTest",
        lower: "definedastest",
        index: 7,
        isBkr: !1
      }, this.rules[8] = {
        name: "DefinedAsError",
        lower: "definedaserror",
        index: 8,
        isBkr: !1
      }, this.rules[9] = {
        name: "DefinedAs",
        lower: "definedas",
        index: 9,
        isBkr: !1
      }, this.rules[10] = {
        name: "Defined",
        lower: "defined",
        index: 10,
        isBkr: !1
      }, this.rules[11] = {
        name: "IncAlt",
        lower: "incalt",
        index: 11,
        isBkr: !1
      }, this.rules[12] = {
        name: "RuleError",
        lower: "ruleerror",
        index: 12,
        isBkr: !1
      }, this.rules[13] = {
        name: "LineEndError",
        lower: "lineenderror",
        index: 13,
        isBkr: !1
      }, this.rules[14] = {
        name: "Alternation",
        lower: "alternation",
        index: 14,
        isBkr: !1
      }, this.rules[15] = {
        name: "Concatenation",
        lower: "concatenation",
        index: 15,
        isBkr: !1
      }, this.rules[16] = {
        name: "Repetition",
        lower: "repetition",
        index: 16,
        isBkr: !1
      }, this.rules[17] = {
        name: "Modifier",
        lower: "modifier",
        index: 17,
        isBkr: !1
      }, this.rules[18] = {
        name: "Predicate",
        lower: "predicate",
        index: 18,
        isBkr: !1
      }, this.rules[19] = {
        name: "BasicElement",
        lower: "basicelement",
        index: 19,
        isBkr: !1
      }, this.rules[20] = {
        name: "BasicElementErr",
        lower: "basicelementerr",
        index: 20,
        isBkr: !1
      }, this.rules[21] = {
        name: "Group",
        lower: "group",
        index: 21,
        isBkr: !1
      }, this.rules[22] = {
        name: "GroupError",
        lower: "grouperror",
        index: 22,
        isBkr: !1
      }, this.rules[23] = {
        name: "GroupOpen",
        lower: "groupopen",
        index: 23,
        isBkr: !1
      }, this.rules[24] = {
        name: "GroupClose",
        lower: "groupclose",
        index: 24,
        isBkr: !1
      }, this.rules[25] = {
        name: "Option",
        lower: "option",
        index: 25,
        isBkr: !1
      }, this.rules[26] = {
        name: "OptionError",
        lower: "optionerror",
        index: 26,
        isBkr: !1
      }, this.rules[27] = {
        name: "OptionOpen",
        lower: "optionopen",
        index: 27,
        isBkr: !1
      }, this.rules[28] = {
        name: "OptionClose",
        lower: "optionclose",
        index: 28,
        isBkr: !1
      }, this.rules[29] = {
        name: "RnmOp",
        lower: "rnmop",
        index: 29,
        isBkr: !1
      }, this.rules[30] = {
        name: "BkrOp",
        lower: "bkrop",
        index: 30,
        isBkr: !1
      }, this.rules[31] = {
        name: "bkrModifier",
        lower: "bkrmodifier",
        index: 31,
        isBkr: !1
      }, this.rules[32] = {
        name: "cs",
        lower: "cs",
        index: 32,
        isBkr: !1
      }, this.rules[33] = {
        name: "ci",
        lower: "ci",
        index: 33,
        isBkr: !1
      }, this.rules[34] = {
        name: "um",
        lower: "um",
        index: 34,
        isBkr: !1
      }, this.rules[35] = {
        name: "pm",
        lower: "pm",
        index: 35,
        isBkr: !1
      }, this.rules[36] = {
        name: "bkr-name",
        lower: "bkr-name",
        index: 36,
        isBkr: !1
      }, this.rules[37] = {
        name: "rname",
        lower: "rname",
        index: 37,
        isBkr: !1
      }, this.rules[38] = {
        name: "uname",
        lower: "uname",
        index: 38,
        isBkr: !1
      }, this.rules[39] = {
        name: "ename",
        lower: "ename",
        index: 39,
        isBkr: !1
      }, this.rules[40] = {
        name: "UdtOp",
        lower: "udtop",
        index: 40,
        isBkr: !1
      }, this.rules[41] = {
        name: "udt-non-empty",
        lower: "udt-non-empty",
        index: 41,
        isBkr: !1
      }, this.rules[42] = {
        name: "udt-empty",
        lower: "udt-empty",
        index: 42,
        isBkr: !1
      }, this.rules[43] = {
        name: "RepOp",
        lower: "repop",
        index: 43,
        isBkr: !1
      }, this.rules[44] = {
        name: "AltOp",
        lower: "altop",
        index: 44,
        isBkr: !1
      }, this.rules[45] = {
        name: "CatOp",
        lower: "catop",
        index: 45,
        isBkr: !1
      }, this.rules[46] = {
        name: "StarOp",
        lower: "starop",
        index: 46,
        isBkr: !1
      }, this.rules[47] = {
        name: "AndOp",
        lower: "andop",
        index: 47,
        isBkr: !1
      }, this.rules[48] = {
        name: "NotOp",
        lower: "notop",
        index: 48,
        isBkr: !1
      }, this.rules[49] = {
        name: "BkaOp",
        lower: "bkaop",
        index: 49,
        isBkr: !1
      }, this.rules[50] = {
        name: "BknOp",
        lower: "bknop",
        index: 50,
        isBkr: !1
      }, this.rules[51] = {
        name: "AbgOp",
        lower: "abgop",
        index: 51,
        isBkr: !1
      }, this.rules[52] = {
        name: "AenOp",
        lower: "aenop",
        index: 52,
        isBkr: !1
      }, this.rules[53] = {
        name: "TrgOp",
        lower: "trgop",
        index: 53,
        isBkr: !1
      }, this.rules[54] = {
        name: "TbsOp",
        lower: "tbsop",
        index: 54,
        isBkr: !1
      }, this.rules[55] = {
        name: "TlsOp",
        lower: "tlsop",
        index: 55,
        isBkr: !1
      }, this.rules[56] = {
        name: "TlsCase",
        lower: "tlscase",
        index: 56,
        isBkr: !1
      }, this.rules[57] = {
        name: "TlsOpen",
        lower: "tlsopen",
        index: 57,
        isBkr: !1
      }, this.rules[58] = {
        name: "TlsClose",
        lower: "tlsclose",
        index: 58,
        isBkr: !1
      }, this.rules[59] = {
        name: "TlsString",
        lower: "tlsstring",
        index: 59,
        isBkr: !1
      }, this.rules[60] = {
        name: "StringTab",
        lower: "stringtab",
        index: 60,
        isBkr: !1
      }, this.rules[61] = {
        name: "ClsOp",
        lower: "clsop",
        index: 61,
        isBkr: !1
      }, this.rules[62] = {
        name: "ClsOpen",
        lower: "clsopen",
        index: 62,
        isBkr: !1
      }, this.rules[63] = {
        name: "ClsClose",
        lower: "clsclose",
        index: 63,
        isBkr: !1
      }, this.rules[64] = {
        name: "ClsString",
        lower: "clsstring",
        index: 64,
        isBkr: !1
      }, this.rules[65] = {
        name: "ProsVal",
        lower: "prosval",
        index: 65,
        isBkr: !1
      }, this.rules[66] = {
        name: "ProsValOpen",
        lower: "prosvalopen",
        index: 66,
        isBkr: !1
      }, this.rules[67] = {
        name: "ProsValString",
        lower: "prosvalstring",
        index: 67,
        isBkr: !1
      }, this.rules[68] = {
        name: "ProsValClose",
        lower: "prosvalclose",
        index: 68,
        isBkr: !1
      }, this.rules[69] = {
        name: "rep-min",
        lower: "rep-min",
        index: 69,
        isBkr: !1
      }, this.rules[70] = {
        name: "rep-min-max",
        lower: "rep-min-max",
        index: 70,
        isBkr: !1
      }, this.rules[71] = {
        name: "rep-max",
        lower: "rep-max",
        index: 71,
        isBkr: !1
      }, this.rules[72] = {
        name: "rep-num",
        lower: "rep-num",
        index: 72,
        isBkr: !1
      }, this.rules[73] = {
        name: "dString",
        lower: "dstring",
        index: 73,
        isBkr: !1
      }, this.rules[74] = {
        name: "xString",
        lower: "xstring",
        index: 74,
        isBkr: !1
      }, this.rules[75] = {
        name: "bString",
        lower: "bstring",
        index: 75,
        isBkr: !1
      }, this.rules[76] = {
        name: "Dec",
        lower: "dec",
        index: 76,
        isBkr: !1
      }, this.rules[77] = {
        name: "Hex",
        lower: "hex",
        index: 77,
        isBkr: !1
      }, this.rules[78] = {
        name: "Bin",
        lower: "bin",
        index: 78,
        isBkr: !1
      }, this.rules[79] = {
        name: "dmin",
        lower: "dmin",
        index: 79,
        isBkr: !1
      }, this.rules[80] = {
        name: "dmax",
        lower: "dmax",
        index: 80,
        isBkr: !1
      }, this.rules[81] = {
        name: "bmin",
        lower: "bmin",
        index: 81,
        isBkr: !1
      }, this.rules[82] = {
        name: "bmax",
        lower: "bmax",
        index: 82,
        isBkr: !1
      }, this.rules[83] = {
        name: "xmin",
        lower: "xmin",
        index: 83,
        isBkr: !1
      }, this.rules[84] = {
        name: "xmax",
        lower: "xmax",
        index: 84,
        isBkr: !1
      }, this.rules[85] = {
        name: "dnum",
        lower: "dnum",
        index: 85,
        isBkr: !1
      }, this.rules[86] = {
        name: "bnum",
        lower: "bnum",
        index: 86,
        isBkr: !1
      }, this.rules[87] = {
        name: "xnum",
        lower: "xnum",
        index: 87,
        isBkr: !1
      }, this.rules[88] = {
        name: "alphanum",
        lower: "alphanum",
        index: 88,
        isBkr: !1
      }, this.rules[89] = {
        name: "owsp",
        lower: "owsp",
        index: 89,
        isBkr: !1
      }, this.rules[90] = {
        name: "wsp",
        lower: "wsp",
        index: 90,
        isBkr: !1
      }, this.rules[91] = {
        name: "space",
        lower: "space",
        index: 91,
        isBkr: !1
      }, this.rules[92] = {
        name: "comment",
        lower: "comment",
        index: 92,
        isBkr: !1
      }, this.rules[93] = {
        name: "LineEnd",
        lower: "lineend",
        index: 93,
        isBkr: !1
      }, this.rules[94] = {
        name: "LineContinue",
        lower: "linecontinue",
        index: 94,
        isBkr: !1
      }, this.udts = [], this.rules[0].opcodes = [], this.rules[0].opcodes[0] = {
        type: 3,
        min: 0,
        max: 1 / 0
      }, this.rules[0].opcodes[1] = {
        type: 1,
        children: [2, 3, 4]
      }, this.rules[0].opcodes[2] = {
        type: 4,
        index: 1
      }, this.rules[0].opcodes[3] = {
        type: 4,
        index: 2
      }, this.rules[0].opcodes[4] = {
        type: 4,
        index: 12
      }, this.rules[1].opcodes = [], this.rules[1].opcodes[0] = {
        type: 2,
        children: [1, 5, 7]
      }, this.rules[1].opcodes[1] = {
        type: 3,
        min: 0,
        max: 1 / 0
      }, this.rules[1].opcodes[2] = {
        type: 1,
        children: [3, 4]
      }, this.rules[1].opcodes[3] = {
        type: 6,
        string: [32]
      }, this.rules[1].opcodes[4] = {
        type: 6,
        string: [9]
      }, this.rules[1].opcodes[5] = {
        type: 3,
        min: 0,
        max: 1
      }, this.rules[1].opcodes[6] = {
        type: 4,
        index: 92
      }, this.rules[1].opcodes[7] = {
        type: 4,
        index: 93
      }, this.rules[2].opcodes = [], this.rules[2].opcodes[0] = {
        type: 2,
        children: [1, 2, 3, 4]
      }, this.rules[2].opcodes[1] = {
        type: 4,
        index: 3
      }, this.rules[2].opcodes[2] = {
        type: 4,
        index: 89
      }, this.rules[2].opcodes[3] = {
        type: 4,
        index: 14
      }, this.rules[2].opcodes[4] = {
        type: 1,
        children: [5, 8]
      }, this.rules[2].opcodes[5] = {
        type: 2,
        children: [6, 7]
      }, this.rules[2].opcodes[6] = {
        type: 4,
        index: 89
      }, this.rules[2].opcodes[7] = {
        type: 4,
        index: 93
      }, this.rules[2].opcodes[8] = {
        type: 2,
        children: [9, 10]
      }, this.rules[2].opcodes[9] = {
        type: 4,
        index: 13
      }, this.rules[2].opcodes[10] = {
        type: 4,
        index: 93
      }, this.rules[3].opcodes = [], this.rules[3].opcodes[0] = {
        type: 2,
        children: [1, 2, 3]
      }, this.rules[3].opcodes[1] = {
        type: 4,
        index: 4
      }, this.rules[3].opcodes[2] = {
        type: 4,
        index: 89
      }, this.rules[3].opcodes[3] = {
        type: 4,
        index: 7
      }, this.rules[4].opcodes = [], this.rules[4].opcodes[0] = {
        type: 1,
        children: [1, 2]
      }, this.rules[4].opcodes[1] = {
        type: 4,
        index: 5
      }, this.rules[4].opcodes[2] = {
        type: 4,
        index: 6
      }, this.rules[5].opcodes = [], this.rules[5].opcodes[0] = {
        type: 4,
        index: 88
      }, this.rules[6].opcodes = [], this.rules[6].opcodes[0] = {
        type: 3,
        min: 1,
        max: 1 / 0
      }, this.rules[6].opcodes[1] = {
        type: 1,
        children: [2, 3]
      }, this.rules[6].opcodes[2] = {
        type: 5,
        min: 33,
        max: 60
      }, this.rules[6].opcodes[3] = {
        type: 5,
        min: 62,
        max: 126
      }, this.rules[7].opcodes = [], this.rules[7].opcodes[0] = {
        type: 1,
        children: [1, 2]
      }, this.rules[7].opcodes[1] = {
        type: 4,
        index: 9
      }, this.rules[7].opcodes[2] = {
        type: 4,
        index: 8
      }, this.rules[8].opcodes = [], this.rules[8].opcodes[0] = {
        type: 3,
        min: 1,
        max: 2
      }, this.rules[8].opcodes[1] = {
        type: 5,
        min: 33,
        max: 126
      }, this.rules[9].opcodes = [], this.rules[9].opcodes[0] = {
        type: 1,
        children: [1, 2]
      }, this.rules[9].opcodes[1] = {
        type: 4,
        index: 11
      }, this.rules[9].opcodes[2] = {
        type: 4,
        index: 10
      }, this.rules[10].opcodes = [], this.rules[10].opcodes[0] = {
        type: 6,
        string: [61]
      }, this.rules[11].opcodes = [], this.rules[11].opcodes[0] = {
        type: 6,
        string: [61, 47]
      }, this.rules[12].opcodes = [], this.rules[12].opcodes[0] = {
        type: 2,
        children: [1, 6]
      }, this.rules[12].opcodes[1] = {
        type: 3,
        min: 1,
        max: 1 / 0
      }, this.rules[12].opcodes[2] = {
        type: 1,
        children: [3, 4, 5]
      }, this.rules[12].opcodes[3] = {
        type: 5,
        min: 32,
        max: 126
      }, this.rules[12].opcodes[4] = {
        type: 6,
        string: [9]
      }, this.rules[12].opcodes[5] = {
        type: 4,
        index: 94
      }, this.rules[12].opcodes[6] = {
        type: 4,
        index: 93
      }, this.rules[13].opcodes = [], this.rules[13].opcodes[0] = {
        type: 3,
        min: 1,
        max: 1 / 0
      }, this.rules[13].opcodes[1] = {
        type: 1,
        children: [2, 3, 4]
      }, this.rules[13].opcodes[2] = {
        type: 5,
        min: 32,
        max: 126
      }, this.rules[13].opcodes[3] = {
        type: 6,
        string: [9]
      }, this.rules[13].opcodes[4] = {
        type: 4,
        index: 94
      }, this.rules[14].opcodes = [], this.rules[14].opcodes[0] = {
        type: 2,
        children: [1, 2]
      }, this.rules[14].opcodes[1] = {
        type: 4,
        index: 15
      }, this.rules[14].opcodes[2] = {
        type: 3,
        min: 0,
        max: 1 / 0
      }, this.rules[14].opcodes[3] = {
        type: 2,
        children: [4, 5, 6]
      }, this.rules[14].opcodes[4] = {
        type: 4,
        index: 89
      }, this.rules[14].opcodes[5] = {
        type: 4,
        index: 44
      }, this.rules[14].opcodes[6] = {
        type: 4,
        index: 15
      }, this.rules[15].opcodes = [], this.rules[15].opcodes[0] = {
        type: 2,
        children: [1, 2]
      }, this.rules[15].opcodes[1] = {
        type: 4,
        index: 16
      }, this.rules[15].opcodes[2] = {
        type: 3,
        min: 0,
        max: 1 / 0
      }, this.rules[15].opcodes[3] = {
        type: 2,
        children: [4, 5]
      }, this.rules[15].opcodes[4] = {
        type: 4,
        index: 45
      }, this.rules[15].opcodes[5] = {
        type: 4,
        index: 16
      }, this.rules[16].opcodes = [], this.rules[16].opcodes[0] = {
        type: 2,
        children: [1, 3]
      }, this.rules[16].opcodes[1] = {
        type: 3,
        min: 0,
        max: 1
      }, this.rules[16].opcodes[2] = {
        type: 4,
        index: 17
      }, this.rules[16].opcodes[3] = {
        type: 1,
        children: [4, 5, 6, 7]
      }, this.rules[16].opcodes[4] = {
        type: 4,
        index: 21
      }, this.rules[16].opcodes[5] = {
        type: 4,
        index: 25
      }, this.rules[16].opcodes[6] = {
        type: 4,
        index: 19
      }, this.rules[16].opcodes[7] = {
        type: 4,
        index: 20
      }, this.rules[17].opcodes = [], this.rules[17].opcodes[0] = {
        type: 1,
        children: [1, 5]
      }, this.rules[17].opcodes[1] = {
        type: 2,
        children: [2, 3]
      }, this.rules[17].opcodes[2] = {
        type: 4,
        index: 18
      }, this.rules[17].opcodes[3] = {
        type: 3,
        min: 0,
        max: 1
      }, this.rules[17].opcodes[4] = {
        type: 4,
        index: 43
      }, this.rules[17].opcodes[5] = {
        type: 4,
        index: 43
      }, this.rules[18].opcodes = [], this.rules[18].opcodes[0] = {
        type: 1,
        children: [1, 2, 3, 4]
      }, this.rules[18].opcodes[1] = {
        type: 4,
        index: 49
      }, this.rules[18].opcodes[2] = {
        type: 4,
        index: 50
      }, this.rules[18].opcodes[3] = {
        type: 4,
        index: 47
      }, this.rules[18].opcodes[4] = {
        type: 4,
        index: 48
      }, this.rules[19].opcodes = [], this.rules[19].opcodes[0] = {
        type: 1,
        children: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
      }, this.rules[19].opcodes[1] = {
        type: 4,
        index: 40
      }, this.rules[19].opcodes[2] = {
        type: 4,
        index: 29
      }, this.rules[19].opcodes[3] = {
        type: 4,
        index: 53
      }, this.rules[19].opcodes[4] = {
        type: 4,
        index: 54
      }, this.rules[19].opcodes[5] = {
        type: 4,
        index: 55
      }, this.rules[19].opcodes[6] = {
        type: 4,
        index: 61
      }, this.rules[19].opcodes[7] = {
        type: 4,
        index: 30
      }, this.rules[19].opcodes[8] = {
        type: 4,
        index: 51
      }, this.rules[19].opcodes[9] = {
        type: 4,
        index: 52
      }, this.rules[19].opcodes[10] = {
        type: 4,
        index: 65
      }, this.rules[20].opcodes = [], this.rules[20].opcodes[0] = {
        type: 3,
        min: 1,
        max: 1 / 0
      }, this.rules[20].opcodes[1] = {
        type: 1,
        children: [2, 3, 4, 5]
      }, this.rules[20].opcodes[2] = {
        type: 5,
        min: 33,
        max: 40
      }, this.rules[20].opcodes[3] = {
        type: 5,
        min: 42,
        max: 46
      }, this.rules[20].opcodes[4] = {
        type: 5,
        min: 48,
        max: 92
      }, this.rules[20].opcodes[5] = {
        type: 5,
        min: 94,
        max: 126
      }, this.rules[21].opcodes = [], this.rules[21].opcodes[0] = {
        type: 2,
        children: [1, 2, 3]
      }, this.rules[21].opcodes[1] = {
        type: 4,
        index: 23
      }, this.rules[21].opcodes[2] = {
        type: 4,
        index: 14
      }, this.rules[21].opcodes[3] = {
        type: 1,
        children: [4, 5]
      }, this.rules[21].opcodes[4] = {
        type: 4,
        index: 24
      }, this.rules[21].opcodes[5] = {
        type: 4,
        index: 22
      }, this.rules[22].opcodes = [], this.rules[22].opcodes[0] = {
        type: 3,
        min: 1,
        max: 1 / 0
      }, this.rules[22].opcodes[1] = {
        type: 1,
        children: [2, 3, 4, 5]
      }, this.rules[22].opcodes[2] = {
        type: 5,
        min: 33,
        max: 40
      }, this.rules[22].opcodes[3] = {
        type: 5,
        min: 42,
        max: 46
      }, this.rules[22].opcodes[4] = {
        type: 5,
        min: 48,
        max: 92
      }, this.rules[22].opcodes[5] = {
        type: 5,
        min: 94,
        max: 126
      }, this.rules[23].opcodes = [], this.rules[23].opcodes[0] = {
        type: 2,
        children: [1, 2]
      }, this.rules[23].opcodes[1] = {
        type: 6,
        string: [40]
      }, this.rules[23].opcodes[2] = {
        type: 4,
        index: 89
      }, this.rules[24].opcodes = [], this.rules[24].opcodes[0] = {
        type: 2,
        children: [1, 2]
      }, this.rules[24].opcodes[1] = {
        type: 4,
        index: 89
      }, this.rules[24].opcodes[2] = {
        type: 6,
        string: [41]
      }, this.rules[25].opcodes = [], this.rules[25].opcodes[0] = {
        type: 2,
        children: [1, 2, 3]
      }, this.rules[25].opcodes[1] = {
        type: 4,
        index: 27
      }, this.rules[25].opcodes[2] = {
        type: 4,
        index: 14
      }, this.rules[25].opcodes[3] = {
        type: 1,
        children: [4, 5]
      }, this.rules[25].opcodes[4] = {
        type: 4,
        index: 28
      }, this.rules[25].opcodes[5] = {
        type: 4,
        index: 26
      }, this.rules[26].opcodes = [], this.rules[26].opcodes[0] = {
        type: 3,
        min: 1,
        max: 1 / 0
      }, this.rules[26].opcodes[1] = {
        type: 1,
        children: [2, 3, 4, 5]
      }, this.rules[26].opcodes[2] = {
        type: 5,
        min: 33,
        max: 40
      }, this.rules[26].opcodes[3] = {
        type: 5,
        min: 42,
        max: 46
      }, this.rules[26].opcodes[4] = {
        type: 5,
        min: 48,
        max: 92
      }, this.rules[26].opcodes[5] = {
        type: 5,
        min: 94,
        max: 126
      }, this.rules[27].opcodes = [], this.rules[27].opcodes[0] = {
        type: 2,
        children: [1, 2]
      }, this.rules[27].opcodes[1] = {
        type: 6,
        string: [91]
      }, this.rules[27].opcodes[2] = {
        type: 4,
        index: 89
      }, this.rules[28].opcodes = [], this.rules[28].opcodes[0] = {
        type: 2,
        children: [1, 2]
      }, this.rules[28].opcodes[1] = {
        type: 4,
        index: 89
      }, this.rules[28].opcodes[2] = {
        type: 6,
        string: [93]
      }, this.rules[29].opcodes = [], this.rules[29].opcodes[0] = {
        type: 4,
        index: 88
      }, this.rules[30].opcodes = [], this.rules[30].opcodes[0] = {
        type: 2,
        children: [1, 2, 4]
      }, this.rules[30].opcodes[1] = {
        type: 6,
        string: [92]
      }, this.rules[30].opcodes[2] = {
        type: 3,
        min: 0,
        max: 1
      }, this.rules[30].opcodes[3] = {
        type: 4,
        index: 31
      }, this.rules[30].opcodes[4] = {
        type: 4,
        index: 36
      }, this.rules[31].opcodes = [], this.rules[31].opcodes[0] = {
        type: 1,
        children: [1, 7, 13, 19]
      }, this.rules[31].opcodes[1] = {
        type: 2,
        children: [2, 3]
      }, this.rules[31].opcodes[2] = {
        type: 4,
        index: 32
      }, this.rules[31].opcodes[3] = {
        type: 3,
        min: 0,
        max: 1
      }, this.rules[31].opcodes[4] = {
        type: 1,
        children: [5, 6]
      }, this.rules[31].opcodes[5] = {
        type: 4,
        index: 34
      }, this.rules[31].opcodes[6] = {
        type: 4,
        index: 35
      }, this.rules[31].opcodes[7] = {
        type: 2,
        children: [8, 9]
      }, this.rules[31].opcodes[8] = {
        type: 4,
        index: 33
      }, this.rules[31].opcodes[9] = {
        type: 3,
        min: 0,
        max: 1
      }, this.rules[31].opcodes[10] = {
        type: 1,
        children: [11, 12]
      }, this.rules[31].opcodes[11] = {
        type: 4,
        index: 34
      }, this.rules[31].opcodes[12] = {
        type: 4,
        index: 35
      }, this.rules[31].opcodes[13] = {
        type: 2,
        children: [14, 15]
      }, this.rules[31].opcodes[14] = {
        type: 4,
        index: 34
      }, this.rules[31].opcodes[15] = {
        type: 3,
        min: 0,
        max: 1
      }, this.rules[31].opcodes[16] = {
        type: 1,
        children: [17, 18]
      }, this.rules[31].opcodes[17] = {
        type: 4,
        index: 32
      }, this.rules[31].opcodes[18] = {
        type: 4,
        index: 33
      }, this.rules[31].opcodes[19] = {
        type: 2,
        children: [20, 21]
      }, this.rules[31].opcodes[20] = {
        type: 4,
        index: 35
      }, this.rules[31].opcodes[21] = {
        type: 3,
        min: 0,
        max: 1
      }, this.rules[31].opcodes[22] = {
        type: 1,
        children: [23, 24]
      }, this.rules[31].opcodes[23] = {
        type: 4,
        index: 32
      }, this.rules[31].opcodes[24] = {
        type: 4,
        index: 33
      }, this.rules[32].opcodes = [], this.rules[32].opcodes[0] = {
        type: 6,
        string: [37, 115]
      }, this.rules[33].opcodes = [], this.rules[33].opcodes[0] = {
        type: 6,
        string: [37, 105]
      }, this.rules[34].opcodes = [], this.rules[34].opcodes[0] = {
        type: 6,
        string: [37, 117]
      }, this.rules[35].opcodes = [], this.rules[35].opcodes[0] = {
        type: 6,
        string: [37, 112]
      }, this.rules[36].opcodes = [], this.rules[36].opcodes[0] = {
        type: 1,
        children: [1, 2, 3]
      }, this.rules[36].opcodes[1] = {
        type: 4,
        index: 38
      }, this.rules[36].opcodes[2] = {
        type: 4,
        index: 39
      }, this.rules[36].opcodes[3] = {
        type: 4,
        index: 37
      }, this.rules[37].opcodes = [], this.rules[37].opcodes[0] = {
        type: 4,
        index: 88
      }, this.rules[38].opcodes = [], this.rules[38].opcodes[0] = {
        type: 2,
        children: [1, 2]
      }, this.rules[38].opcodes[1] = {
        type: 6,
        string: [117, 95]
      }, this.rules[38].opcodes[2] = {
        type: 4,
        index: 88
      }, this.rules[39].opcodes = [], this.rules[39].opcodes[0] = {
        type: 2,
        children: [1, 2]
      }, this.rules[39].opcodes[1] = {
        type: 6,
        string: [101, 95]
      }, this.rules[39].opcodes[2] = {
        type: 4,
        index: 88
      }, this.rules[40].opcodes = [], this.rules[40].opcodes[0] = {
        type: 1,
        children: [1, 2]
      }, this.rules[40].opcodes[1] = {
        type: 4,
        index: 42
      }, this.rules[40].opcodes[2] = {
        type: 4,
        index: 41
      }, this.rules[41].opcodes = [], this.rules[41].opcodes[0] = {
        type: 2,
        children: [1, 2]
      }, this.rules[41].opcodes[1] = {
        type: 6,
        string: [117, 95]
      }, this.rules[41].opcodes[2] = {
        type: 4,
        index: 88
      }, this.rules[42].opcodes = [], this.rules[42].opcodes[0] = {
        type: 2,
        children: [1, 2]
      }, this.rules[42].opcodes[1] = {
        type: 6,
        string: [101, 95]
      }, this.rules[42].opcodes[2] = {
        type: 4,
        index: 88
      }, this.rules[43].opcodes = [], this.rules[43].opcodes[0] = {
        type: 1,
        children: [1, 5, 8, 11, 12]
      }, this.rules[43].opcodes[1] = {
        type: 2,
        children: [2, 3, 4]
      }, this.rules[43].opcodes[2] = {
        type: 4,
        index: 69
      }, this.rules[43].opcodes[3] = {
        type: 4,
        index: 46
      }, this.rules[43].opcodes[4] = {
        type: 4,
        index: 71
      }, this.rules[43].opcodes[5] = {
        type: 2,
        children: [6, 7]
      }, this.rules[43].opcodes[6] = {
        type: 4,
        index: 69
      }, this.rules[43].opcodes[7] = {
        type: 4,
        index: 46
      }, this.rules[43].opcodes[8] = {
        type: 2,
        children: [9, 10]
      }, this.rules[43].opcodes[9] = {
        type: 4,
        index: 46
      }, this.rules[43].opcodes[10] = {
        type: 4,
        index: 71
      }, this.rules[43].opcodes[11] = {
        type: 4,
        index: 46
      }, this.rules[43].opcodes[12] = {
        type: 4,
        index: 70
      }, this.rules[44].opcodes = [], this.rules[44].opcodes[0] = {
        type: 2,
        children: [1, 2]
      }, this.rules[44].opcodes[1] = {
        type: 6,
        string: [47]
      }, this.rules[44].opcodes[2] = {
        type: 4,
        index: 89
      }, this.rules[45].opcodes = [], this.rules[45].opcodes[0] = {
        type: 4,
        index: 90
      }, this.rules[46].opcodes = [], this.rules[46].opcodes[0] = {
        type: 6,
        string: [42]
      }, this.rules[47].opcodes = [], this.rules[47].opcodes[0] = {
        type: 6,
        string: [38]
      }, this.rules[48].opcodes = [], this.rules[48].opcodes[0] = {
        type: 6,
        string: [33]
      }, this.rules[49].opcodes = [], this.rules[49].opcodes[0] = {
        type: 6,
        string: [38, 38]
      }, this.rules[50].opcodes = [], this.rules[50].opcodes[0] = {
        type: 6,
        string: [33, 33]
      }, this.rules[51].opcodes = [], this.rules[51].opcodes[0] = {
        type: 6,
        string: [37, 94]
      }, this.rules[52].opcodes = [], this.rules[52].opcodes[0] = {
        type: 6,
        string: [37, 36]
      }, this.rules[53].opcodes = [], this.rules[53].opcodes[0] = {
        type: 2,
        children: [1, 2]
      }, this.rules[53].opcodes[1] = {
        type: 6,
        string: [37]
      }, this.rules[53].opcodes[2] = {
        type: 1,
        children: [3, 8, 13]
      }, this.rules[53].opcodes[3] = {
        type: 2,
        children: [4, 5, 6, 7]
      }, this.rules[53].opcodes[4] = {
        type: 4,
        index: 76
      }, this.rules[53].opcodes[5] = {
        type: 4,
        index: 79
      }, this.rules[53].opcodes[6] = {
        type: 6,
        string: [45]
      }, this.rules[53].opcodes[7] = {
        type: 4,
        index: 80
      }, this.rules[53].opcodes[8] = {
        type: 2,
        children: [9, 10, 11, 12]
      }, this.rules[53].opcodes[9] = {
        type: 4,
        index: 77
      }, this.rules[53].opcodes[10] = {
        type: 4,
        index: 83
      }, this.rules[53].opcodes[11] = {
        type: 6,
        string: [45]
      }, this.rules[53].opcodes[12] = {
        type: 4,
        index: 84
      }, this.rules[53].opcodes[13] = {
        type: 2,
        children: [14, 15, 16, 17]
      }, this.rules[53].opcodes[14] = {
        type: 4,
        index: 78
      }, this.rules[53].opcodes[15] = {
        type: 4,
        index: 81
      }, this.rules[53].opcodes[16] = {
        type: 6,
        string: [45]
      }, this.rules[53].opcodes[17] = {
        type: 4,
        index: 82
      }, this.rules[54].opcodes = [], this.rules[54].opcodes[0] = {
        type: 2,
        children: [1, 2]
      }, this.rules[54].opcodes[1] = {
        type: 6,
        string: [37]
      }, this.rules[54].opcodes[2] = {
        type: 1,
        children: [3, 10, 17]
      }, this.rules[54].opcodes[3] = {
        type: 2,
        children: [4, 5, 6]
      }, this.rules[54].opcodes[4] = {
        type: 4,
        index: 76
      }, this.rules[54].opcodes[5] = {
        type: 4,
        index: 73
      }, this.rules[54].opcodes[6] = {
        type: 3,
        min: 0,
        max: 1 / 0
      }, this.rules[54].opcodes[7] = {
        type: 2,
        children: [8, 9]
      }, this.rules[54].opcodes[8] = {
        type: 6,
        string: [46]
      }, this.rules[54].opcodes[9] = {
        type: 4,
        index: 73
      }, this.rules[54].opcodes[10] = {
        type: 2,
        children: [11, 12, 13]
      }, this.rules[54].opcodes[11] = {
        type: 4,
        index: 77
      }, this.rules[54].opcodes[12] = {
        type: 4,
        index: 74
      }, this.rules[54].opcodes[13] = {
        type: 3,
        min: 0,
        max: 1 / 0
      }, this.rules[54].opcodes[14] = {
        type: 2,
        children: [15, 16]
      }, this.rules[54].opcodes[15] = {
        type: 6,
        string: [46]
      }, this.rules[54].opcodes[16] = {
        type: 4,
        index: 74
      }, this.rules[54].opcodes[17] = {
        type: 2,
        children: [18, 19, 20]
      }, this.rules[54].opcodes[18] = {
        type: 4,
        index: 78
      }, this.rules[54].opcodes[19] = {
        type: 4,
        index: 75
      }, this.rules[54].opcodes[20] = {
        type: 3,
        min: 0,
        max: 1 / 0
      }, this.rules[54].opcodes[21] = {
        type: 2,
        children: [22, 23]
      }, this.rules[54].opcodes[22] = {
        type: 6,
        string: [46]
      }, this.rules[54].opcodes[23] = {
        type: 4,
        index: 75
      }, this.rules[55].opcodes = [], this.rules[55].opcodes[0] = {
        type: 2,
        children: [1, 2, 3, 4]
      }, this.rules[55].opcodes[1] = {
        type: 4,
        index: 56
      }, this.rules[55].opcodes[2] = {
        type: 4,
        index: 57
      }, this.rules[55].opcodes[3] = {
        type: 4,
        index: 59
      }, this.rules[55].opcodes[4] = {
        type: 4,
        index: 58
      }, this.rules[56].opcodes = [], this.rules[56].opcodes[0] = {
        type: 3,
        min: 0,
        max: 1
      }, this.rules[56].opcodes[1] = {
        type: 1,
        children: [2, 3]
      }, this.rules[56].opcodes[2] = {
        type: 7,
        string: [37, 105]
      }, this.rules[56].opcodes[3] = {
        type: 7,
        string: [37, 115]
      }, this.rules[57].opcodes = [], this.rules[57].opcodes[0] = {
        type: 6,
        string: [34]
      }, this.rules[58].opcodes = [], this.rules[58].opcodes[0] = {
        type: 6,
        string: [34]
      }, this.rules[59].opcodes = [], this.rules[59].opcodes[0] = {
        type: 3,
        min: 0,
        max: 1 / 0
      }, this.rules[59].opcodes[1] = {
        type: 1,
        children: [2, 3, 4]
      }, this.rules[59].opcodes[2] = {
        type: 5,
        min: 32,
        max: 33
      }, this.rules[59].opcodes[3] = {
        type: 5,
        min: 35,
        max: 126
      }, this.rules[59].opcodes[4] = {
        type: 4,
        index: 60
      }, this.rules[60].opcodes = [], this.rules[60].opcodes[0] = {
        type: 6,
        string: [9]
      }, this.rules[61].opcodes = [], this.rules[61].opcodes[0] = {
        type: 2,
        children: [1, 2, 3]
      }, this.rules[61].opcodes[1] = {
        type: 4,
        index: 62
      }, this.rules[61].opcodes[2] = {
        type: 4,
        index: 64
      }, this.rules[61].opcodes[3] = {
        type: 4,
        index: 63
      }, this.rules[62].opcodes = [], this.rules[62].opcodes[0] = {
        type: 6,
        string: [39]
      }, this.rules[63].opcodes = [], this.rules[63].opcodes[0] = {
        type: 6,
        string: [39]
      }, this.rules[64].opcodes = [], this.rules[64].opcodes[0] = {
        type: 3,
        min: 0,
        max: 1 / 0
      }, this.rules[64].opcodes[1] = {
        type: 1,
        children: [2, 3, 4]
      }, this.rules[64].opcodes[2] = {
        type: 5,
        min: 32,
        max: 38
      }, this.rules[64].opcodes[3] = {
        type: 5,
        min: 40,
        max: 126
      }, this.rules[64].opcodes[4] = {
        type: 4,
        index: 60
      }, this.rules[65].opcodes = [], this.rules[65].opcodes[0] = {
        type: 2,
        children: [1, 2, 3]
      }, this.rules[65].opcodes[1] = {
        type: 4,
        index: 66
      }, this.rules[65].opcodes[2] = {
        type: 4,
        index: 67
      }, this.rules[65].opcodes[3] = {
        type: 4,
        index: 68
      }, this.rules[66].opcodes = [], this.rules[66].opcodes[0] = {
        type: 6,
        string: [60]
      }, this.rules[67].opcodes = [], this.rules[67].opcodes[0] = {
        type: 3,
        min: 0,
        max: 1 / 0
      }, this.rules[67].opcodes[1] = {
        type: 1,
        children: [2, 3, 4]
      }, this.rules[67].opcodes[2] = {
        type: 5,
        min: 32,
        max: 61
      }, this.rules[67].opcodes[3] = {
        type: 5,
        min: 63,
        max: 126
      }, this.rules[67].opcodes[4] = {
        type: 4,
        index: 60
      }, this.rules[68].opcodes = [], this.rules[68].opcodes[0] = {
        type: 6,
        string: [62]
      }, this.rules[69].opcodes = [], this.rules[69].opcodes[0] = {
        type: 4,
        index: 72
      }, this.rules[70].opcodes = [], this.rules[70].opcodes[0] = {
        type: 4,
        index: 72
      }, this.rules[71].opcodes = [], this.rules[71].opcodes[0] = {
        type: 4,
        index: 72
      }, this.rules[72].opcodes = [], this.rules[72].opcodes[0] = {
        type: 3,
        min: 1,
        max: 1 / 0
      }, this.rules[72].opcodes[1] = {
        type: 5,
        min: 48,
        max: 57
      }, this.rules[73].opcodes = [], this.rules[73].opcodes[0] = {
        type: 4,
        index: 85
      }, this.rules[74].opcodes = [], this.rules[74].opcodes[0] = {
        type: 4,
        index: 87
      }, this.rules[75].opcodes = [], this.rules[75].opcodes[0] = {
        type: 4,
        index: 86
      }, this.rules[76].opcodes = [], this.rules[76].opcodes[0] = {
        type: 1,
        children: [1, 2]
      }, this.rules[76].opcodes[1] = {
        type: 6,
        string: [68]
      }, this.rules[76].opcodes[2] = {
        type: 6,
        string: [100]
      }, this.rules[77].opcodes = [], this.rules[77].opcodes[0] = {
        type: 1,
        children: [1, 2]
      }, this.rules[77].opcodes[1] = {
        type: 6,
        string: [88]
      }, this.rules[77].opcodes[2] = {
        type: 6,
        string: [120]
      }, this.rules[78].opcodes = [], this.rules[78].opcodes[0] = {
        type: 1,
        children: [1, 2]
      }, this.rules[78].opcodes[1] = {
        type: 6,
        string: [66]
      }, this.rules[78].opcodes[2] = {
        type: 6,
        string: [98]
      }, this.rules[79].opcodes = [], this.rules[79].opcodes[0] = {
        type: 4,
        index: 85
      }, this.rules[80].opcodes = [], this.rules[80].opcodes[0] = {
        type: 4,
        index: 85
      }, this.rules[81].opcodes = [], this.rules[81].opcodes[0] = {
        type: 4,
        index: 86
      }, this.rules[82].opcodes = [], this.rules[82].opcodes[0] = {
        type: 4,
        index: 86
      }, this.rules[83].opcodes = [], this.rules[83].opcodes[0] = {
        type: 4,
        index: 87
      }, this.rules[84].opcodes = [], this.rules[84].opcodes[0] = {
        type: 4,
        index: 87
      }, this.rules[85].opcodes = [], this.rules[85].opcodes[0] = {
        type: 3,
        min: 1,
        max: 1 / 0
      }, this.rules[85].opcodes[1] = {
        type: 5,
        min: 48,
        max: 57
      }, this.rules[86].opcodes = [], this.rules[86].opcodes[0] = {
        type: 3,
        min: 1,
        max: 1 / 0
      }, this.rules[86].opcodes[1] = {
        type: 5,
        min: 48,
        max: 49
      }, this.rules[87].opcodes = [], this.rules[87].opcodes[0] = {
        type: 3,
        min: 1,
        max: 1 / 0
      }, this.rules[87].opcodes[1] = {
        type: 1,
        children: [2, 3, 4]
      }, this.rules[87].opcodes[2] = {
        type: 5,
        min: 48,
        max: 57
      }, this.rules[87].opcodes[3] = {
        type: 5,
        min: 65,
        max: 70
      }, this.rules[87].opcodes[4] = {
        type: 5,
        min: 97,
        max: 102
      }, this.rules[88].opcodes = [], this.rules[88].opcodes[0] = {
        type: 2,
        children: [1, 4]
      }, this.rules[88].opcodes[1] = {
        type: 1,
        children: [2, 3]
      }, this.rules[88].opcodes[2] = {
        type: 5,
        min: 97,
        max: 122
      }, this.rules[88].opcodes[3] = {
        type: 5,
        min: 65,
        max: 90
      }, this.rules[88].opcodes[4] = {
        type: 3,
        min: 0,
        max: 1 / 0
      }, this.rules[88].opcodes[5] = {
        type: 1,
        children: [6, 7, 8, 9]
      }, this.rules[88].opcodes[6] = {
        type: 5,
        min: 97,
        max: 122
      }, this.rules[88].opcodes[7] = {
        type: 5,
        min: 65,
        max: 90
      }, this.rules[88].opcodes[8] = {
        type: 5,
        min: 48,
        max: 57
      }, this.rules[88].opcodes[9] = {
        type: 6,
        string: [45]
      }, this.rules[89].opcodes = [], this.rules[89].opcodes[0] = {
        type: 3,
        min: 0,
        max: 1 / 0
      }, this.rules[89].opcodes[1] = {
        type: 4,
        index: 91
      }, this.rules[90].opcodes = [], this.rules[90].opcodes[0] = {
        type: 3,
        min: 1,
        max: 1 / 0
      }, this.rules[90].opcodes[1] = {
        type: 4,
        index: 91
      }, this.rules[91].opcodes = [], this.rules[91].opcodes[0] = {
        type: 1,
        children: [1, 2, 3, 4]
      }, this.rules[91].opcodes[1] = {
        type: 6,
        string: [32]
      }, this.rules[91].opcodes[2] = {
        type: 6,
        string: [9]
      }, this.rules[91].opcodes[3] = {
        type: 4,
        index: 92
      }, this.rules[91].opcodes[4] = {
        type: 4,
        index: 94
      }, this.rules[92].opcodes = [], this.rules[92].opcodes[0] = {
        type: 2,
        children: [1, 2]
      }, this.rules[92].opcodes[1] = {
        type: 6,
        string: [59]
      }, this.rules[92].opcodes[2] = {
        type: 3,
        min: 0,
        max: 1 / 0
      }, this.rules[92].opcodes[3] = {
        type: 1,
        children: [4, 5]
      }, this.rules[92].opcodes[4] = {
        type: 5,
        min: 32,
        max: 126
      }, this.rules[92].opcodes[5] = {
        type: 6,
        string: [9]
      }, this.rules[93].opcodes = [], this.rules[93].opcodes[0] = {
        type: 1,
        children: [1, 2, 3]
      }, this.rules[93].opcodes[1] = {
        type: 6,
        string: [13, 10]
      }, this.rules[93].opcodes[2] = {
        type: 6,
        string: [10]
      }, this.rules[93].opcodes[3] = {
        type: 6,
        string: [13]
      }, this.rules[94].opcodes = [], this.rules[94].opcodes[0] = {
        type: 2,
        children: [1, 5]
      }, this.rules[94].opcodes[1] = {
        type: 1,
        children: [2, 3, 4]
      }, this.rules[94].opcodes[2] = {
        type: 6,
        string: [13, 10]
      }, this.rules[94].opcodes[3] = {
        type: 6,
        string: [10]
      }, this.rules[94].opcodes[4] = {
        type: 6,
        string: [13]
      }, this.rules[94].opcodes[5] = {
        type: 1,
        children: [6, 7]
      }, this.rules[94].opcodes[6] = {
        type: 6,
        string: [32]
      }, this.rules[94].opcodes[7] = {
        type: 6,
        string: [9]
      }, this.toString = function () {
        let e = "";
        return e += ";\n", e += "; ABNF for JavaScript APG 2.0 SABNF\n", e += "; RFC 5234 with some restrictions and additions.\n", e += "; Updated 11/24/2015 for RFC 7405 case-sensitive literal string notation\n", e += ';  - accepts %s"string" as a case-sensitive string\n', e += ';  - accepts %i"string" as a case-insensitive string\n', e += ';  - accepts "string" as a case-insensitive string\n', e += ";\n", e += "; Some restrictions:\n", e += ";   1. Rules must begin at first character of each line.\n", e += ";      Indentations on first rule and rules thereafter are not allowed.\n", e += ";   2. Relaxed line endings. CRLF, LF or CR are accepted as valid line ending.\n", e += ";   3. Prose values, i.e. <prose value>, are accepted as valid grammar syntax.\n", e += ";      However, a working parser cannot be generated from them.\n", e += ";\n", e += "; Super set (SABNF) additions:\n", e += ";   1. Look-ahead (syntactic predicate) operators are accepted as element prefixes.\n", e += ";      & is the positive look-ahead operator, succeeds and backtracks if the look-ahead phrase is found\n", e += ";      ! is the negative look-ahead operator, succeeds and backtracks if the look-ahead phrase is NOT found\n", e += ";      e.g. &%d13 or &rule or !(A / B)\n", e += ";   2. User-Defined Terminals (UDT) of the form, u_name and e_name are accepted.\n", e += ";      'name' is alpha followed by alpha/num/hyphen just like a rule name.\n", e += ";      u_name may be used as an element but no rule definition is given.\n", e += ";      e.g. rule = A / u_myUdt\n", e += ';           A = "a"\n', e += ";      would be a valid grammar.\n", e += ";   3. Case-sensitive, single-quoted strings are accepted.\n", e += ";      e.g. 'abc' would be equivalent to %d97.98.99\n", e += ';      (kept for backward compatibility, but superseded by %s"abc")  \n', e += "; New 12/26/2015\n", e += ";   4. Look-behind operators are accepted as element prefixes.\n", e += ";      && is the positive look-behind operator, succeeds and backtracks if the look-behind phrase is found\n", e += ";      !! is the negative look-behind operator, succeeds and backtracks if the look-behind phrase is NOT found\n", e += ";      e.g. &&%d13 or &&rule or !!(A / B)\n", e += ";   5. Back reference operators, i.e. \\rulename, are accepted.\n", e += ";      A back reference operator acts like a TLS or TBS terminal except that the phrase it attempts\n", e += ";      to match is a phrase previously matched by the rule 'rulename'.\n", e += ";      There are two modes of previous phrase matching - the parent-frame mode and the universal mode.\n", e += ";      In universal mode, \\rulename matches the last match to 'rulename' regardless of where it was found.\n", e += ";      In parent-frame mode, \\rulename matches only the last match found on the parent's frame or parse tree level.\n", e += ";      Back reference modifiers can be used to specify case and mode.\n", e += ";      \\A defaults to case-insensitive and universal mode, e.g. \\A === \\%i%uA\n", e += ";      Modifiers %i and %s determine case-insensitive and case-sensitive mode, respectively.\n", e += ";      Modifiers %u and %p determine universal mode and parent frame mode, respectively.\n", e += ";      Case and mode modifiers can appear in any order, e.g. \\%s%pA === \\%p%sA. \n", e += ";   7. String begin anchor, ABG(%^) matches the beginning of the input string location.\n", e += ";      Returns EMPTY or NOMATCH. Never consumes any characters.\n", e += ";   8. String end anchor, AEN(%$) matches the end of the input string location.\n", e += ";      Returns EMPTY or NOMATCH. Never consumes any characters.\n", e += ";\n", e += "File            = *(BlankLine / Rule / RuleError)\n", e += "BlankLine       = *(%d32/%d9) [comment] LineEnd\n", e += "Rule            = RuleLookup owsp Alternation ((owsp LineEnd)\n", e += "                / (LineEndError LineEnd))\n", e += "RuleLookup      = RuleNameTest owsp DefinedAsTest\n", e += "RuleNameTest    = RuleName/RuleNameError\n", e += "RuleName        = alphanum\n", e += "RuleNameError   = 1*(%d33-60/%d62-126)\n", e += "DefinedAsTest   = DefinedAs / DefinedAsError\n", e += "DefinedAsError  = 1*2%d33-126\n", e += "DefinedAs       = IncAlt / Defined\n", e += "Defined         = %d61\n", e += "IncAlt          = %d61.47\n", e += "RuleError       = 1*(%d32-126 / %d9  / LineContinue) LineEnd\n", e += "LineEndError    = 1*(%d32-126 / %d9  / LineContinue)\n", e += "Alternation     = Concatenation *(owsp AltOp Concatenation)\n", e += "Concatenation   = Repetition *(CatOp Repetition)\n", e += "Repetition      = [Modifier] (Group / Option / BasicElement / BasicElementErr)\n", e += "Modifier        = (Predicate [RepOp])\n", e += "                / RepOp\n", e += "Predicate       = BkaOp\n", e += "                / BknOp\n", e += "                / AndOp\n", e += "                / NotOp\n", e += "BasicElement    = UdtOp\n", e += "                / RnmOp\n", e += "                / TrgOp\n", e += "                / TbsOp\n", e += "                / TlsOp\n", e += "                / ClsOp\n", e += "                / BkrOp\n", e += "                / AbgOp\n", e += "                / AenOp\n", e += "                / ProsVal\n", e += "BasicElementErr = 1*(%d33-40/%d42-46/%d48-92/%d94-126)\n", e += "Group           = GroupOpen  Alternation (GroupClose / GroupError)\n", e += "GroupError      = 1*(%d33-40/%d42-46/%d48-92/%d94-126) ; same as BasicElementErr\n", e += "GroupOpen       = %d40 owsp\n", e += "GroupClose      = owsp %d41\n", e += "Option          = OptionOpen Alternation (OptionClose / OptionError)\n", e += "OptionError     = 1*(%d33-40/%d42-46/%d48-92/%d94-126) ; same as BasicElementErr\n", e += "OptionOpen      = %d91 owsp\n", e += "OptionClose     = owsp %d93\n", e += "RnmOp           = alphanum\n", e += "BkrOp           = %d92 [bkrModifier] bkr-name\n", e += "bkrModifier     = (cs [um / pm]) / (ci [um / pm]) / (um [cs /ci]) / (pm [cs / ci])\n", e += "cs              = '%s'\n", e += "ci              = '%i'\n", e += "um              = '%u'\n", e += "pm              = '%p'\n", e += "bkr-name        = uname / ename / rname\n", e += "rname           = alphanum\n", e += "uname           = %d117.95 alphanum\n", e += "ename           = %d101.95 alphanum\n", e += "UdtOp           = udt-empty\n", e += "                / udt-non-empty\n", e += "udt-non-empty   = %d117.95 alphanum\n", e += "udt-empty       = %d101.95 alphanum\n", e += "RepOp           = (rep-min StarOp rep-max)\n", e += "                / (rep-min StarOp)\n", e += "                / (StarOp rep-max)\n", e += "                / StarOp\n", e += "                / rep-min-max\n", e += "AltOp           = %d47 owsp\n", e += "CatOp           = wsp\n", e += "StarOp          = %d42\n", e += "AndOp           = %d38\n", e += "NotOp           = %d33\n", e += "BkaOp           = %d38.38\n", e += "BknOp           = %d33.33\n", e += "AbgOp           = %d37.94\n", e += "AenOp           = %d37.36\n", e += "TrgOp           = %d37 ((Dec dmin %d45 dmax) / (Hex xmin %d45 xmax) / (Bin bmin %d45 bmax))\n", e += "TbsOp           = %d37 ((Dec dString *(%d46 dString)) / (Hex xString *(%d46 xString)) / (Bin bString *(%d46 bString)))\n", e += "TlsOp           = TlsCase TlsOpen TlsString TlsClose\n", e += 'TlsCase         = ["%i" / "%s"]\n', e += "TlsOpen         = %d34\n", e += "TlsClose        = %d34\n", e += "TlsString       = *(%d32-33/%d35-126/StringTab)\n", e += "StringTab       = %d9\n", e += "ClsOp           = ClsOpen ClsString ClsClose\n", e += "ClsOpen         = %d39\n", e += "ClsClose        = %d39\n", e += "ClsString       = *(%d32-38/%d40-126/StringTab)\n", e += "ProsVal         = ProsValOpen ProsValString ProsValClose\n", e += "ProsValOpen     = %d60\n", e += "ProsValString   = *(%d32-61/%d63-126/StringTab)\n", e += "ProsValClose    = %d62\n", e += "rep-min         = rep-num\n", e += "rep-min-max     = rep-num\n", e += "rep-max         = rep-num\n", e += "rep-num         = 1*(%d48-57)\n", e += "dString         = dnum\n", e += "xString         = xnum\n", e += "bString         = bnum\n", e += "Dec             = (%d68/%d100)\n", e += "Hex             = (%d88/%d120)\n", e += "Bin             = (%d66/%d98)\n", e += "dmin            = dnum\n", e += "dmax            = dnum\n", e += "bmin            = bnum\n", e += "bmax            = bnum\n", e += "xmin            = xnum\n", e += "xmax            = xnum\n", e += "dnum            = 1*(%d48-57)\n", e += "bnum            = 1*%d48-49\n", e += "xnum            = 1*(%d48-57 / %d65-70 / %d97-102)\n", e += ";\n", e += "; Basics\n", e += "alphanum        = (%d97-122/%d65-90) *(%d97-122/%d65-90/%d48-57/%d45)\n", e += "owsp            = *space\n", e += "wsp             = 1*space\n", e += "space           = %d32\n", e += "                / %d9\n", e += "                / comment\n", e += "                / LineContinue\n", e += "comment         = %d59 *(%d32-126 / %d9)\n", e += "LineEnd         = %d13.10\n", e += "                / %d10\n", e += "                / %d13\n", e += "LineContinue    = (%d13.10 / %d10 / %d13) (%d32 / %d9)\n", ";\n; ABNF for JavaScript APG 2.0 SABNF\n; RFC 5234 with some restrictions and additions.\n; Updated 11/24/2015 for RFC 7405 case-sensitive literal string notation\n;  - accepts %s\"string\" as a case-sensitive string\n;  - accepts %i\"string\" as a case-insensitive string\n;  - accepts \"string\" as a case-insensitive string\n;\n; Some restrictions:\n;   1. Rules must begin at first character of each line.\n;      Indentations on first rule and rules thereafter are not allowed.\n;   2. Relaxed line endings. CRLF, LF or CR are accepted as valid line ending.\n;   3. Prose values, i.e. <prose value>, are accepted as valid grammar syntax.\n;      However, a working parser cannot be generated from them.\n;\n; Super set (SABNF) additions:\n;   1. Look-ahead (syntactic predicate) operators are accepted as element prefixes.\n;      & is the positive look-ahead operator, succeeds and backtracks if the look-ahead phrase is found\n;      ! is the negative look-ahead operator, succeeds and backtracks if the look-ahead phrase is NOT found\n;      e.g. &%d13 or &rule or !(A / B)\n;   2. User-Defined Terminals (UDT) of the form, u_name and e_name are accepted.\n;      'name' is alpha followed by alpha/num/hyphen just like a rule name.\n;      u_name may be used as an element but no rule definition is given.\n;      e.g. rule = A / u_myUdt\n;           A = \"a\"\n;      would be a valid grammar.\n;   3. Case-sensitive, single-quoted strings are accepted.\n;      e.g. 'abc' would be equivalent to %d97.98.99\n;      (kept for backward compatibility, but superseded by %s\"abc\")  \n; New 12/26/2015\n;   4. Look-behind operators are accepted as element prefixes.\n;      && is the positive look-behind operator, succeeds and backtracks if the look-behind phrase is found\n;      !! is the negative look-behind operator, succeeds and backtracks if the look-behind phrase is NOT found\n;      e.g. &&%d13 or &&rule or !!(A / B)\n;   5. Back reference operators, i.e. \\rulename, are accepted.\n;      A back reference operator acts like a TLS or TBS terminal except that the phrase it attempts\n;      to match is a phrase previously matched by the rule 'rulename'.\n;      There are two modes of previous phrase matching - the parent-frame mode and the universal mode.\n;      In universal mode, \\rulename matches the last match to 'rulename' regardless of where it was found.\n;      In parent-frame mode, \\rulename matches only the last match found on the parent's frame or parse tree level.\n;      Back reference modifiers can be used to specify case and mode.\n;      \\A defaults to case-insensitive and universal mode, e.g. \\A === \\%i%uA\n;      Modifiers %i and %s determine case-insensitive and case-sensitive mode, respectively.\n;      Modifiers %u and %p determine universal mode and parent frame mode, respectively.\n;      Case and mode modifiers can appear in any order, e.g. \\%s%pA === \\%p%sA. \n;   7. String begin anchor, ABG(%^) matches the beginning of the input string location.\n;      Returns EMPTY or NOMATCH. Never consumes any characters.\n;   8. String end anchor, AEN(%$) matches the end of the input string location.\n;      Returns EMPTY or NOMATCH. Never consumes any characters.\n;\nFile            = *(BlankLine / Rule / RuleError)\nBlankLine       = *(%d32/%d9) [comment] LineEnd\nRule            = RuleLookup owsp Alternation ((owsp LineEnd)\n                / (LineEndError LineEnd))\nRuleLookup      = RuleNameTest owsp DefinedAsTest\nRuleNameTest    = RuleName/RuleNameError\nRuleName        = alphanum\nRuleNameError   = 1*(%d33-60/%d62-126)\nDefinedAsTest   = DefinedAs / DefinedAsError\nDefinedAsError  = 1*2%d33-126\nDefinedAs       = IncAlt / Defined\nDefined         = %d61\nIncAlt          = %d61.47\nRuleError       = 1*(%d32-126 / %d9  / LineContinue) LineEnd\nLineEndError    = 1*(%d32-126 / %d9  / LineContinue)\nAlternation     = Concatenation *(owsp AltOp Concatenation)\nConcatenation   = Repetition *(CatOp Repetition)\nRepetition      = [Modifier] (Group / Option / BasicElement / BasicElementErr)\nModifier        = (Predicate [RepOp])\n                / RepOp\nPredicate       = BkaOp\n                / BknOp\n                / AndOp\n                / NotOp\nBasicElement    = UdtOp\n                / RnmOp\n                / TrgOp\n                / TbsOp\n                / TlsOp\n                / ClsOp\n                / BkrOp\n                / AbgOp\n                / AenOp\n                / ProsVal\nBasicElementErr = 1*(%d33-40/%d42-46/%d48-92/%d94-126)\nGroup           = GroupOpen  Alternation (GroupClose / GroupError)\nGroupError      = 1*(%d33-40/%d42-46/%d48-92/%d94-126) ; same as BasicElementErr\nGroupOpen       = %d40 owsp\nGroupClose      = owsp %d41\nOption          = OptionOpen Alternation (OptionClose / OptionError)\nOptionError     = 1*(%d33-40/%d42-46/%d48-92/%d94-126) ; same as BasicElementErr\nOptionOpen      = %d91 owsp\nOptionClose     = owsp %d93\nRnmOp           = alphanum\nBkrOp           = %d92 [bkrModifier] bkr-name\nbkrModifier     = (cs [um / pm]) / (ci [um / pm]) / (um [cs /ci]) / (pm [cs / ci])\ncs              = '%s'\nci              = '%i'\num              = '%u'\npm              = '%p'\nbkr-name        = uname / ename / rname\nrname           = alphanum\nuname           = %d117.95 alphanum\nename           = %d101.95 alphanum\nUdtOp           = udt-empty\n                / udt-non-empty\nudt-non-empty   = %d117.95 alphanum\nudt-empty       = %d101.95 alphanum\nRepOp           = (rep-min StarOp rep-max)\n                / (rep-min StarOp)\n                / (StarOp rep-max)\n                / StarOp\n                / rep-min-max\nAltOp           = %d47 owsp\nCatOp           = wsp\nStarOp          = %d42\nAndOp           = %d38\nNotOp           = %d33\nBkaOp           = %d38.38\nBknOp           = %d33.33\nAbgOp           = %d37.94\nAenOp           = %d37.36\nTrgOp           = %d37 ((Dec dmin %d45 dmax) / (Hex xmin %d45 xmax) / (Bin bmin %d45 bmax))\nTbsOp           = %d37 ((Dec dString *(%d46 dString)) / (Hex xString *(%d46 xString)) / (Bin bString *(%d46 bString)))\nTlsOp           = TlsCase TlsOpen TlsString TlsClose\nTlsCase         = [\"%i\" / \"%s\"]\nTlsOpen         = %d34\nTlsClose        = %d34\nTlsString       = *(%d32-33/%d35-126/StringTab)\nStringTab       = %d9\nClsOp           = ClsOpen ClsString ClsClose\nClsOpen         = %d39\nClsClose        = %d39\nClsString       = *(%d32-38/%d40-126/StringTab)\nProsVal         = ProsValOpen ProsValString ProsValClose\nProsValOpen     = %d60\nProsValString   = *(%d32-61/%d63-126/StringTab)\nProsValClose    = %d62\nrep-min         = rep-num\nrep-min-max     = rep-num\nrep-max         = rep-num\nrep-num         = 1*(%d48-57)\ndString         = dnum\nxString         = xnum\nbString         = bnum\nDec             = (%d68/%d100)\nHex             = (%d88/%d120)\nBin             = (%d66/%d98)\ndmin            = dnum\ndmax            = dnum\nbmin            = bnum\nbmax            = bnum\nxmin            = xnum\nxmax            = xnum\ndnum            = 1*(%d48-57)\nbnum            = 1*%d48-49\nxnum            = 1*(%d48-57 / %d65-70 / %d97-102)\n;\n; Basics\nalphanum        = (%d97-122/%d65-90) *(%d97-122/%d65-90/%d48-57/%d45)\nowsp            = *space\nwsp             = 1*space\nspace           = %d32\n                / %d9\n                / comment\n                / LineContinue\ncomment         = %d59 *(%d32-126 / %d9)\nLineEnd         = %d13.10\n                / %d10\n                / %d13\nLineContinue    = (%d13.10 / %d10 / %d13) (%d32 / %d9)\n";
      };
    };
  }, {}],
  10: [function (e, t, n) {
    const r = e("../apg-lib/identifiers"),
      s = e("../apg-lib/utilities");
    const i = [];
    i.line = function (e, t, n, s, i) {
      return e === r.SEM_PRE ? (i.endLength = 0, i.textLength = 0, i.invalidCount = 0) : i.lines.push({
        lineNo: i.lines.length,
        beginChar: n,
        length: s,
        textLength: i.textLength,
        endType: i.endType,
        invalidChars: i.invalidCount
      }), r.SEM_OK;
    }, i["line-text"] = function (e, t, n, s, i) {
      return e === r.SEM_PRE && (i.textLength = s), r.SEM_OK;
    }, i["last-line"] = function (e, t, n, s, i) {
      return e === r.SEM_PRE ? (i.endLength = 0, i.textLength = 0, i.invalidCount = 0) : i.strict ? (i.lines.push({
        lineNo: i.lines.length,
        beginChar: n,
        length: s,
        textLength: s,
        endType: "none",
        invalidChars: i.invalidCount
      }), i.errors.push({
        line: i.lineNo,
        char: n + s,
        msg: "no line end on last line - strict ABNF specifies CRLF(\\r\\n, \\x0D\\x0A)"
      })) : (t.push(10), i.lines.push({
        lineNo: i.lines.length,
        beginChar: n,
        length: s + 1,
        textLength: s,
        endType: "LF",
        invalidChars: i.invalidCount
      })), r.SEM_OK;
    }, i.invalid = function (e, t, n, i, o) {
      return e === r.SEM_PRE && o.errors.push({
        line: o.lineNo,
        char: n,
        msg: `invalid character found '\\x${s.charToHex(t[n])}'`
      }), r.SEM_OK;
    }, i.end = function (e, t, n, s, i) {
      return e === r.SEM_POST && (i.lineNo += 1), r.SEM_OK;
    }, i.lf = function (e, t, n, s, i) {
      return e === r.SEM_PRE && (i.endType = "LF", i.strict && i.errors.push({
        line: i.lineNo,
        char: n,
        msg: "line end character LF(\\n, \\x0A) - strict ABNF specifies CRLF(\\r\\n, \\x0D\\x0A)"
      })), r.SEM_OK;
    }, i.cr = function (e, t, n, s, i) {
      return e === r.SEM_PRE && (i.endType = "CR", i.strict && i.errors.push({
        line: i.lineNo,
        char: n,
        msg: "line end character CR(\\r, \\x0D) - strict ABNF specifies CRLF(\\r\\n, \\x0D\\x0A)"
      })), r.SEM_OK;
    }, i.crlf = function (e, t, n, s, i) {
      return e === r.SEM_PRE && (i.endType = "CRLF"), r.SEM_OK;
    }, n.callbacks = i;
  }, {
    "../apg-lib/identifiers": 23,
    "../apg-lib/utilities": 29
  }],
  11: [function (e, t, n) {
    t.exports = function () {
      this.grammarObject = "grammarObject", this.rules = [], this.rules[0] = {
        name: "file",
        lower: "file",
        index: 0,
        isBkr: !1
      }, this.rules[1] = {
        name: "line",
        lower: "line",
        index: 1,
        isBkr: !1
      }, this.rules[2] = {
        name: "line-text",
        lower: "line-text",
        index: 2,
        isBkr: !1
      }, this.rules[3] = {
        name: "last-line",
        lower: "last-line",
        index: 3,
        isBkr: !1
      }, this.rules[4] = {
        name: "valid",
        lower: "valid",
        index: 4,
        isBkr: !1
      }, this.rules[5] = {
        name: "invalid",
        lower: "invalid",
        index: 5,
        isBkr: !1
      }, this.rules[6] = {
        name: "end",
        lower: "end",
        index: 6,
        isBkr: !1
      }, this.rules[7] = {
        name: "CRLF",
        lower: "crlf",
        index: 7,
        isBkr: !1
      }, this.rules[8] = {
        name: "LF",
        lower: "lf",
        index: 8,
        isBkr: !1
      }, this.rules[9] = {
        name: "CR",
        lower: "cr",
        index: 9,
        isBkr: !1
      }, this.udts = [], this.rules[0].opcodes = [], this.rules[0].opcodes[0] = {
        type: 2,
        children: [1, 3]
      }, this.rules[0].opcodes[1] = {
        type: 3,
        min: 0,
        max: 1 / 0
      }, this.rules[0].opcodes[2] = {
        type: 4,
        index: 1
      }, this.rules[0].opcodes[3] = {
        type: 3,
        min: 0,
        max: 1
      }, this.rules[0].opcodes[4] = {
        type: 4,
        index: 3
      }, this.rules[1].opcodes = [], this.rules[1].opcodes[0] = {
        type: 2,
        children: [1, 2]
      }, this.rules[1].opcodes[1] = {
        type: 4,
        index: 2
      }, this.rules[1].opcodes[2] = {
        type: 4,
        index: 6
      }, this.rules[2].opcodes = [], this.rules[2].opcodes[0] = {
        type: 3,
        min: 0,
        max: 1 / 0
      }, this.rules[2].opcodes[1] = {
        type: 1,
        children: [2, 3]
      }, this.rules[2].opcodes[2] = {
        type: 4,
        index: 4
      }, this.rules[2].opcodes[3] = {
        type: 4,
        index: 5
      }, this.rules[3].opcodes = [], this.rules[3].opcodes[0] = {
        type: 3,
        min: 1,
        max: 1 / 0
      }, this.rules[3].opcodes[1] = {
        type: 1,
        children: [2, 3]
      }, this.rules[3].opcodes[2] = {
        type: 4,
        index: 4
      }, this.rules[3].opcodes[3] = {
        type: 4,
        index: 5
      }, this.rules[4].opcodes = [], this.rules[4].opcodes[0] = {
        type: 1,
        children: [1, 2]
      }, this.rules[4].opcodes[1] = {
        type: 5,
        min: 32,
        max: 126
      }, this.rules[4].opcodes[2] = {
        type: 6,
        string: [9]
      }, this.rules[5].opcodes = [], this.rules[5].opcodes[0] = {
        type: 1,
        children: [1, 2, 3, 4]
      }, this.rules[5].opcodes[1] = {
        type: 5,
        min: 0,
        max: 8
      }, this.rules[5].opcodes[2] = {
        type: 5,
        min: 11,
        max: 12
      }, this.rules[5].opcodes[3] = {
        type: 5,
        min: 14,
        max: 31
      }, this.rules[5].opcodes[4] = {
        type: 5,
        min: 127,
        max: 4294967295
      }, this.rules[6].opcodes = [], this.rules[6].opcodes[0] = {
        type: 1,
        children: [1, 2, 3]
      }, this.rules[6].opcodes[1] = {
        type: 4,
        index: 7
      }, this.rules[6].opcodes[2] = {
        type: 4,
        index: 8
      }, this.rules[6].opcodes[3] = {
        type: 4,
        index: 9
      }, this.rules[7].opcodes = [], this.rules[7].opcodes[0] = {
        type: 6,
        string: [13, 10]
      }, this.rules[8].opcodes = [], this.rules[8].opcodes[0] = {
        type: 6,
        string: [10]
      }, this.rules[9].opcodes = [], this.rules[9].opcodes[0] = {
        type: 6,
        string: [13]
      }, this.toString = function () {
        let e = "";
        return e += "file = *line [last-line]\n", e += "line = line-text end\n", e += "line-text = *(valid/invalid)\n", e += "last-line = 1*(valid/invalid)\n", e += "valid = %d32-126 / %d9\n", e += "invalid = %d0-8 / %d11-12 /%d14-31 / %x7f-ffffffff\n", e += "end = CRLF / LF / CR\n", e += "CRLF = %d13.10\n", e += "LF = %d10\n", e += "CR = %d13\n", "file = *line [last-line]\nline = line-text end\nline-text = *(valid/invalid)\nlast-line = 1*(valid/invalid)\nvalid = %d32-126 / %d9\ninvalid = %d0-8 / %d11-12 /%d14-31 / %x7f-ffffffff\nend = CRLF / LF / CR\nCRLF = %d13.10\nLF = %d10\nCR = %d13\n";
      };
    };
  }, {}],
  12: [function (e, t, n) {
    t.exports = function (t, n, r, s) {
      const i = e("../apg-lib/node-exports"),
        o = new (e("./scanner-grammar"))(),
        {
          callbacks: a
        } = e("./scanner-callbacks"),
        l = [],
        c = new i.parser();
      if (c.ast = new i.ast(), c.ast.callbacks = a, s) {
        if ("traceObject" !== s.traceObject) throw new TypeError("scanner.js: trace argument is not a trace object");
        c.trace = s;
      }
      if (!0 !== c.parse(o, "file", t).success) return void n.push({
        line: 0,
        char: 0,
        msg: "syntax analysis error analyzing input SABNF grammar"
      });
      const p = {
        lines: l,
        lineNo: 0,
        errors: n,
        strict: !!r
      };
      return c.ast.translate(p), l;
    };
  }, {
    "../apg-lib/node-exports": 24,
    "./scanner-callbacks": 10,
    "./scanner-grammar": 11
  }],
  13: [function (e, t, n) {
    t.exports = function () {
      const t = e("../apg-lib/node-exports"),
        n = t.ids,
        r = function () {
          this.names = [], this.add = function (e) {
            let t = -1;
            return -1 === this.get(e) && (t = {
              name: e,
              lower: e.toLowerCase(),
              index: this.names.length
            }, this.names.push(t)), t;
          }, this.get = function (e) {
            let t = -1;
            const n = e.toLowerCase();
            for (let e = 0; e < this.names.length; e += 1) if (this.names[e].lower === n) {
              t = this.names[e];
              break;
            }
            return t;
          };
        },
        s = function (e, t, n) {
          let r = 0;
          for (let s = t; s < t + n; s += 1) r = 10 * r + e[s] - 48;
          return r;
        },
        i = function (e, t, n) {
          let r = 0;
          for (let s = t; s < t + n; s += 1) r = 2 * r + e[s] - 48;
          return r;
        },
        o = function (e, t, n) {
          let r = 0;
          for (let s = t; s < t + n; s += 1) {
            let t = e[s];
            if (t >= 48 && t <= 57) t -= 48;else if (t >= 65 && t <= 70) t -= 55;else {
              if (!(t >= 97 && t <= 102)) throw new Error("hexnum out of range");
              t -= 87;
            }
            r = 16 * r + t;
          }
          return r;
        };
      this.callbacks = [], this.callbacks.abgop = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_POST && i.opcodes.push({
          type: n.ABG
        }), o;
      }, this.callbacks.aenop = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_POST && i.opcodes.push({
          type: n.AEN
        }), o;
      }, this.callbacks.alternation = function (e, t, r, s, i) {
        let o = n.SEM_OK;
        if (e === n.SEM_PRE) {
          const e = !0;
          for (; e;) {
            if (null === i.definedas) {
              o = n.SEM_SKIP;
              break;
            }
            if (null === i.topStack) {
              if ("=" === i.definedas) {
                i.topStack = {
                  alt: {
                    type: n.ALT,
                    children: []
                  },
                  cat: null
                }, i.altStack.push(i.topStack), i.opcodes.push(i.topStack.alt);
                break;
              }
              i.topStack = {
                alt: i.opcodes[0],
                cat: null
              }, i.altStack.push(i.topStack);
              break;
            }
            i.topStack = {
              alt: {
                type: n.ALT,
                children: []
              },
              cat: null
            }, i.altStack.push(i.topStack), i.opcodes.push(i.topStack.alt);
            break;
          }
        } else e === n.SEM_POST && (i.altStack.pop(), i.altStack.length > 0 ? i.topStack = i.altStack[i.altStack.length - 1] : i.topStack = null);
        return o;
      }, this.callbacks.andop = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_POST && i.opcodes.push({
          type: n.AND
        }), o;
      }, this.callbacks.bmax = function (e, t, r, s, o) {
        const a = n.SEM_OK;
        return e === n.SEM_POST && (o.max = i(t, r, s)), a;
      }, this.callbacks.bmin = function (e, t, r, s, o) {
        const a = n.SEM_OK;
        return e === n.SEM_POST && (o.min = i(t, r, s)), a;
      }, this.callbacks.bkaop = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_POST && i.opcodes.push({
          type: n.BKA
        }), o;
      }, this.callbacks.bknop = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_POST && i.opcodes.push({
          type: n.BKN
        }), o;
      }, this.callbacks.bkrop = function (e, r, s, i, o) {
        const a = n.SEM_OK;
        return e === n.SEM_PRE ? (o.ci = !0, o.cs = !1, o.um = !0, o.pm = !1) : e === n.SEM_POST && o.opcodes.push({
          type: n.BKR,
          bkrCase: !0 === o.cs ? n.BKR_MODE_CS : n.BKR_MODE_CI,
          bkrMode: !0 === o.pm ? n.BKR_MODE_PM : n.BKR_MODE_UM,
          index: {
            phraseIndex: o.bkrname.phraseIndex,
            name: t.utils.charsToString(r, o.bkrname.phraseIndex, o.bkrname.phraseLength)
          }
        }), a;
      }, this.callbacks["bkr-name"] = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_POST && (i.bkrname = {
          phraseIndex: r,
          phraseLength: s
        }), o;
      }, this.callbacks.bstring = function (e, t, r, s, o) {
        const a = n.SEM_OK;
        return e === n.SEM_POST && o.tbsstr.push(i(t, r, s)), a;
      }, this.callbacks.clsop = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_POST && (s <= 2 ? i.opcodes.push({
          type: n.TLS,
          string: []
        }) : i.opcodes.push({
          type: n.TBS,
          string: t.slice(r + 1, r + s - 1)
        })), o;
      }, this.callbacks.ci = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_POST && (i.ci = !0), o;
      }, this.callbacks.cs = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_POST && (i.cs = !0), o;
      }, this.callbacks.um = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_POST && (i.um = !0), o;
      }, this.callbacks.pm = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_POST && (i.pm = !0), o;
      }, this.callbacks.concatenation = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_PRE ? (i.topStack.alt.children.push(i.opcodes.length), i.topStack.cat = {
          type: n.CAT,
          children: []
        }, i.opcodes.push(i.topStack.cat)) : e === n.SEM_POST && (i.topStack.cat = null), o;
      }, this.callbacks.defined = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_POST && (i.definedas = "="), o;
      }, this.callbacks.dmax = function (e, t, r, i, o) {
        const a = n.SEM_OK;
        return e === n.SEM_POST && (o.max = s(t, r, i)), a;
      }, this.callbacks.dmin = function (e, t, r, i, o) {
        const a = n.SEM_OK;
        return e === n.SEM_POST && (o.min = s(t, r, i)), a;
      }, this.callbacks.dstring = function (e, t, r, i, o) {
        const a = n.SEM_OK;
        return e === n.SEM_POST && o.tbsstr.push(s(t, r, i)), a;
      }, this.callbacks.file = function (e, t, s, i, o) {
        const a = n.SEM_OK;
        if (e === n.SEM_PRE) o.ruleNames = new r(), o.udtNames = new r(), o.rules = [], o.udts = [], o.rulesLineMap = [], o.opcodes = [], o.altStack = [], o.topStack = null, o.topRule = null;else if (e === n.SEM_POST) {
          let e;
          o.rules.forEach(t => {
            t.isBkr = !1, t.opcodes.forEach(t => {
              t.type === n.RNM && (e = o.ruleNames.get(t.index.name), -1 === e ? (o.errors.push({
                line: o.findLine(o.lines, t.index.phraseIndex, o.charsLength),
                char: t.index.phraseIndex,
                msg: `Rule name '${t.index.name}' used but not defined.`
              }), t.index = -1) : t.index = e.index);
            });
          }), o.udts.forEach(e => {
            e.isBkr = !1;
          }), o.rules.forEach(t => {
            t.opcodes.forEach(r => {
              r.type === n.BKR && (t.hasBkr = !0, e = o.ruleNames.get(r.index.name), -1 !== e ? (o.rules[e.index].isBkr = !0, r.index = e.index) : (e = o.udtNames.get(r.index.name), -1 !== e ? (o.udts[e.index].isBkr = !0, r.index = o.rules.length + e.index) : (o.errors.push({
                line: o.findLine(o.lines, r.index.phraseIndex, o.charsLength),
                char: r.index.phraseIndex,
                msg: `Back reference name '${r.index.name}' refers to undefined rule or unamed UDT.`
              }), r.index = -1)));
            });
          });
        }
        return a;
      }, this.callbacks.incalt = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_POST && (i.definedas = "=/"), o;
      }, this.callbacks.notop = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_POST && i.opcodes.push({
          type: n.NOT
        }), o;
      }, this.callbacks.optionopen = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_POST && i.opcodes.push({
          type: n.REP,
          min: 0,
          max: 1,
          char: r
        }), o;
      }, this.callbacks["rep-max"] = function (e, t, r, i, o) {
        const a = n.SEM_OK;
        return e === n.SEM_POST && (o.max = s(t, r, i)), a;
      }, this.callbacks["rep-min"] = function (e, t, r, i, o) {
        const a = n.SEM_OK;
        return e === n.SEM_POST && (o.min = s(t, r, i)), a;
      }, this.callbacks["rep-min-max"] = function (e, t, r, i, o) {
        const a = n.SEM_OK;
        return e === n.SEM_POST && (o.max = s(t, r, i), o.min = o.max), a;
      }, this.callbacks.repetition = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_PRE && i.topStack.cat.children.push(i.opcodes.length), o;
      }, this.callbacks.repop = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_PRE ? (i.min = 0, i.max = 1 / 0, i.topRep = {
          type: n.REP,
          min: 0,
          max: 1 / 0
        }, i.opcodes.push(i.topRep)) : e === n.SEM_POST && (i.min > i.max && i.errors.push({
          line: i.findLine(i.lines, r, i.charsLength),
          char: r,
          msg: `repetition min cannot be greater than max: min: ${i.min}: max: ${i.max}`
        }), i.topRep.min = i.min, i.topRep.max = i.max), o;
      }, this.callbacks.rnmop = function (e, r, s, i, o) {
        const a = n.SEM_OK;
        return e === n.SEM_POST && o.opcodes.push({
          type: n.RNM,
          index: {
            phraseIndex: s,
            name: t.utils.charsToString(r, s, i)
          }
        }), a;
      }, this.callbacks.rule = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_PRE && (i.altStack.length = 0, i.topStack = null, i.rulesLineMap.push({
          line: i.findLine(i.lines, r, i.charsLength),
          char: r
        })), o;
      }, this.callbacks.rulelookup = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        if (e === n.SEM_PRE) i.ruleName = "", i.definedas = "";else if (e === n.SEM_POST) {
          let e;
          "=" === i.definedas ? (e = i.ruleNames.add(i.ruleName), -1 === e ? (i.definedas = null, i.errors.push({
            line: i.findLine(i.lines, r, i.charsLength),
            char: r,
            msg: `Rule name '${i.ruleName}' previously defined.`
          })) : (i.topRule = {
            name: e.name,
            lower: e.lower,
            opcodes: [],
            index: e.index
          }, i.rules.push(i.topRule), i.opcodes = i.topRule.opcodes)) : (e = i.ruleNames.get(i.ruleName), -1 === e ? (i.definedas = null, i.errors.push({
            line: i.findLine(i.lines, r, i.charsLength),
            char: r,
            msg: `Rule name '${i.ruleName}' for incremental alternate not previously defined.`
          })) : (i.topRule = i.rules[e.index], i.opcodes = i.topRule.opcodes));
        }
        return o;
      }, this.callbacks.rulename = function (e, r, s, i, o) {
        const a = n.SEM_OK;
        return e === n.SEM_PRE && (o.ruleName = t.utils.charsToString(r, s, i)), a;
      }, this.callbacks.tbsop = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_PRE ? i.tbsstr = [] : e === n.SEM_POST && i.opcodes.push({
          type: n.TBS,
          string: i.tbsstr
        }), o;
      }, this.callbacks.tlscase = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_POST && s > 0 && (83 === t[r + 1] || 115 === t[r + 1]) && (i.tlscase = !1), o;
      }, this.callbacks.tlsstring = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        if (e === n.SEM_POST) if (i.tlscase) {
          const e = t.slice(r, r + s);
          for (let t = 0; t < e.length; t += 1) e[t] >= 65 && e[t] <= 90 && (e[t] += 32);
          i.opcodes.push({
            type: n.TLS,
            string: e
          });
        } else i.opcodes.push({
          type: n.TBS,
          string: t.slice(r, r + s)
        });
        return o;
      }, this.callbacks.tlsop = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_PRE && (i.tlscase = !0), o;
      }, this.callbacks.trgop = function (e, t, r, s, i) {
        const o = n.SEM_OK;
        return e === n.SEM_PRE ? (i.min = 0, i.max = 0) : e === n.SEM_POST && (i.min > i.max && i.errors.push({
          line: i.findLine(i.lines, r, i.charsLength),
          char: r,
          msg: `TRG, (%dmin-max), min cannot be greater than max: min: ${i.min}: max: ${i.max}`
        }), i.opcodes.push({
          type: n.TRG,
          min: i.min,
          max: i.max
        })), o;
      }, this.callbacks["udt-empty"] = function (e, r, s, i, o) {
        const a = n.SEM_OK;
        if (e === n.SEM_POST) {
          const e = t.utils.charsToString(r, s, i);
          let a = o.udtNames.add(e);
          if (-1 === a) {
            if (a = o.udtNames.get(e), -1 === a) throw new Error("semUdtEmpty: name look up error");
          } else o.udts.push({
            name: a.name,
            lower: a.lower,
            index: a.index,
            empty: !0
          });
          o.opcodes.push({
            type: n.UDT,
            empty: !0,
            index: a.index
          });
        }
        return a;
      }, this.callbacks["udt-non-empty"] = function (e, r, s, i, o) {
        const a = n.SEM_OK;
        if (e === n.SEM_POST) {
          const e = t.utils.charsToString(r, s, i);
          let a = o.udtNames.add(e);
          if (-1 === a) {
            if (a = o.udtNames.get(e), -1 === a) throw new Error("semUdtNonEmpty: name look up error");
          } else o.udts.push({
            name: a.name,
            lower: a.lower,
            index: a.index,
            empty: !1
          });
          o.opcodes.push({
            type: n.UDT,
            empty: !1,
            index: a.index,
            syntax: null,
            semantic: null
          });
        }
        return a;
      }, this.callbacks.xmax = function (e, t, r, s, i) {
        const a = n.SEM_OK;
        return e === n.SEM_POST && (i.max = o(t, r, s)), a;
      }, this.callbacks.xmin = function (e, t, r, s, i) {
        const a = n.SEM_OK;
        return e === n.SEM_POST && (i.min = o(t, r, s)), a;
      }, this.callbacks.xstring = function (e, t, r, s, i) {
        const a = n.SEM_OK;
        return e === n.SEM_POST && i.tbsstr.push(o(t, r, s)), a;
      };
    };
  }, {
    "../apg-lib/node-exports": 24
  }],
  14: [function (e, t, n) {
    t.exports = function () {
      const e = "show-rules.js";
      return function () {
        let t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        let r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "index";
        const s = "showRules";
        let i = [],
          o = [];
        const a = [],
          l = [],
          c = t,
          p = n,
          h = t.length,
          u = n.length;
        let d,
          f = "RULE/UDT NAMES";
        if (!Array.isArray(t) || !t.length) throw new Error(`${e}:${s}: rules arg must be array with length > 0`);
        if (!Array.isArray(n)) throw new Error(`${e}:${s}: udts arg must be array`);
        for (d = 0; d < h; d += 1) a.push(d);
        if (i = a.slice(0), i.sort(function (e, t) {
          return c[e].lower < c[t].lower ? -1 : c[e].lower > c[t].lower ? 1 : 0;
        }), u) {
          for (d = 0; d < u; d += 1) l.push(d);
          o = l.slice(0), o.sort(function (e, t) {
            return p[e].lower < p[t].lower ? -1 : p[e].lower > p[t].lower ? 1 : 0;
          });
        }
        if (97 === r.charCodeAt(0)) {
          for (f += " - alphabetical by rule/UDT name\n", d = 0; d < h; d += 1) f += `${d}: ${i[d]}: ${c[i[d]].name}\n`;
          if (u) for (d = 0; d < u; d += 1) f += `${d}: ${o[d]}: ${p[o[d]].name}\n`;
        } else {
          for (f += " - ordered by rule/UDT index\n", d = 0; d < h; d += 1) f += `${d}: ${c[d].name}\n`;
          if (u) for (d = 0; d < u; d += 1) f += `${d}: ${p[d].name}\n`;
        }
        return f;
      };
    }();
  }, {}],
  15: [function (e, t, n) {
    t.exports = function () {
      const t = "syntax-callbacks.js: ",
        n = e("../apg-lib/node-exports"),
        r = n.ids;
      let s;
      this.callbacks = [], this.callbacks.andop = function (e, n, s, i) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            i.strict && i.errors.push({
              line: i.findLine(i.lines, s, i.charsLength),
              char: s,
              msg: "AND operator(&) found - strict ABNF specified."
            });
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.basicelementerr = function (e, n, i, o) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            !1 === s.basicError && o.errors.push({
              line: o.findLine(o.lines, i, o.charsLength),
              char: i,
              msg: "Unrecognized SABNF element."
            });
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.clsclose = function (e, n, i, o) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
            break;
          case r.NOMATCH:
            o.errors.push({
              line: o.findLine(o.lines, s.clsOpen),
              char: s.clsOpen,
              msg: "Case-sensitive literal string('...') opened but not closed."
            }), s.clsOpen = null, s.basicError = !0;
            break;
          case r.MATCH:
            o.strict && o.errors.push({
              line: o.findLine(o.lines, s.clsOpen),
              char: s.clsOpen,
              msg: "Case-sensitive string operator('...') found - strict ABNF specified."
            }), s.clsOpen = null;
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.clsopen = function (e, n, i) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            s.clsOpen = i;
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.clsstring = function (e, n, s, i) {
        switch (e.state) {
          case r.ACTIVE:
            i.stringTabChar = !1;
            break;
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            !1 !== i.stringTabChar && i.errors.push({
              line: i.findLine(i.lines, i.stringTabChar),
              char: i.stringTabChar,
              msg: "Tab character (\\t, x09) not allowed in literal string."
            });
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.definedaserror = function (e, n, s, i) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            i.errors.push({
              line: i.findLine(i.lines, s, i.charsLength),
              char: s,
              msg: "Expected '=' or '=/'. Not found."
            });
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.file = function (e, n, s, i) {
        switch (e.state) {
          case r.ACTIVE:
            i.altStack = [], i.repCount = 0;
            break;
          case r.EMPTY:
            i.errors.push({
              line: 0,
              char: 0,
              msg: "grammar file is empty"
            });
            break;
          case r.MATCH:
            0 === i.ruleCount && i.errors.push({
              line: 0,
              char: 0,
              msg: "no rules defined"
            });
            break;
          case r.NOMATCH:
            throw new Error(`${t}synFile: grammar file NOMATCH: design error: should never happen.`);
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.groupclose = function (e, n, i, o) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
            break;
          case r.NOMATCH:
            o.errors.push({
              line: o.findLine(o.lines, s.groupOpen),
              char: s.groupOpen,
              msg: 'Group "(...)" opened but not closed.'
            }), s = o.altStack.pop(), s.groupError = !0;
            break;
          case r.MATCH:
            s = o.altStack.pop();
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.groupopen = function (e, n, i, o) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            s = {
              groupOpen: i,
              groupError: !1,
              optionOpen: null,
              optionError: !1,
              tlsOpen: null,
              clsOpen: null,
              prosValOpen: null,
              basicError: !1
            }, o.altStack.push(s);
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.lineenderror = function (e, n, s, i) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            i.errors.push({
              line: i.findLine(i.lines, s, i.charsLength),
              char: s,
              msg: "Unrecognized grammar element or characters."
            });
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.lineend = function (e, n, s, i) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            if (1 === e.phraseLength && i.strict) {
              const e = 13 === n[s] ? "CR" : "LF";
              i.errors.push({
                line: i.findLine(i.lines, s, i.charsLength),
                char: s,
                msg: `Line end '${e}' found - strict ABNF specified, only CRLF allowed.`
              });
            }
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.notop = function (e, n, s, i) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            i.strict && i.errors.push({
              line: i.findLine(i.lines, s, i.charsLength),
              char: s,
              msg: "NOT operator(!) found - strict ABNF specified."
            });
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.optionclose = function (e, n, i, o) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
            break;
          case r.NOMATCH:
            o.errors.push({
              line: o.findLine(o.lines, s.optionOpen),
              char: s.optionOpen,
              msg: 'Option "[...]" opened but not closed.'
            }), s = o.altStack.pop(), s.optionError = !0;
            break;
          case r.MATCH:
            s = o.altStack.pop();
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.optionopen = function (e, n, i, o) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            s = {
              groupOpen: null,
              groupError: !1,
              optionOpen: i,
              optionError: !1,
              tlsOpen: null,
              clsOpen: null,
              prosValOpen: null,
              basicError: !1
            }, o.altStack.push(s);
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.prosvalclose = function (e, n, i, o) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
            break;
          case r.NOMATCH:
            o.errors.push({
              line: o.findLine(o.lines, s.prosValOpen),
              char: s.prosValOpen,
              msg: "Prose value operator(<...>) opened but not closed."
            }), s.basicError = !0, s.prosValOpen = null;
            break;
          case r.MATCH:
            o.errors.push({
              line: o.findLine(o.lines, s.prosValOpen),
              char: s.prosValOpen,
              msg: "Prose value operator(<...>) found. The ABNF syntax is valid, but a parser cannot be generated from this grammar."
            }), s.prosValOpen = null;
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.prosvalopen = function (e, n, i) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            s.prosValOpen = i;
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.prosvalstring = function (e, n, s, i) {
        switch (e.state) {
          case r.ACTIVE:
            i.stringTabChar = !1;
            break;
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            !1 !== i.stringTabChar && i.errors.push({
              line: i.findLine(i.lines, i.stringTabChar),
              char: i.stringTabChar,
              msg: "Tab character (\\t, x09) not allowed in prose value string."
            });
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.repetition = function (e, n, s, i) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
            break;
          case r.NOMATCH:
          case r.MATCH:
            i.repCount += 1;
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.rule = function (e, n, i, o) {
        switch (e.state) {
          case r.ACTIVE:
            o.altStack.length = 0, s = {
              groupOpen: null,
              groupError: !1,
              optionOpen: null,
              optionError: !1,
              tlsOpen: null,
              clsOpen: null,
              prosValOpen: null,
              basicError: !1
            }, o.altStack.push(s);
            break;
          case r.EMPTY:
            throw new Error(`${t}synRule: EMPTY: rule cannot be empty`);
          case r.NOMATCH:
            break;
          case r.MATCH:
            o.ruleCount += 1;
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.ruleerror = function (e, n, s, i) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            i.errors.push({
              line: i.findLine(i.lines, s, i.charsLength),
              char: s,
              msg: "Unrecognized SABNF line. Invalid rule, comment or blank line."
            });
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.rulenameerror = function (e, n, s, i) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            i.errors.push({
              line: i.findLine(i.lines, s, i.charsLength),
              char: s,
              msg: "Rule names must be alphanum and begin with alphabetic character."
            });
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.stringtab = function (e, n, s, i) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            i.stringTabChar = s;
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.tlsclose = function (e, n, i, o) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
            break;
          case r.NOMATCH:
            o.errors.push({
              line: o.findLine(o.lines, s.tlsOpen),
              char: s.tlsOpen,
              msg: 'Case-insensitive literal string("...") opened but not closed.'
            }), s.basicError = !0, s.tlsOpen = null;
            break;
          case r.MATCH:
            s.tlsOpen = null;
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.tlsopen = function (e, n, i) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            s.tlsOpen = i;
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.tlsstring = function (e, n, s, i) {
        switch (e.state) {
          case r.ACTIVE:
            i.stringTabChar = !1;
            break;
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            !1 !== i.stringTabChar && i.errors.push({
              line: i.findLine(i.lines, i.stringTabChar),
              char: i.stringTabChar,
              msg: "Tab character (\\t, x09) not allowed in literal string (see 'quoted-string' definition, RFC 7405.)"
            });
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.udtop = function (e, s, i, o) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            if (o.strict) {
              const t = n.utils.charsToString(s, i, e.phraseLength);
              o.errors.push({
                line: o.findLine(o.lines, i, o.charsLength),
                char: i,
                msg: `UDT operator found(${t}) - strict ABNF specified.`
              });
            }
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.bkaop = function (e, n, s, i) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            i.strict ? i.errors.push({
              line: i.findLine(i.lines, s, i.charsLength),
              char: s,
              msg: "Positive look-behind operator(&&) found - strict ABNF specified."
            }) : i.lite && i.errors.push({
              line: i.findLine(i.lines, s, i.charsLength),
              char: s,
              msg: "Positive look-behind operator(&&) found - apg-lite specified."
            });
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.bknop = function (e, n, s, i) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            i.strict ? i.errors.push({
              line: i.findLine(i.lines, s, i.charsLength),
              char: s,
              msg: "Negative look-behind operator(!!) found - strict ABNF specified."
            }) : i.lite && i.errors.push({
              line: i.findLine(i.lines, s, i.charsLength),
              char: s,
              msg: "Negative look-behind operator(!!) found - apg-lite specified."
            });
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.bkrop = function (e, s, i, o) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            if (o.strict) {
              const t = n.utils.charsToString(s, i, e.phraseLength);
              o.errors.push({
                line: o.findLine(o.lines, i, o.charsLength),
                char: i,
                msg: `Back reference operator(${t}) found - strict ABNF specified.`
              });
            } else if (o.lite) {
              const t = n.utils.charsToString(s, i, e.phraseLength);
              o.errors.push({
                line: o.findLine(o.lines, i, o.charsLength),
                char: i,
                msg: `Back reference operator(${t}) found - apg-lite specified.`
              });
            }
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.abgop = function (e, n, s, i) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            i.strict ? i.errors.push({
              line: i.findLine(i.lines, s, i.charsLength),
              char: s,
              msg: "Beginning of string anchor(%^) found - strict ABNF specified."
            }) : i.lite && i.errors.push({
              line: i.findLine(i.lines, s, i.charsLength),
              char: s,
              msg: "Beginning of string anchor(%^) found - apg-lite specified."
            });
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      }, this.callbacks.aenop = function (e, n, s, i) {
        switch (e.state) {
          case r.ACTIVE:
          case r.EMPTY:
          case r.NOMATCH:
            break;
          case r.MATCH:
            i.strict ? i.errors.push({
              line: i.findLine(i.lines, s, i.charsLength),
              char: s,
              msg: "End of string anchor(%$) found - strict ABNF specified."
            }) : i.lite && i.errors.push({
              line: i.findLine(i.lines, s, i.charsLength),
              char: s,
              msg: "End of string anchor(%$) found - apg-lite specified."
            });
            break;
          default:
            throw new Error(`${t}synFile: unrecognized case.`);
        }
      };
    };
  }, {
    "../apg-lib/node-exports": 24
  }],
  16: [function (e, t, n) {
    globalThis.apgApi = e("./api"), globalThis.apgLib = e("../apg-lib/node-exports"), globalThis.apgConvApi = e("../apg-conv-api/node-exports");
  }, {
    "../apg-conv-api/node-exports": 18,
    "../apg-lib/node-exports": 24,
    "./api": 4
  }],
  17: [function (e, t, n) {
    const {
        Buffer: r
      } = e("buffer"),
      s = e("./transformers"),
      i = "UTF8",
      o = "UTF16",
      a = "UTF16BE",
      l = "UTF16LE",
      c = "UTF32",
      p = "UTF32BE",
      h = "UTF32LE",
      u = "UINT7",
      d = "ASCII",
      f = "BINARY",
      g = "UINT8",
      m = "UINT16",
      b = "UINT16LE",
      y = "UINT16BE",
      T = "UINT32",
      E = "UINT32LE",
      x = "UINT32BE",
      w = "ESCAPED",
      A = "STRING",
      k = function (e, t) {
        const n = function (e) {
          const t = {
              type: "",
              base64: !1
            },
            n = /^(base64:)?([a-zA-Z0-9]+)$/i.exec(e);
          return n && (n[2] && (t.type = n[2].toUpperCase()), n[1] && (t.base64 = !0)), t;
        }(e.toUpperCase());
        if (n.base64) {
          if (n.type === A) throw new TypeError(`type: "${e} "BASE64:" prefix not allowed with type ${A}`);
          if (r.isBuffer(t)) n.data = s.base64.decode(t);else {
            if ("string" != typeof t) throw new TypeError(`type: "${e} unrecognized data type: typeof(data): ${typeof t}`);
            {
              const e = r.from(t, "ascii");
              n.data = s.base64.decode(e);
            }
          }
        } else n.data = t;
        switch (n.type) {
          case i:
            !function (e) {
              e.type = i;
              const t = e.data;
              e.bom = 0, t.length >= 3 && 239 === t[0] && 187 === t[1] && 191 === t[2] && (e.bom = 3);
            }(n);
            break;
          case o:
          case a:
          case l:
            !function (e) {
              const t = e.data;
              switch (e.bom = 0, e.type) {
                case o:
                  e.type = a, t.length >= 2 && (254 === t[0] && 255 === t[1] ? e.bom = 2 : 255 === t[0] && 254 === t[1] && (e.type = l, e.bom = 2));
                  break;
                case a:
                  if (e.type = a, t.length >= 2) if (254 === t[0] && 255 === t[1]) e.bom = 2;else if (255 === t[0] && 254 === t[1]) throw new TypeError(`src type: "${a}" specified but BOM is for "${l}"`);
                  break;
                case l:
                  if (e.type = l, t.length >= 0) {
                    if (254 === t[0] && 255 === t[1]) throw new TypeError(`src type: "${l}" specified but BOM is for "${a}"`);
                    255 === t[0] && 254 === t[1] && (e.bom = 2);
                  }
                  break;
                default:
                  throw new TypeError(`UTF16 BOM: src type "${e.type}" unrecognized`);
              }
            }(n);
            break;
          case c:
          case p:
          case h:
            !function (e) {
              const t = e.data;
              switch (e.bom = 0, e.type) {
                case c:
                  e.type = p, t.length >= 4 && (0 === t[0] && 0 === t[1] && 254 === t[2] && 255 === t[3] && (e.bom = 4), 255 === t[0] && 254 === t[1] && 0 === t[2] && 0 === t[3] && (e.type = h, e.bom = 4));
                  break;
                case p:
                  if (e.type = p, t.length >= 4 && (0 === t[0] && 0 === t[1] && 254 === t[2] && 255 === t[3] && (e.bom = 4), 255 === t[0] && 254 === t[1] && 0 === t[2] && 0 === t[3])) throw new TypeError(`src type: ${p} specified but BOM is for ${h}"`);
                  break;
                case h:
                  if (e.type = h, t.length >= 4) {
                    if (0 === t[0] && 0 === t[1] && 254 === t[2] && 255 === t[3]) throw new TypeError(`src type: "${h}" specified but BOM is for "${p}"`);
                    255 === t[0] && 254 === t[1] && 0 === t[2] && 0 === t[3] && (e.bom = 4);
                  }
                  break;
                default:
                  throw new TypeError(`UTF32 BOM: src type "${e.type}" unrecognized`);
              }
            }(n);
            break;
          case m:
            n.type = y;
            break;
          case T:
            n.type = x;
            break;
          case d:
            n.type = u;
            break;
          case f:
            n.type = g;
            break;
          case u:
          case g:
          case b:
          case y:
          case E:
          case x:
          case A:
          case w:
            break;
          default:
            throw new TypeError(`type: "${e}" not recognized`);
        }
        if (n.type === A) {
          if ("string" != typeof n.data) throw new TypeError(`type: "${e}" but data is not a string`);
        } else if (!r.isBuffer(n.data)) throw new TypeError(`type: "${e}" but data is not a Buffer`);
        return n;
      },
      C = function (e, t) {
        switch (e) {
          case i:
            return s.utf8.encode(t);
          case a:
            return s.utf16be.encode(t);
          case l:
            return s.utf16le.encode(t);
          case p:
            return s.utf32be.encode(t);
          case h:
            return s.utf32le.encode(t);
          case u:
            return s.uint7.encode(t);
          case g:
            return s.uint8.encode(t);
          case y:
            return s.uint16be.encode(t);
          case b:
            return s.uint16le.encode(t);
          case x:
            return s.uint32be.encode(t);
          case E:
            return s.uint32le.encode(t);
          case A:
            return s.string.encode(t);
          case w:
            return s.escaped.encode(t);
          default:
            throw new TypeError(`encode type "${e}" not recognized`);
        }
      };
    n.decode = function (e, t) {
      return function (e) {
        switch (e.type) {
          case i:
            return s.utf8.decode(e.data, e.bom);
          case l:
            return s.utf16le.decode(e.data, e.bom);
          case a:
            return s.utf16be.decode(e.data, e.bom);
          case p:
            return s.utf32be.decode(e.data, e.bom);
          case h:
            return s.utf32le.decode(e.data, e.bom);
          case u:
            return s.uint7.decode(e.data);
          case g:
            return s.uint8.decode(e.data);
          case y:
            return s.uint16be.decode(e.data);
          case b:
            return s.uint16le.decode(e.data);
          case x:
            return s.uint32be.decode(e.data);
          case E:
            return s.uint32le.decode(e.data);
          case A:
            return s.string.decode(e.data);
          case w:
            return s.escaped.decode(e.data);
          default:
            throw new TypeError(`decode type "${e.type}" not recognized`);
        }
      }(k(e, t));
    }, n.encode = function (e, t) {
      let n, r;
      const k = function (e, t) {
        if (!Array.isArray(t)) throw new TypeError('dst chars: not array: "' + typeof t);
        if ("string" != typeof e) throw new TypeError('dst type: not string: "' + typeof e);
        const n = function (e) {
          let t, n;
          const r = {
            crlf: !1,
            lf: !1,
            base64: !1,
            type: ""
          };
          for (;;) {
            if (n = e, t = e.slice(0, 5), "CRLF:" === t) {
              r.crlf = !0, n = e.slice(5);
              break;
            }
            if (t = e.slice(0, 3), "LF:" === t) {
              r.lf = !0, n = e.slice(3);
              break;
            }
            break;
          }
          return t = n.split(":"), 1 === t.length ? r.type = t[0] : 2 === t.length && "BASE64" === t[1] && (r.base64 = !0, r.type = t[0]), r;
        }(e.toUpperCase());
        switch (n.type) {
          case i:
          case a:
          case l:
          case p:
          case h:
          case u:
          case g:
          case b:
          case y:
          case E:
          case x:
          case w:
            break;
          case A:
            if (n.base64) throw new TypeError(`":BASE64" suffix not allowed with type ${A}`);
            break;
          case d:
            n.type = u;
            break;
          case f:
            n.type = g;
            break;
          case o:
            n.type = a;
            break;
          case c:
            n.type = p;
            break;
          case m:
            n.type = y;
            break;
          case T:
            n.type = x;
            break;
          default:
            throw new TypeError(`dst type unrecognized: "${e}" : must have form [crlf:|lf:]type[:base64]`);
        }
        return n;
      }(e, t);
      return k.crlf ? (n = s.lineEnds.crlf(t), r = C(k.type, n)) : k.lf ? (n = s.lineEnds.lf(t), r = C(k.type, n)) : r = C(k.type, t), k.base64 && (r = s.base64.encode(r)), r;
    };
    n.convert = function (e, t, r) {
      return n.encode(r, n.decode(e, t));
    };
  }, {
    "./transformers": 19,
    buffer: 2
  }],
  18: [function (e, t, n) {
    t.exports = {
      converter: e("./converter"),
      transformers: e("./transformers")
    };
  }, {
    "./converter": 17,
    "./transformers": 19
  }],
  19: [function (e, t, n) {
    const {
        Buffer: r
      } = e("buffer"),
      s = 4294967292,
      i = 4294967293,
      o = 4294967294,
      a = 4294967295,
      l = [0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023],
      c = ["00", "01", "02", "03", "04", "05", "06", "07", "08", "09", "0A", "0B", "0C", "0D", "0E", "0F", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "1A", "1B", "1C", "1D", "1E", "1F", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "2A", "2B", "2C", "2D", "2E", "2F", "30", "31", "32", "33", "34", "35", "36", "37", "38", "39", "3A", "3B", "3C", "3D", "3E", "3F", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "4A", "4B", "4C", "4D", "4E", "4F", "50", "51", "52", "53", "54", "55", "56", "57", "58", "59", "5A", "5B", "5C", "5D", "5E", "5F", "60", "61", "62", "63", "64", "65", "66", "67", "68", "69", "6A", "6B", "6C", "6D", "6E", "6F", "70", "71", "72", "73", "74", "75", "76", "77", "78", "79", "7A", "7B", "7C", "7D", "7E", "7F", "80", "81", "82", "83", "84", "85", "86", "87", "88", "89", "8A", "8B", "8C", "8D", "8E", "8F", "90", "91", "92", "93", "94", "95", "96", "97", "98", "99", "9A", "9B", "9C", "9D", "9E", "9F", "A0", "A1", "A2", "A3", "A4", "A5", "A6", "A7", "A8", "A9", "AA", "AB", "AC", "AD", "AE", "AF", "B0", "B1", "B2", "B3", "B4", "B5", "B6", "B7", "B8", "B9", "BA", "BB", "BC", "BD", "BE", "BF", "C0", "C1", "C2", "C3", "C4", "C5", "C6", "C7", "C8", "C9", "CA", "CB", "CC", "CD", "CE", "CF", "D0", "D1", "D2", "D3", "D4", "D5", "D6", "D7", "D8", "D9", "DA", "DB", "DC", "DD", "DE", "DF", "E0", "E1", "E2", "E3", "E4", "E5", "E6", "E7", "E8", "E9", "EA", "EB", "EC", "ED", "EE", "EF", "F0", "F1", "F2", "F3", "F4", "F5", "F6", "F7", "F8", "F9", "FA", "FB", "FC", "FD", "FE", "FF"],
      p = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".split(""),
      h = [];
    p.forEach(e => {
      h.push(e.charCodeAt(0));
    }), n.utf8 = {
      encode(e) {
        const t = [];
        return e.forEach(e => {
          if (e >= 0 && e <= 127) t.push(e);else if (e <= 2047) t.push(192 + (e >> 6 & l[5])), t.push(128 + (e & l[6]));else if (e < 55296 || e > 57343 && e <= 65535) t.push(224 + (e >> 12 & l[4])), t.push(128 + (e >> 6 & l[6])), t.push(128 + (e & l[6]));else {
            if (!(e >= 65536 && e <= 1114111)) throw new RangeError(`utf8.encode: character out of range: char: ${e}`);
            {
              const n = e >> 16 & l[5];
              t.push(240 + (n >> 2)), t.push(128 + ((n & l[2]) << 4) + (e >> 12 & l[4])), t.push(128 + (e >> 6 & l[6])), t.push(128 + (e & l[6]));
            }
          }
        }), r.from(t);
      },
      decode(e, t) {
        function n(e, t) {
          if (128 != (192 & t)) return i;
          const n = ((e & l[5]) << 6) + (t & l[6]);
          return n < 128 ? s : n;
        }
        function r(e, t, n) {
          if (128 != (192 & n) || 128 != (192 & t)) return i;
          const r = ((e & l[4]) << 12) + ((t & l[6]) << 6) + (n & l[6]);
          return r < 2048 ? s : r >= 55296 && r <= 57343 ? o : r;
        }
        function c(e, t, n, r) {
          if (128 != (192 & r) || 128 != (192 & n) || 128 != (192 & t)) return i;
          const a = (((e & l[3]) << 2) + (t >> 4 & l[2]) << 16) + ((t & l[4]) << 12) + ((n & l[6]) << 6) + (r & l[6]);
          return a < 65536 ? s : a > 1114111 ? o : a;
        }
        let p, h, u, d, f, g;
        const m = e.length;
        let b = t ? 3 : 0;
        const y = [];
        for (; b < m;) {
          h = e[b], p = a;
          const t = !0;
          for (; t;) {
            if (h >= 0 && h <= 127) {
              p = h, g = 1;
              break;
            }
            if (u = b + 1, u < m && h >= 194 && h <= 223) {
              p = n(h, e[u]), g = 2;
              break;
            }
            if (d = b + 2, d < m && h >= 224 && h <= 239) {
              p = r(h, e[u], e[d]), g = 3;
              break;
            }
            if (f = b + 3, f < m && h >= 240 && h <= 244) {
              p = c(h, e[u], e[d], e[f]), g = 4;
              break;
            }
            break;
          }
          if (p > 1114111) {
            const e = `byte[${b}]`;
            if (p === a) throw new RangeError(`utf8.decode: ill-formed UTF8 byte sequence found at: ${e}`);
            if (p === i) throw new RangeError(`utf8.decode: illegal trailing byte found at: ${e}`);
            if (p === o) throw new RangeError(`utf8.decode: code point out of range found at: ${e}`);
            if (p === s) throw new RangeError(`utf8.decode: non-shortest form found at: ${e}`);
            throw new RangeError(`utf8.decode: unrecognized error found at: ${e}`);
          }
          y.push(p), b += g;
        }
        return y;
      }
    }, n.utf16be = {
      encode(e) {
        const t = [];
        let n, s, i;
        for (let r = 0; r < e.length; r += 1) if (n = e[r], n >= 0 && n <= 55295 || n >= 57344 && n <= 65535) t.push(n >> 8 & l[8]), t.push(n & l[8]);else {
          if (!(n >= 65536 && n <= 1114111)) throw new RangeError(`utf16be.encode: UTF16BE value out of range: char[${r}]: ${n}`);
          i = n - 65536, s = 55296 + (i >> 10), i = 56320 + (i & l[10]), t.push(s >> 8 & l[8]), t.push(s & l[8]), t.push(i >> 8 & l[8]), t.push(i & l[8]);
        }
        return r.from(t);
      },
      decode(e, t) {
        if (e.length % 2 > 0) throw new RangeError(`utf16be.decode: data length must be even multiple of 2: length: ${e.length}`);
        const n = [],
          r = e.length;
        let s,
          i,
          o,
          a,
          l,
          c,
          p = t ? 2 : 0,
          h = 0;
        for (; p < r;) {
          const t = !0;
          for (; t;) {
            if (o = p + 1, o < r) {
              if (l = (e[p] << 8) + e[o], l < 55296 || l > 57343) {
                s = l, i = 2;
                break;
              }
              if (a = p + 3, a < r && (c = (e[p + 2] << 8) + e[a], l <= 56319 && c >= 56320 && c <= 57343)) {
                s = 65536 + (l - 55296 << 10) + (c - 56320), i = 4;
                break;
              }
            }
            throw new RangeError(`utf16be.decode: ill-formed UTF16BE byte sequence found: byte[${p}]`);
          }
          n[h++] = s, p += i;
        }
        return n;
      }
    }, n.utf16le = {
      encode(e) {
        const t = [];
        let n, s, i;
        for (let r = 0; r < e.length; r += 1) if (n = e[r], n >= 0 && n <= 55295 || n >= 57344 && n <= 65535) t.push(n & l[8]), t.push(n >> 8 & l[8]);else {
          if (!(n >= 65536 && n <= 1114111)) throw new RangeError(`utf16le.encode: UTF16LE value out of range: char[${r}]: ${n}`);
          i = n - 65536, s = 55296 + (i >> 10), i = 56320 + (i & l[10]), t.push(s & l[8]), t.push(s >> 8 & l[8]), t.push(i & l[8]), t.push(i >> 8 & l[8]);
        }
        return r.from(t);
      },
      decode(e, t) {
        if (e.length % 2 > 0) throw new RangeError(`utf16le.decode: data length must be even multiple of 2: length: ${e.length}`);
        const n = [],
          r = e.length;
        let s,
          i,
          o,
          a,
          l,
          c,
          p = t ? 2 : 0,
          h = 0;
        for (; p < r;) {
          const t = !0;
          for (; t;) {
            if (o = p + 1, o < r) {
              if (l = (e[o] << 8) + e[p], l < 55296 || l > 57343) {
                s = l, i = 2;
                break;
              }
              if (a = p + 3, a < r && (c = (e[a] << 8) + e[p + 2], l <= 56319 && c >= 56320 && c <= 57343)) {
                s = 65536 + (l - 55296 << 10) + (c - 56320), i = 4;
                break;
              }
            }
            throw new RangeError(`utf16le.decode: ill-formed UTF16LE byte sequence found: byte[${p}]`);
          }
          n[h++] = s, p += i;
        }
        return n;
      }
    }, n.utf32be = {
      encode(e) {
        const t = r.alloc(4 * e.length);
        let n = 0;
        return e.forEach(e => {
          if (e >= 55296 && e <= 57343 || e > 1114111) throw new RangeError(`utf32be.encode: UTF32BE character code out of range: char[${n / 4}]: ${e}`);
          t[n++] = e >> 24 & l[8], t[n++] = e >> 16 & l[8], t[n++] = e >> 8 & l[8], t[n++] = e & l[8];
        }), t;
      },
      decode(e, t) {
        if (e.length % 4 > 0) throw new RangeError(`utf32be.decode: UTF32BE byte length must be even multiple of 4: length: ${e.length}`);
        const n = [];
        let r = t ? 4 : 0;
        for (; r < e.length; r += 4) {
          const t = (e[r] << 24) + (e[r + 1] << 16) + (e[r + 2] << 8) + e[r + 3];
          if (t >= 55296 && t <= 57343 || t > 1114111) throw new RangeError(`utf32be.decode: UTF32BE character code out of range: char[${r / 4}]: ${t}`);
          n.push(t);
        }
        return n;
      }
    }, n.utf32le = {
      encode(e) {
        const t = r.alloc(4 * e.length);
        let n = 0;
        return e.forEach(e => {
          if (e >= 55296 && e <= 57343 || e > 1114111) throw new RangeError(`utf32le.encode: UTF32LE character code out of range: char[${n / 4}]: ${e}`);
          t[n++] = e & l[8], t[n++] = e >> 8 & l[8], t[n++] = e >> 16 & l[8], t[n++] = e >> 24 & l[8];
        }), t;
      },
      decode(e, t) {
        if (e.length % 4 > 0) throw new RangeError(`utf32be.decode: UTF32LE byte length must be even multiple of 4: length: ${e.length}`);
        const n = [];
        let r = t ? 4 : 0;
        for (; r < e.length; r += 4) {
          const t = (e[r + 3] << 24) + (e[r + 2] << 16) + (e[r + 1] << 8) + e[r];
          if (t >= 55296 && t <= 57343 || t > 1114111) throw new RangeError(`utf32le.encode: UTF32LE character code out of range: char[${r / 4}]: ${t}`);
          n.push(t);
        }
        return n;
      }
    }, n.uint7 = {
      encode(e) {
        const t = r.alloc(e.length);
        for (let n = 0; n < e.length; n += 1) {
          if (e[n] > 127) throw new RangeError(`uint7.encode: UINT7 character code out of range: char[${n}]: ${e[n]}`);
          t[n] = e[n];
        }
        return t;
      },
      decode(e) {
        const t = [];
        for (let n = 0; n < e.length; n += 1) {
          if (e[n] > 127) throw new RangeError(`uint7.decode: UINT7 character code out of range: byte[${n}]: ${e[n]}`);
          t[n] = e[n];
        }
        return t;
      }
    }, n.uint8 = {
      encode(e) {
        const t = r.alloc(e.length);
        for (let n = 0; n < e.length; n += 1) {
          if (e[n] > 255) throw new RangeError(`uint8.encode: UINT8 character code out of range: char[${n}]: ${e[n]}`);
          t[n] = e[n];
        }
        return t;
      },
      decode(e) {
        const t = [];
        for (let n = 0; n < e.length; n += 1) t[n] = e[n];
        return t;
      }
    }, n.uint16be = {
      encode(e) {
        const t = r.alloc(2 * e.length);
        let n = 0;
        return e.forEach(e => {
          if (e > 65535) throw new RangeError(`uint16be.encode: UINT16BE character code out of range: char[${n / 2}]: ${e}`);
          t[n++] = e >> 8 & l[8], t[n++] = e & l[8];
        }), t;
      },
      decode(e) {
        if (e.length % 2 > 0) throw new RangeError(`uint16be.decode: UINT16BE byte length must be even multiple of 2: length: ${e.length}`);
        const t = [];
        for (let n = 0; n < e.length; n += 2) t.push((e[n] << 8) + e[n + 1]);
        return t;
      }
    }, n.uint16le = {
      encode(e) {
        const t = r.alloc(2 * e.length);
        let n = 0;
        return e.forEach(e => {
          if (e > 65535) throw new RangeError(`uint16le.encode: UINT16LE character code out of range: char[${n / 2}]: ${e}`);
          t[n++] = e & l[8], t[n++] = e >> 8 & l[8];
        }), t;
      },
      decode(e) {
        if (e.length % 2 > 0) throw new RangeError(`uint16le.decode: UINT16LE byte length must be even multiple of 2: length: ${e.length}`);
        const t = [];
        for (let n = 0; n < e.length; n += 2) t.push((e[n + 1] << 8) + e[n]);
        return t;
      }
    }, n.uint32be = {
      encode(e) {
        const t = r.alloc(4 * e.length);
        let n = 0;
        return e.forEach(e => {
          t[n++] = e >> 24 & l[8], t[n++] = e >> 16 & l[8], t[n++] = e >> 8 & l[8], t[n++] = e & l[8];
        }), t;
      },
      decode(e) {
        if (e.length % 4 > 0) throw new RangeError(`uint32be.decode: UINT32BE byte length must be even multiple of 4: length: ${e.length}`);
        const t = [];
        for (let n = 0; n < e.length; n += 4) t.push((e[n] << 24) + (e[n + 1] << 16) + (e[n + 2] << 8) + e[n + 3]);
        return t;
      }
    }, n.uint32le = {
      encode(e) {
        const t = r.alloc(4 * e.length);
        let n = 0;
        return e.forEach(e => {
          t[n++] = e & l[8], t[n++] = e >> 8 & l[8], t[n++] = e >> 16 & l[8], t[n++] = e >> 24 & l[8];
        }), t;
      },
      decode(e) {
        if (e.length % 4 > 0) throw new RangeError(`uint32le.decode: UINT32LE byte length must be even multiple of 4: length: ${e.length}`);
        const t = [];
        for (let n = 0; n < e.length; n += 4) t.push((e[n + 3] << 24) + (e[n + 2] << 16) + (e[n + 1] << 8) + e[n]);
        return t;
      }
    }, n.string = {
      encode: e => n.utf16le.encode(e).toString("utf16le"),
      decode: e => n.utf16le.decode(r.from(e, "utf16le"), 0)
    }, n.escaped = {
      encode(e) {
        const t = [];
        for (let n = 0; n < e.length; n += 1) {
          const s = e[n];
          if (96 === s) t.push(s), t.push(s);else if (10 === s) t.push(s);else if (s >= 32 && s <= 126) t.push(s);else {
            let e = "";
            if (s >= 0 && s <= 31) e += `\`x${c[s]}`;else if (s >= 127 && s <= 255) e += `\`x${c[s]}`;else if (s >= 256 && s <= 65535) e += `\`u${c[s >> 8 & l[8]]}${c[s & l[8]]}`;else {
              if (!(s >= 65536 && s <= 4294967295)) throw new Error("escape.encode(char): char > 0xffffffff not allowed");
              {
                e += "`u{";
                const t = s >> 24 & l[8];
                t > 0 && (e += c[t]), e += `${c[s >> 16 & l[8]] + c[s >> 8 & l[8]] + c[s & l[8]]}}`;
              }
            }
            r.from(e).forEach(e => {
              t.push(e);
            });
          }
        }
        return r.from(t);
      },
      decode(e) {
        function t(e) {
          return e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102;
        }
        function n(e, n, r) {
          const s = {
            char: null,
            nexti: e + 2,
            error: !0
          };
          if (e + 1 < n && t(r[e]) && t(r[e + 1])) {
            const t = String.fromCodePoint(r[e], r[e + 1]);
            s.char = parseInt(t, 16), Number.isNaN(s.char) || (s.error = !1);
          }
          return s;
        }
        function r(e, n, r) {
          const s = {
            char: null,
            nexti: e + 4,
            error: !0
          };
          if (e + 3 < n && t(r[e]) && t(r[e + 1]) && t(r[e + 2]) && t(r[e + 3])) {
            const t = String.fromCodePoint(r[e], r[e + 1], r[e + 2], r[e + 3]);
            s.char = parseInt(t, 16), Number.isNaN(s.char) || (s.error = !1);
          }
          return s;
        }
        function s(e, n, r) {
          const s = {
            char: null,
            nexti: e + 4,
            error: !0
          };
          let i = "";
          for (; e < n && t(r[e]);) i += String.fromCodePoint(r[e]), e += 1;
          return s.char = parseInt(i, 16), 125 !== r[e] || Number.isNaN(s.char) || (s.error = !1), s.nexti = e + 1, s;
        }
        const i = [],
          o = e.length;
        let a,
          l,
          c,
          p = 0;
        for (; p < o;) {
          const t = !0;
          for (; t;) {
            if (c = !0, 96 !== e[p]) {
              i.push(e[p]), p += 1, c = !1;
              break;
            }
            if (a = p + 1, a >= o) break;
            if (96 === e[a]) {
              i.push(96), p += 2, c = !1;
              break;
            }
            if (120 === e[a]) {
              if (l = n(a + 1, o, e), l.error) break;
              i.push(l.char), p = l.nexti, c = !1;
              break;
            }
            if (117 === e[a]) {
              if (123 === e[a + 1]) {
                if (l = s(a + 2, o, e), l.error) break;
                i.push(l.char), p = l.nexti, c = !1;
                break;
              }
              if (l = r(a + 1, o, e), l.error) break;
              i.push(l.char), p = l.nexti, c = !1;
              break;
            }
            break;
          }
          if (c) throw new Error(`escaped.decode: ill-formed escape sequence at buf[${p}]`);
        }
        return i;
      }
    };
    const u = 10;
    n.lineEnds = {
      crlf(e) {
        const t = [];
        let n = 0;
        for (; n < e.length;) switch (e[n]) {
          case 13:
            n + 1 < e.length && e[n + 1] === u ? n += 2 : n += 1, t.push(13), t.push(u);
            break;
          case u:
            t.push(13), t.push(u), n += 1;
            break;
          default:
            t.push(e[n]), n += 1;
        }
        return t.length > 0 && t[t.length - 1] !== u && (t.push(13), t.push(u)), t;
      },
      lf(e) {
        const t = [];
        let n = 0;
        for (; n < e.length;) switch (e[n]) {
          case 13:
            n + 1 < e.length && e[n + 1] === u ? n += 2 : n += 1, t.push(u);
            break;
          case u:
            t.push(u), n += 1;
            break;
          default:
            t.push(e[n]), n += 1;
        }
        return t.length > 0 && t[t.length - 1] !== u && t.push(u), t;
      }
    }, n.base64 = {
      encode(e) {
        if (0 === e.length) return r.alloc(0);
        let t,
          n,
          s,
          i = e.length % 3;
        i = i > 0 ? 3 - i : 0;
        let o = (e.length + i) / 3;
        const a = r.alloc(4 * o);
        i > 0 && (o -= 1), t = 0, n = 0;
        for (let r = 0; r < o; r += 1) s = e[t++] << 16, s += e[t++] << 8, s += e[t++], a[n++] = h[s >> 18 & l[6]], a[n++] = h[s >> 12 & l[6]], a[n++] = h[s >> 6 & l[6]], a[n++] = h[s & l[6]];
        return 0 === i ? a : 1 === i ? (s = e[t++] << 16, s += e[t] << 8, a[n++] = h[s >> 18 & l[6]], a[n++] = h[s >> 12 & l[6]], a[n++] = h[s >> 6 & l[6]], a[n] = h[64], a) : 2 === i ? (s = e[t] << 16, a[n++] = h[s >> 18 & l[6]], a[n++] = h[s >> 12 & l[6]], a[n++] = h[64], a[n] = h[64], a) : void 0;
      },
      decode(e) {
        if (0 === e.length) return r.alloc(0);
        const t = function (e) {
            const t = [];
            let n = 0;
            for (let r = 0; r < e.length; r += 1) {
              const s = e[r],
                i = !0;
              for (; i && 32 !== s && 9 !== s && 10 !== s && 13 !== s;) {
                if (s >= 65 && s <= 90) {
                  t.push(s - 65);
                  break;
                }
                if (s >= 97 && s <= 122) {
                  t.push(s - 71);
                  break;
                }
                if (s >= 48 && s <= 57) {
                  t.push(s + 4);
                  break;
                }
                if (43 === s) {
                  t.push(62);
                  break;
                }
                if (47 === s) {
                  t.push(63);
                  break;
                }
                if (61 === s) {
                  t.push(64), n += 1;
                  break;
                }
                throw new RangeError(`base64.decode: invalid character buf[${r}]: ${s}`);
              }
            }
            if (t.length % 4 > 0) throw new RangeError(`base64.decode: string length not integral multiple of 4: ${t.length}`);
            switch (n) {
              case 0:
                break;
              case 1:
                if (64 !== t[t.length - 1]) throw new RangeError("base64.decode: one tail character found: not last character");
                break;
              case 2:
                if (64 !== t[t.length - 1] || 64 !== t[t.length - 2]) throw new RangeError("base64.decode: two tail characters found: not last characters");
                break;
              default:
                throw new RangeError(`base64.decode: more than two tail characters found: ${n}`);
            }
            return {
              tail: n,
              buf: r.from(t)
            };
          }(e),
          {
            tail: n
          } = t,
          s = t.buf;
        let i,
          o,
          a,
          c = s.length / 4;
        const p = r.alloc(3 * c - n);
        n > 0 && (c -= 1), o = 0, i = 0;
        for (let e = 0; e < c; e += 1) a = s[i++] << 18, a += s[i++] << 12, a += s[i++] << 6, a += s[i++], p[o++] = a >> 16 & l[8], p[o++] = a >> 8 & l[8], p[o++] = a & l[8];
        return 1 === n && (a = s[i++] << 18, a += s[i++] << 12, a += s[i] << 6, p[o++] = a >> 16 & l[8], p[o] = a >> 8 & l[8]), 2 === n && (a = s[i++] << 18, a += s[i++] << 12, p[o] = a >> 16 & l[8]), p;
      },
      toString(e) {
        if (e.length % 4 > 0) throw new RangeError(`base64.toString: input buffer length not multiple of 4: ${e.length}`);
        let t = "",
          n = 0;
        function r(e, r, s, i) {
          switch (n) {
            case 76:
              t += `\r\n${e}${r}${s}${i}`, n = 4;
              break;
            case 75:
              t += `${e}\r\n${r}${s}${i}`, n = 3;
              break;
            case 74:
              t += `${e + r}\r\n${s}${i}`, n = 2;
              break;
            case 73:
              t += `${e + r + s}\r\n${i}`, n = 1;
              break;
            default:
              t += e + r + s + i, n += 4;
          }
        }
        for (let t = 0; t < e.length; t += 4) {
          for (let n = t; n < t + 4; n += 1) if (!((s = e[n]) >= 65 && s <= 90 || s >= 97 && s <= 122 || s >= 48 && s <= 57 || 43 === s || 47 === s || 61 === s)) throw new RangeError(`base64.toString: buf[${n}]: ${e[n]} : not valid base64 character code`);
          r(String.fromCharCode(e[t]), String.fromCharCode(e[t + 1]), String.fromCharCode(e[t + 2]), String.fromCharCode(e[t + 3]));
        }
        var s;
        return t;
      }
    };
  }, {
    buffer: 2
  }],
  20: [function (e, t, n) {
    t.exports = function () {
      const t = e("./identifiers"),
        n = e("./utilities"),
        r = this;
      let s = null,
        i = null,
        o = null,
        a = 0;
      const l = [],
        c = [],
        p = [],
        h = [];
      function u(e) {
        let t = "";
        for (let n = 0; n < e; n += 1) t += " ";
        return t;
      }
      this.callbacks = [], this.astObject = "astObject", this.init = function (e, t, n) {
        let u;
        p.length = 0, h.length = 0, l.length = 0, a = 0, s = e, i = t, o = n;
        const d = [];
        for (u = 0; u < s.length; u += 1) d.push(s[u].lower);
        for (u = 0; u < i.length; u += 1) d.push(i[u].lower);
        for (a = s.length + i.length, u = 0; u < a; u += 1) l[u] = !1, c[u] = null;
        for (const e in r.callbacks) {
          const t = e.toLowerCase();
          if (u = d.indexOf(t), u < 0) throw new Error(`ast.js: init: node '${e}' not a rule or udt name`);
          "function" == typeof r.callbacks[e] && (l[u] = !0, c[u] = r.callbacks[e]), !0 === r.callbacks[e] && (l[u] = !0);
        }
      }, this.ruleDefined = function (e) {
        return !1 !== l[e];
      }, this.udtDefined = function (e) {
        return !1 !== l[s.length + e];
      }, this.down = function (e, n) {
        const r = h.length;
        return p.push(r), h.push({
          name: n,
          thisIndex: r,
          thatIndex: null,
          state: t.SEM_PRE,
          callbackIndex: e,
          phraseIndex: null,
          phraseLength: null,
          stack: p.length
        }), r;
      }, this.up = function (e, n, r, s) {
        const i = h.length,
          o = p.pop();
        return h.push({
          name: n,
          thisIndex: i,
          thatIndex: o,
          state: t.SEM_POST,
          callbackIndex: e,
          phraseIndex: r,
          phraseLength: s,
          stack: p.length
        }), h[o].thatIndex = i, h[o].phraseIndex = r, h[o].phraseLength = s, i;
      }, this.translate = function (e) {
        let n, r, s;
        for (let i = 0; i < h.length; i += 1) s = h[i], r = c[s.callbackIndex], s.state === t.SEM_PRE ? null !== r && (n = r(t.SEM_PRE, o, s.phraseIndex, s.phraseLength, e), n === t.SEM_SKIP && (i = s.thatIndex)) : null !== r && r(t.SEM_POST, o, s.phraseIndex, s.phraseLength, e);
      }, this.setLength = function (e) {
        h.length = e, p.length = e > 0 ? h[e - 1].stack : 0;
      }, this.getLength = function () {
        return h.length;
      }, this.toXml = function (e) {
        let r = n.charsToDec,
          s = "decimal integer character codes";
        if ("string" == typeof e && e.length >= 3) {
          const t = e.slice(0, 3).toLowerCase();
          "asc" === t ? (r = n.charsToAscii, s = "ASCII for printing characters, hex for non-printing") : "hex" === t ? (r = n.charsToHex, s = "hexadecimal integer character codes") : "uni" === t && (r = n.charsToUnicode, s = "Unicode UTF-32 integer character codes");
        }
        let i = "",
          a = 0;
        return i += '<?xml version="1.0" encoding="utf-8"?>\n', i += `<root nodes="${h.length / 2}" characters="${o.length}">\n`, i += `\x3c!-- input string, ${s} --\x3e\n`, i += u(a + 2), i += r(o), i += "\n", h.forEach(e => {
          e.state === t.SEM_PRE ? (a += 1, i += u(a), i += `<node name="${e.name}" index="${e.phraseIndex}" length="${e.phraseLength}">\n`, i += u(a + 2), i += r(o, e.phraseIndex, e.phraseLength), i += "\n") : (i += u(a), i += `</node>\x3c!-- name="${e.name}" --\x3e\n`, a -= 1);
        }), i += "</root>\n", i;
      }, this.phrases = function () {
        const e = {};
        let n, r;
        for (n = 0; n < h.length; n += 1) r = h[n], r.state === t.SEM_PRE && (Array.isArray(e[r.name]) || (e[r.name] = []), e[r.name].push({
          index: r.phraseIndex,
          length: r.phraseLength
        }));
        return e;
      };
    };
  }, {
    "./identifiers": 23,
    "./utilities": 29
  }],
  21: [function (e, t, n) {
    t.exports = function () {
      let e = -1,
        t = 0;
      this.init = function (n) {
        if ("number" != typeof n || n <= 0) throw new Error("circular-buffer.js: init: circular buffer size must an integer > 0");
        t = Math.ceil(n), e = -1;
      }, this.increment = function () {
        return e += 1, (e + t) % t;
      }, this.maxSize = function () {
        return t;
      }, this.items = function () {
        return e + 1;
      }, this.getListIndex = function (n) {
        return -1 === e || n < 0 || n > e || e - n >= t ? -1 : (n + t) % t;
      }, this.forEach = function (n) {
        if (-1 !== e) if (e < t) for (let t = 0; t <= e; t += 1) n(t, t);else for (let r = e - t + 1; r <= e; r += 1) {
          n((r + t) % t, r);
        }
      };
    };
  }, {}],
  22: [function (e, t, n) {
    t.exports = function () {
      return "/* This file automatically generated by jsonToless() and LESS. */\n.apg-mono {\n  font-family: monospace;\n}\n.apg-active {\n  font-weight: bold;\n  color: #000000;\n}\n.apg-match {\n  font-weight: bold;\n  color: #264BFF;\n}\n.apg-empty {\n  font-weight: bold;\n  color: #0fbd0f;\n}\n.apg-nomatch {\n  font-weight: bold;\n  color: #FF4000;\n}\n.apg-lh-match {\n  font-weight: bold;\n  color: #1A97BA;\n}\n.apg-lb-match {\n  font-weight: bold;\n  color: #5F1687;\n}\n.apg-remainder {\n  font-weight: bold;\n  color: #999999;\n}\n.apg-ctrl-char {\n  font-weight: bolder;\n  font-style: italic;\n  font-size: 0.6em;\n}\n.apg-line-end {\n  font-weight: bold;\n  color: #000000;\n}\n.apg-error {\n  font-weight: bold;\n  color: #FF4000;\n}\n.apg-phrase {\n  color: #000000;\n  background-color: #8caae6;\n}\n.apg-empty-phrase {\n  color: #0fbd0f;\n}\ntable.apg-state {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: left;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-state th,\ntable.apg-state td {\n  text-align: left;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-state th:nth-last-child(2),\ntable.apg-state td:nth-last-child(2) {\n  text-align: right;\n}\ntable.apg-state caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-stats {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-stats th,\ntable.apg-stats td {\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-stats caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-trace {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-trace caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-trace th,\ntable.apg-trace td {\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-trace th:last-child,\ntable.apg-trace th:nth-last-child(2),\ntable.apg-trace td:last-child,\ntable.apg-trace td:nth-last-child(2) {\n  text-align: left;\n}\ntable.apg-grammar {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-grammar caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-grammar th,\ntable.apg-grammar td {\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-grammar th:last-child,\ntable.apg-grammar td:last-child {\n  text-align: left;\n}\ntable.apg-rules {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-rules caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-rules th,\ntable.apg-rules td {\n  text-align: right;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-rules a {\n  color: #003399 !important;\n}\ntable.apg-rules a:hover {\n  color: #8caae6 !important;\n}\ntable.apg-attrs {\n  font-family: monospace;\n  margin-top: 5px;\n  font-size: 11px;\n  line-height: 130%;\n  text-align: center;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-attrs caption {\n  font-size: 125%;\n  line-height: 130%;\n  font-weight: bold;\n  text-align: left;\n}\ntable.apg-attrs th,\ntable.apg-attrs td {\n  text-align: center;\n  border: 1px solid black;\n  border-collapse: collapse;\n}\ntable.apg-attrs th:nth-child(1),\ntable.apg-attrs th:nth-child(2),\ntable.apg-attrs th:nth-child(3) {\n  text-align: right;\n}\ntable.apg-attrs td:nth-child(1),\ntable.apg-attrs td:nth-child(2),\ntable.apg-attrs td:nth-child(3) {\n  text-align: right;\n}\ntable.apg-attrs a {\n  color: #003399 !important;\n}\ntable.apg-attrs a:hover {\n  color: #8caae6 !important;\n}\n";
    };
  }, {}],
  23: [function (e, t, n) {
    t.exports = {
      ALT: 1,
      CAT: 2,
      REP: 3,
      RNM: 4,
      TRG: 5,
      TBS: 6,
      TLS: 7,
      UDT: 11,
      AND: 12,
      NOT: 13,
      BKR: 14,
      BKA: 15,
      BKN: 16,
      ABG: 17,
      AEN: 18,
      ACTIVE: 100,
      MATCH: 101,
      EMPTY: 102,
      NOMATCH: 103,
      SEM_PRE: 200,
      SEM_POST: 201,
      SEM_OK: 300,
      SEM_SKIP: 301,
      ATTR_N: 400,
      ATTR_R: 401,
      ATTR_MR: 402,
      LOOKAROUND_NONE: 500,
      LOOKAROUND_AHEAD: 501,
      LOOKAROUND_BEHIND: 502,
      BKR_MODE_UM: 601,
      BKR_MODE_PM: 602,
      BKR_MODE_CS: 603,
      BKR_MODE_CI: 604
    };
  }, {}],
  24: [function (e, t, n) {
    t.exports = {
      ast: e("./ast"),
      circular: e("./circular-buffer"),
      ids: e("./identifiers"),
      parser: e("./parser"),
      stats: e("./stats"),
      trace: e("./trace"),
      utils: e("./utilities"),
      emitcss: e("./emitcss"),
      style: e("./style")
    };
  }, {
    "./ast": 20,
    "./circular-buffer": 21,
    "./emitcss": 22,
    "./identifiers": 23,
    "./parser": 25,
    "./stats": 26,
    "./style": 27,
    "./trace": 28,
    "./utilities": 29
  }],
  25: [function (e, t, n) {
    t.exports = function () {
      const t = e("./identifiers"),
        n = e("./utilities"),
        r = "parser.js: ",
        s = this;
      let i;
      this.ast = null, this.stats = null, this.trace = null, this.callbacks = [];
      let o,
        a,
        l,
        c,
        p = null,
        h = null,
        u = 0,
        d = 0,
        f = 0,
        g = null,
        m = null,
        b = null,
        y = null,
        T = null,
        E = 0,
        x = 1 / 0,
        w = 1 / 0;
      const A = function (e, n, s) {
          const o = `${r}evaluateRule(): `;
          if (e >= b.length) throw new Error(`${o}rule index: ${e} out of range`);
          if (n >= l) throw new Error(`${o}phrase index: ${n} out of range`);
          const {
            length: a
          } = p;
          p.push({
            type: t.RNM,
            index: e
          }), i(a, n, s), p.pop();
        },
        k = function (e, n, s) {
          const o = `${r}evaluateUdt(): `;
          if (e >= y.length) throw new Error(`${o}udt index: ${e} out of range`);
          if (n >= l) throw new Error(`${o}phrase index: ${n} out of range`);
          const {
            length: a
          } = p;
          p.push({
            type: t.UDT,
            empty: y[e].empty,
            index: e
          }), i(a, n, s), p.pop();
        },
        C = function () {
          u = 0, d = 0, f = 0, E = 0, c = [{
            lookAround: t.LOOKAROUND_NONE,
            anchor: 0,
            charsEnd: 0,
            charsLength: 0
          }], b = null, y = null, h = null, o = 0, a = 0, l = 0, g = null, m = null, T = null, p = null;
        },
        S = function () {
          const e = [];
          this.push = function () {
            e.push(function () {
              const t = e[e.length - 1],
                n = {};
              for (const e in t) n[e] = t[e];
              return n;
            }());
          }, this.pop = function (t) {
            let n = t;
            if (n || (n = e.length - 1), n < 1 || n > e.length) throw new Error(`${r}backRef.pop(): bad length: ${n}`);
            return e.length = n, e[e.length - 1];
          }, this.length = function () {
            return e.length;
          }, this.savePhrase = function (t, n, r) {
            e[e.length - 1][t] = {
              phraseIndex: n,
              phraseLength: r
            };
          }, this.getPhrase = function (t) {
            return e[e.length - 1][t];
          }, function () {
            const t = {};
            b.forEach(e => {
              e.isBkr && (t[e.lower] = null);
            }), y.length > 0 && y.forEach(e => {
              e.isBkr && (t[e.lower] = null);
            }), e.push(t);
          }();
        },
        M = function () {
          const e = this;
          this.state = t.ACTIVE, this.phraseLength = 0, this.ruleIndex = 0, this.udtIndex = 0, this.lookAround = c[c.length - 1], this.uFrame = new S(), this.pFrame = new S(), this.evaluateRule = A, this.evaluateUdt = k, this.refresh = function () {
            e.state = t.ACTIVE, e.phraseLength = 0, e.lookAround = c[c.length - 1];
          };
        },
        O = function () {
          return c[c.length - 1];
        },
        $ = function () {
          return c.length > 1;
        },
        L = function (e, t, s) {
          const i = `${r}initializeInputChars(): `;
          let c = e,
            p = t,
            u = s;
          if (void 0 === c) throw new Error(`${i}input string is undefined`);
          if (null === c) throw new Error(`${i}input string is null`);
          if ("string" == typeof c) c = n.stringToChars(c);else if (!Array.isArray(c)) throw new Error(`${i}input string is not a string or array`);
          if (c.length > 0 && "number" != typeof c[0]) throw new Error(`${i}input string not an array of integers`);
          if ("number" != typeof p) p = 0;else if (p = Math.floor(p), p < 0 || p > c.length) throw new Error(`${i}input beginning index out of range: ${p}`);
          if ("number" != typeof u) u = c.length - p;else if (u = Math.floor(u), u < 0 || u > c.length - p) throw new Error(`${i}input length out of range: ${u}`);
          h = c, o = p, a = u, l = o + a;
        };
      this.setMaxTreeDepth = function (e) {
        if ("number" != typeof e) throw new Error(`parser: max tree depth must be integer > 0: ${e}`);
        if (x = Math.floor(e), x <= 0) throw new Error(`parser: max tree depth must be integer > 0: ${e}`);
      }, this.setMaxNodeHits = function (e) {
        if ("number" != typeof e) throw new Error(`parser: max node hits must be integer > 0: ${e}`);
        if (w = Math.floor(e), w <= 0) throw new Error(`parser: max node hits must be integer > 0: ${e}`);
      };
      const B = function (e, n, c) {
        let u;
        const x = `${r}parse(): `;
        !function (e) {
          const t = `${r}initializeGrammar(): `;
          if (!e) throw new Error(`${t}grammar object undefined`);
          if ("grammarObject" !== e.grammarObject) throw new Error(`${t}bad grammar object`);
          b = e.rules, y = e.udts;
        }(e);
        const w = function (e) {
          const t = `${r}initializeStartRule(): `;
          let n = null;
          if ("number" == typeof e) {
            if (e >= b.length) throw new Error(`${t}start rule index too large: max: ${b.length}: index: ${e}`);
            n = e;
          } else {
            if ("string" != typeof e) throw new Error(`${t}type of start rule '${typeof e}' not recognized`);
            {
              const r = e.toLowerCase();
              for (let e = 0; e < b.length; e += 1) if (r === b[e].lower) {
                n = b[e].index;
                break;
              }
              if (null === n) throw new Error(`${t}start rule name '${e}' not recognized`);
            }
          }
          return n;
        }(n);
        !function () {
          const e = `${r}initializeCallbacks(): `;
          let t, n;
          for (g = [], m = [], t = 0; t < b.length; t += 1) g[t] = null;
          for (t = 0; t < y.length; t += 1) m[t] = null;
          const i = [];
          for (t = 0; t < b.length; t += 1) i.push(b[t].lower);
          for (t = 0; t < y.length; t += 1) i.push(y[t].lower);
          for (const r in s.callbacks) {
            if (t = i.indexOf(r.toLowerCase()), t < 0) throw new Error(`${e}syntax callback '${r}' not a rule or udt name`);
            if (n = s.callbacks[r], n || (n = null), "function" != typeof n && null !== n) throw new Error(`${e}syntax callback[${r}] must be function reference or 'false' (false/null/undefined/etc.)`);
            t < b.length ? g[t] = n : m[t - b.length] = n;
          }
          for (t = 0; t < y.length; t += 1) if (null === m[t]) throw new Error(`${e}all UDT callbacks must be defined. UDT callback[${y[t].lower}] not a function reference`);
        }(), function () {
          const e = `${r}initializeTrace(): `;
          for (;;) {
            if (void 0 === s.trace) {
              s.trace = null;
              break;
            }
            if (null === s.trace) break;
            if ("traceObject" !== s.trace.traceObject) throw new Error(`${e}trace object not recognized`);
            break;
          }
          null !== s.trace && s.trace.init(b, y, h);
        }(), function () {
          const e = `${r}initializeStats(): `;
          for (;;) {
            if (void 0 === s.stats) {
              s.stats = null;
              break;
            }
            if (null === s.stats) break;
            if ("statsObject" !== s.stats.statsObject) throw new Error(`${e}stats object not recognized`);
            break;
          }
          null !== s.stats && s.stats.init(b, y);
        }(), function () {
          const e = `${r}initializeAst(): `;
          for (;;) {
            if (void 0 === s.ast) {
              s.ast = null;
              break;
            }
            if (null === s.ast) break;
            if ("astObject" !== s.ast.astObject) throw new Error(`${e}ast object not recognized`);
            break;
          }
          null !== s.ast && s.ast.init(b, y, h);
        }();
        const A = new M();
        switch (null != c && (T = c), p = [{
          type: t.RNM,
          index: w
        }], i(0, o, A), p = null, A.state) {
          case t.ACTIVE:
            throw new Error(`${x}final state should never be 'ACTIVE'`);
          case t.NOMATCH:
            u = !1;
            break;
          case t.EMPTY:
          case t.MATCH:
            u = A.phraseLength === a;
            break;
          default:
            throw new Error("unrecognized state");
        }
        return {
          success: u,
          state: A.state,
          length: a,
          matched: A.phraseLength,
          maxMatched: E,
          maxTreeDepth: d,
          nodeHits: f,
          inputLength: h.length,
          subBegin: o,
          subEnd: l,
          subLength: a
        };
      };
      this.parseSubstring = function (e, t, n, r, s, i) {
        return C(), L(n, r, s), B(e, t, i);
      }, this.parse = function (e, t, n, r) {
        return C(), L(n, 0, n.length), B(e, t, r);
      };
      const R = function (e, n, r) {
          const s = p[e];
          for (let e = 0; e < s.children.length && (i(s.children[e], n, r), r.state === t.NOMATCH); e += 1);
        },
        N = function (e, n, s, i) {
          if (n.phraseLength > s) {
            let t = `${r}opRNM(${e.name}): callback function error: `;
            throw t += `sysData.phraseLength: ${n.phraseLength}`, t += ` must be <= remaining chars: ${s}`, new Error(t);
          }
          switch (n.state) {
            case t.ACTIVE:
              if (!0 !== i) throw new Error(`${r}opRNM(${e.name}): callback function return error. ACTIVE state not allowed.`);
              break;
            case t.EMPTY:
              n.phraseLength = 0;
              break;
            case t.MATCH:
              0 === n.phraseLength && (n.state = t.EMPTY);
              break;
            case t.NOMATCH:
              n.phraseLength = 0;
              break;
            default:
              throw new Error(`${r}opRNM(${e.name}): callback function return error. Unrecognized return state: ${n.state}`);
          }
        },
        v = function (e, n, r) {
          let o, a, c, u, d, f;
          const m = p[e],
            y = b[m.index],
            E = g[y.index],
            x = !$();
          if (x && (a = s.ast && s.ast.ruleDefined(m.index), a && (o = s.ast.getLength(), s.ast.down(m.index, b[m.index].name)), u = r.uFrame.length(), d = r.pFrame.length(), r.uFrame.push(), r.pFrame.push(), f = r.pFrame, r.pFrame = new S()), null === E) c = p, p = y.opcodes, i(0, n, r), p = c;else {
            const e = l - n;
            r.ruleIndex = y.index, E(r, h, n, T), N(y, r, e, !0), r.state === t.ACTIVE && (c = p, p = y.opcodes, i(0, n, r), p = c, r.ruleIndex = y.index, E(r, h, n, T), N(y, r, e, !1));
          }
          x && (a && (r.state === t.NOMATCH ? s.ast.setLength(o) : s.ast.up(m.index, y.name, n, r.phraseLength)), r.pFrame = f, r.state === t.NOMATCH ? (r.uFrame.pop(u), r.pFrame.pop(d)) : y.isBkr && (r.pFrame.savePhrase(y.lower, n, r.phraseLength), r.uFrame.savePhrase(y.lower, n, r.phraseLength)));
        },
        _ = function (e, n, i) {
          let o, a, c, u, d, f;
          const g = p[e],
            E = y[g.index];
          i.UdtIndex = E.index;
          const x = !$();
          x && (c = s.ast && s.ast.udtDefined(g.index), c && (a = b.length + g.index, o = s.ast.getLength(), s.ast.down(a, E.name)), u = i.uFrame.length(), d = i.pFrame.length(), i.uFrame.push(), i.pFrame.push(), f = i.pFrame, i.pFrame = new S());
          const w = l - n;
          m[g.index](i, h, n, T), function (e, n, s) {
            if (n.phraseLength > s) {
              let t = `${r}opUDT(${e.name}): callback function error: `;
              throw t += `sysData.phraseLength: ${n.phraseLength}`, t += ` must be <= remaining chars: ${s}`, new Error(t);
            }
            switch (n.state) {
              case t.ACTIVE:
                throw new Error(`${r}opUDT(${e.name}): callback function return error. ACTIVE state not allowed.`);
              case t.EMPTY:
                if (!1 === e.empty) throw new Error(`${r}opUDT(${e.name}): callback function return error. May not return EMPTY.`);
                n.phraseLength = 0;
                break;
              case t.MATCH:
                if (0 === n.phraseLength) {
                  if (!1 === e.empty) throw new Error(`${r}opUDT(${e.name}): callback function return error. May not return EMPTY.`);
                  n.state = t.EMPTY;
                }
                break;
              case t.NOMATCH:
                n.phraseLength = 0;
                break;
              default:
                throw new Error(`${r}opUDT(${e.name}): callback function return error. Unrecognized return state: ${n.state}`);
            }
          }(E, i, w), x && (c && (i.state === t.NOMATCH ? s.ast.setLength(o) : s.ast.up(a, E.name, n, i.phraseLength)), i.pFrame = f, i.state === t.NOMATCH ? (i.uFrame.pop(u), i.pFrame.pop(d)) : E.isBkr && (i.pFrame.savePhrase(E.lower, n, i.phraseLength), i.uFrame.savePhrase(E.lower, n, i.phraseLength)));
        },
        D = function (e, n, r) {
          c.push({
            lookAround: t.LOOKAROUND_AHEAD,
            anchor: n,
            charsEnd: l,
            charsLength: a
          }), l = h.length, a = h.length - o, i(e + 1, n, r);
          const s = c.pop();
          switch (l = s.charsEnd, a = s.charsLength, r.phraseLength = 0, r.state) {
            case t.EMPTY:
            case t.MATCH:
              r.state = t.EMPTY;
              break;
            case t.NOMATCH:
              r.state = t.NOMATCH;
              break;
            default:
              throw new Error(`opAND: invalid state ${r.state}`);
          }
        },
        P = function (e, n, r) {
          c.push({
            lookAround: t.LOOKAROUND_AHEAD,
            anchor: n,
            charsEnd: l,
            charsLength: a
          }), l = h.length, a = h.length - o, i(e + 1, n, r);
          const s = c.pop();
          switch (l = s.charsEnd, a = s.charsLength, r.phraseLength = 0, r.state) {
            case t.EMPTY:
            case t.MATCH:
              r.state = t.NOMATCH;
              break;
            case t.NOMATCH:
              r.state = t.EMPTY;
              break;
            default:
              throw new Error(`opNOT: invalid state ${r.state}`);
          }
        },
        I = function (e, n, r) {
          r.state = t.NOMATCH, r.phraseLength = 0, r.state = 0 === n ? t.EMPTY : t.NOMATCH;
        },
        H = function (e, n, r) {
          r.state = t.NOMATCH, r.phraseLength = 0, r.state = n === h.length ? t.EMPTY : t.NOMATCH;
        },
        U = function (e, n, r) {
          switch (c.push({
            lookAround: t.LOOKAROUND_BEHIND,
            anchor: n
          }), i(e + 1, n, r), c.pop(), r.phraseLength = 0, r.state) {
            case t.EMPTY:
            case t.MATCH:
              r.state = t.EMPTY;
              break;
            case t.NOMATCH:
              r.state = t.NOMATCH;
              break;
            default:
              throw new Error(`opBKA: invalid state ${r.state}`);
          }
        },
        F = function (e, n, r) {
          switch (c.push({
            lookAround: t.LOOKAROUND_BEHIND,
            anchor: n
          }), i(e + 1, n, r), c.pop(), r.phraseLength = 0, r.state) {
            case t.EMPTY:
            case t.MATCH:
              r.state = t.NOMATCH;
              break;
            case t.NOMATCH:
              r.state = t.EMPTY;
              break;
            default:
              throw new Error(`opBKN: invalid state ${r.state}`);
          }
        };
      i = function (e, n, r) {
        let o = !0;
        const a = p[e];
        if (f += 1, f > w) throw new Error(`parser: maximum number of node hits exceeded: ${w}`);
        if (u += 1, u > d && (d = u, d > x)) throw new Error(`parser: maximum parse tree depth exceeded: ${x}`);
        if (r.refresh(), null !== s.trace) {
          const e = O();
          s.trace.down(a, r.state, n, r.phraseLength, e.anchor, e.lookAround);
        }
        if (c[c.length - 1].lookAround === t.LOOKAROUND_BEHIND) switch (a.type) {
          case t.ALT:
            R(e, n, r);
            break;
          case t.CAT:
            !function (e, n, r) {
              let o, a, l, c;
              const h = p[e],
                u = r.uFrame.length(),
                d = r.pFrame.length();
              s.ast && (a = s.ast.getLength()), o = !0, l = n, c = 0;
              for (let e = h.children.length - 1; e >= 0; e -= 1) if (i(h.children[e], l, r), l -= r.phraseLength, c += r.phraseLength, r.state === t.NOMATCH) {
                o = !1;
                break;
              }
              o ? (r.state = 0 === c ? t.EMPTY : t.MATCH, r.phraseLength = c) : (r.state = t.NOMATCH, r.phraseLength = 0, r.uFrame.pop(u), r.pFrame.pop(d), s.ast && s.ast.setLength(a));
            }(e, n, r);
            break;
          case t.REP:
            !function (e, n, r) {
              let o, a, l, c;
              const h = p[e];
              a = n, l = 0, c = 0;
              const u = r.uFrame.length(),
                d = r.pFrame.length();
              for (s.ast && (o = s.ast.getLength()); !(a <= 0) && (i(e + 1, a, r), r.state !== t.NOMATCH) && r.state !== t.EMPTY && (c += 1, l += r.phraseLength, a -= r.phraseLength, c !== h.max););
              r.state === t.EMPTY || c >= h.min ? (r.state = 0 === l ? t.EMPTY : t.MATCH, r.phraseLength = l) : (r.state = t.NOMATCH, r.phraseLength = 0, r.uFrame.pop(u), r.pFrame.pop(d), s.ast && s.ast.setLength(o));
            }(e, n, r);
            break;
          case t.RNM:
            v(e, n, r);
            break;
          case t.UDT:
            _(e, n, r);
            break;
          case t.AND:
            D(e, n, r);
            break;
          case t.NOT:
            P(e, n, r);
            break;
          case t.TRG:
            !function (e, n, r) {
              const s = p[e];
              if (r.state = t.NOMATCH, r.phraseLength = 0, n > 0) {
                const e = h[n - 1];
                s.min <= e && e <= s.max && (r.state = t.MATCH, r.phraseLength = 1);
              }
            }(e, n, r);
            break;
          case t.TBS:
            !function (e, n, r) {
              let s;
              const i = p[e];
              r.state = t.NOMATCH;
              const o = i.string.length,
                a = n - o;
              if (a >= 0) {
                for (s = 0; s < o; s += 1) if (h[a + s] !== i.string[s]) return;
                r.state = t.MATCH, r.phraseLength = o;
              }
            }(e, n, r);
            break;
          case t.TLS:
            !function (e, n, r) {
              let s;
              const i = p[e];
              r.state = t.NOMATCH;
              const o = i.string.length;
              if (0 === o) return void (r.state = t.EMPTY);
              const a = n - o;
              if (a >= 0) {
                for (let e = 0; e < o; e += 1) if (s = h[a + e], s >= 65 && s <= 90 && (s += 32), s !== i.string[e]) return;
                r.state = t.MATCH, r.phraseLength = o;
              }
            }(e, n, r);
            break;
          case t.BKR:
            !function (e, n, r) {
              let s, i, o, a;
              const l = p[e];
              r.state = t.NOMATCH, r.phraseLength = 0, a = l.index < b.length ? b[l.index].lower : y[l.index - b.length].lower;
              const c = l.bkrMode === t.BKR_MODE_PM ? r.pFrame.getPhrase(a) : r.uFrame.getPhrase(a),
                u = l.bkrCase === t.BKR_MODE_CI;
              if (null === c) return;
              const d = c.phraseIndex,
                f = c.phraseLength;
              if (0 === f) return r.state = t.EMPTY, void (r.phraseLength = 0);
              const g = n - f;
              if (g >= 0) {
                if (u) {
                  for (s = 0; s < f; s += 1) if (i = h[g + s], o = h[d + s], i >= 65 && i <= 90 && (i += 32), o >= 65 && o <= 90 && (o += 32), i !== o) return;
                  r.state = t.MATCH, r.phraseLength = f;
                } else for (s = 0; s < f; s += 1) if (i = h[g + s], o = h[d + s], i !== o) return;
                r.state = t.MATCH, r.phraseLength = f;
              }
            }(e, n, r);
            break;
          case t.BKA:
            U(e, n, r);
            break;
          case t.BKN:
            F(e, n, r);
            break;
          case t.ABG:
            I(0, n, r);
            break;
          case t.AEN:
            H(0, n, r);
            break;
          default:
            o = !1;
        } else switch (a.type) {
          case t.ALT:
            R(e, n, r);
            break;
          case t.CAT:
            !function (e, n, r) {
              let o, a, l, c;
              const h = p[e],
                u = r.uFrame.length(),
                d = r.pFrame.length();
              s.ast && (a = s.ast.getLength()), o = !0, l = n, c = 0;
              for (let e = 0; e < h.children.length; e += 1) {
                if (i(h.children[e], l, r), r.state === t.NOMATCH) {
                  o = !1;
                  break;
                }
                l += r.phraseLength, c += r.phraseLength;
              }
              o ? (r.state = 0 === c ? t.EMPTY : t.MATCH, r.phraseLength = c) : (r.state = t.NOMATCH, r.phraseLength = 0, r.uFrame.pop(u), r.pFrame.pop(d), s.ast && s.ast.setLength(a));
            }(e, n, r);
            break;
          case t.REP:
            !function (e, n, r) {
              let o, a, c, h;
              const u = p[e];
              if (0 === u.max) return r.state = t.EMPTY, void (r.phraseLength = 0);
              a = n, c = 0, h = 0;
              const d = r.uFrame.length(),
                f = r.pFrame.length();
              for (s.ast && (o = s.ast.getLength()); !(a >= l) && (i(e + 1, a, r), r.state !== t.NOMATCH) && r.state !== t.EMPTY && (h += 1, c += r.phraseLength, a += r.phraseLength, h !== u.max););
              r.state === t.EMPTY || h >= u.min ? (r.state = 0 === c ? t.EMPTY : t.MATCH, r.phraseLength = c) : (r.state = t.NOMATCH, r.phraseLength = 0, r.uFrame.pop(d), r.pFrame.pop(f), s.ast && s.ast.setLength(o));
            }(e, n, r);
            break;
          case t.RNM:
            v(e, n, r);
            break;
          case t.UDT:
            _(e, n, r);
            break;
          case t.AND:
            D(e, n, r);
            break;
          case t.NOT:
            P(e, n, r);
            break;
          case t.TRG:
            !function (e, n, r) {
              const s = p[e];
              r.state = t.NOMATCH, n < l && s.min <= h[n] && h[n] <= s.max && (r.state = t.MATCH, r.phraseLength = 1);
            }(e, n, r);
            break;
          case t.TBS:
            !function (e, n, r) {
              let s;
              const i = p[e],
                o = i.string.length;
              if (r.state = t.NOMATCH, n + o <= l) {
                for (s = 0; s < o; s += 1) if (h[n + s] !== i.string[s]) return;
                r.state = t.MATCH, r.phraseLength = o;
              }
            }(e, n, r);
            break;
          case t.TLS:
            !function (e, n, r) {
              let s, i;
              const o = p[e];
              r.state = t.NOMATCH;
              const a = o.string.length;
              if (0 !== a) {
                if (n + a <= l) {
                  for (s = 0; s < a; s += 1) if (i = h[n + s], i >= 65 && i <= 90 && (i += 32), i !== o.string[s]) return;
                  r.state = t.MATCH, r.phraseLength = a;
                }
              } else r.state = t.EMPTY;
            }(e, n, r);
            break;
          case t.BKR:
            !function (e, n, r) {
              let s, i, o, a;
              const c = p[e];
              r.state = t.NOMATCH, a = c.index < b.length ? b[c.index].lower : y[c.index - b.length].lower;
              const u = c.bkrMode === t.BKR_MODE_PM ? r.pFrame.getPhrase(a) : r.uFrame.getPhrase(a),
                d = c.bkrCase === t.BKR_MODE_CI;
              if (null === u) return;
              const f = u.phraseIndex,
                g = u.phraseLength;
              if (0 !== g) {
                if (n + g <= l) {
                  if (d) {
                    for (s = 0; s < g; s += 1) if (i = h[n + s], o = h[f + s], i >= 65 && i <= 90 && (i += 32), o >= 65 && o <= 90 && (o += 32), i !== o) return;
                    r.state = t.MATCH, r.phraseLength = g;
                  } else for (s = 0; s < g; s += 1) if (i = h[n + s], o = h[f + s], i !== o) return;
                  r.state = t.MATCH, r.phraseLength = g;
                }
              } else r.state = t.EMPTY;
            }(e, n, r);
            break;
          case t.BKA:
            U(e, n, r);
            break;
          case t.BKN:
            F(e, n, r);
            break;
          case t.ABG:
            I(0, n, r);
            break;
          case t.AEN:
            H(0, n, r);
            break;
          default:
            o = !1;
        }
        if (!$() && n + r.phraseLength > E && (E = n + r.phraseLength), null !== s.stats && s.stats.collect(a, r), null !== s.trace) {
          const e = O();
          s.trace.up(a, r.state, n, r.phraseLength, e.anchor, e.lookAround);
        }
        return u -= 1, o;
      };
    };
  }, {
    "./identifiers": 23,
    "./utilities": 29
  }],
  26: [function (e, t, n) {
    t.exports = function () {
      const t = e("./identifiers"),
        n = e("./utilities"),
        r = e("./style");
      let s = [],
        i = [];
      const o = [];
      let a;
      const l = [],
        c = [];
      this.statsObject = "statsObject";
      const p = function (e, t) {
          return e.lower < t.lower ? -1 : e.lower > t.lower ? 1 : 0;
        },
        h = function (e, t) {
          return e.total < t.total ? 1 : e.total > t.total ? -1 : p(e, t);
        },
        u = function (e, t) {
          return e.index < t.index ? -1 : e.index > t.index ? 1 : 0;
        },
        d = function () {
          this.empty = 0, this.match = 0, this.nomatch = 0, this.total = 0;
        },
        f = function (e, n) {
          switch (e.total += 1, n) {
            case t.EMPTY:
              e.empty += 1;
              break;
            case t.MATCH:
              e.match += 1;
              break;
            case t.NOMATCH:
              e.nomatch += 1;
              break;
            default:
              throw new Error(`stats.js: collect(): incStat(): unrecognized state: ${n}`);
          }
        },
        g = function (e, t) {
          let n = "";
          return n += "<tr>", n += `<td class="${r.CLASS_ACTIVE}">${e}</td>`, n += `<td class="${r.CLASS_EMPTY}">${t.empty}</td>`, n += `<td class="${r.CLASS_MATCH}">${t.match}</td>`, n += `<td class="${r.CLASS_NOMATCH}">${t.nomatch}</td>`, n += `<td class="${r.CLASS_ACTIVE}">${t.total}</td>`, n += "</tr>\n", n;
        },
        m = function () {
          let e = "";
          return e += g("ALT", o[t.ALT]), e += g("CAT", o[t.CAT]), e += g("REP", o[t.REP]), e += g("RNM", o[t.RNM]), e += g("TRG", o[t.TRG]), e += g("TBS", o[t.TBS]), e += g("TLS", o[t.TLS]), e += g("UDT", o[t.UDT]), e += g("AND", o[t.AND]), e += g("NOT", o[t.NOT]), e += g("BKR", o[t.BKR]), e += g("BKA", o[t.BKA]), e += g("BKN", o[t.BKN]), e += g("ABG", o[t.ABG]), e += g("AEN", o[t.AEN]), e += g("totals", a), e;
        },
        b = function () {
          let e = "";
          e += "<tr><th></th><th></th><th></th><th></th><th></th></tr>\n", e += "<tr><th>rules</th><th></th><th></th><th></th><th></th></tr>\n";
          for (let t = 0; t < s.length; t += 1) l[t].total > 0 && (e += "<tr>", e += `<td class="${r.CLASS_ACTIVE}">${l[t].name}</td>`, e += `<td class="${r.CLASS_EMPTY}">${l[t].empty}</td>`, e += `<td class="${r.CLASS_MATCH}">${l[t].match}</td>`, e += `<td class="${r.CLASS_NOMATCH}">${l[t].nomatch}</td>`, e += `<td class="${r.CLASS_ACTIVE}">${l[t].total}</td>`, e += "</tr>\n");
          if (i.length > 0) {
            e += "<tr><th></th><th></th><th></th><th></th><th></th></tr>\n", e += "<tr><th>udts</th><th></th><th></th><th></th><th></th></tr>\n";
            for (let t = 0; t < i.length; t += 1) c[t].total > 0 && (e += "<tr>", e += `<td class="${r.CLASS_ACTIVE}">${c[t].name}</td>`, e += `<td class="${r.CLASS_EMPTY}">${c[t].empty}</td>`, e += `<td class="${r.CLASS_MATCH}">${c[t].match}</td>`, e += `<td class="${r.CLASS_NOMATCH}">${c[t].nomatch}</td>`, e += `<td class="${r.CLASS_ACTIVE}">${c[t].total}</td>`, e += "</tr>\n");
          }
          return e;
        };
      this.validate = function (e) {
        let t = !1;
        return "string" == typeof e && "stats" === e && (t = !0), t;
      }, this.init = function (e, n) {
        s = e, i = n, function () {
          o.length = 0, a = new d(), o[t.ALT] = new d(), o[t.CAT] = new d(), o[t.REP] = new d(), o[t.RNM] = new d(), o[t.TRG] = new d(), o[t.TBS] = new d(), o[t.TLS] = new d(), o[t.UDT] = new d(), o[t.AND] = new d(), o[t.NOT] = new d(), o[t.BKR] = new d(), o[t.BKA] = new d(), o[t.BKN] = new d(), o[t.ABG] = new d(), o[t.AEN] = new d(), l.length = 0;
          for (let e = 0; e < s.length; e += 1) l.push({
            empty: 0,
            match: 0,
            nomatch: 0,
            total: 0,
            name: s[e].name,
            lower: s[e].lower,
            index: s[e].index
          });
          if (i.length > 0) {
            c.length = 0;
            for (let e = 0; e < i.length; e += 1) c.push({
              empty: 0,
              match: 0,
              nomatch: 0,
              total: 0,
              name: i[e].name,
              lower: i[e].lower,
              index: i[e].index
            });
          }
        }();
      }, this.collect = function (e, n) {
        f(a, n.state, n.phraseLength), f(o[e.type], n.state, n.phraseLength), e.type === t.RNM && f(l[e.index], n.state, n.phraseLength), e.type === t.UDT && f(c[e.index], n.state, n.phraseLength);
      }, this.toHtml = function (e, t) {
        let n = "";
        n += `<table class="${r.CLASS_STATS}">\n`, "string" == typeof t && (n += `<caption>${t}</caption>\n`), n += `<tr><th class="${r.CLASS_ACTIVE}">ops</th>\n`, n += `<th class="${r.CLASS_EMPTY}">EMPTY</th>\n`, n += `<th class="${r.CLASS_MATCH}">MATCH</th>\n`, n += `<th class="${r.CLASS_NOMATCH}">NOMATCH</th>\n`, n += `<th class="${r.CLASS_ACTIVE}">totals</th></tr>\n`;
        for (;;) {
          if (void 0 === e) {
            n += m();
            break;
          }
          if (null === e) {
            n += m();
            break;
          }
          if ("ops" === e) {
            n += m();
            break;
          }
          if ("index" === e) {
            l.sort(u), c.length > 0 && c.sort(u), n += m(), n += b();
            break;
          }
          if ("hits" === e) {
            l.sort(h), c.length > 0 && c.sort(u), n += m(), n += b();
            break;
          }
          if ("alpha" === e) {
            l.sort(p), c.length > 0 && c.sort(p), n += m(), n += b();
            break;
          }
          break;
        }
        return n += "</table>\n", n;
      }, this.toHtmlPage = function (e, t, r) {
        return n.htmlToPage(this.toHtml(e, t), r);
      };
    };
  }, {
    "./identifiers": 23,
    "./style": 27,
    "./utilities": 29
  }],
  27: [function (e, t, n) {
    t.exports = {
      CLASS_MONOSPACE: "apg-mono",
      CLASS_ACTIVE: "apg-active",
      CLASS_EMPTY: "apg-empty",
      CLASS_MATCH: "apg-match",
      CLASS_NOMATCH: "apg-nomatch",
      CLASS_LOOKAHEAD: "apg-lh-match",
      CLASS_LOOKBEHIND: "apg-lb-match",
      CLASS_REMAINDER: "apg-remainder",
      CLASS_CTRLCHAR: "apg-ctrl-char",
      CLASS_LINEEND: "apg-line-end",
      CLASS_ERROR: "apg-error",
      CLASS_PHRASE: "apg-phrase",
      CLASS_EMPTYPHRASE: "apg-empty-phrase",
      CLASS_STATE: "apg-state",
      CLASS_STATS: "apg-stats",
      CLASS_TRACE: "apg-trace",
      CLASS_GRAMMAR: "apg-grammar",
      CLASS_RULES: "apg-rules",
      CLASS_RULESLINK: "apg-rules-link",
      CLASS_ATTRIBUTES: "apg-attrs"
    };
  }, {}],
  28: [function (e, t, n) {
    t.exports = function () {
      const t = e("./utilities"),
        n = e("./style"),
        r = new (e("./circular-buffer"))(),
        s = e("./identifiers"),
        i = "trace.js: ",
        o = this,
        a = 16,
        l = 80,
        c = [];
      let p = 5e3,
        h = -1,
        u = 0,
        d = 0;
      const f = [];
      let g = null,
        m = null,
        b = null;
      const y = [],
        T = [],
        E = `<span class="${n.CLASS_LINEEND}">&bull;</span>`,
        x = `<span class="${n.CLASS_LINEEND}">&hellip;</span>`,
        w = `<span class="${n.CLASS_EMPTY}">&#120634;</span>`;
      this.traceObject = "traceObject", this.filter = {
        operators: [],
        rules: []
      }, this.setMaxRecords = function (e, t) {
        h = -1, "number" == typeof e && e > 0 ? (p = Math.ceil(e), "number" == typeof t && (h = Math.floor(t), h < 0 && (h = -1))) : p = 0;
      }, this.getMaxRecords = function () {
        return p;
      }, this.getLastRecord = function () {
        return h;
      }, this.init = function (e, t, n) {
        c.length = 0, f.length = 0, u = 0, d = 0, g = n, m = e, b = t, function () {
          const e = function (e) {
            y[s.ALT] = e, y[s.CAT] = e, y[s.REP] = e, y[s.TLS] = e, y[s.TBS] = e, y[s.TRG] = e, y[s.AND] = e, y[s.NOT] = e, y[s.BKR] = e, y[s.BKA] = e, y[s.BKN] = e, y[s.ABG] = e, y[s.AEN] = e;
          };
          let t = 0;
          for (const e in o.filter.operators) t += 1;
          if (0 !== t) {
            for (const t in o.filter.operators) {
              const n = t.toUpperCase();
              if ("<ALL>" === n) return void e(!0);
              if ("<NONE>" === n) return void e(!1);
            }
            e(!1);
            for (const e in o.filter.operators) {
              const t = e.toUpperCase();
              if ("ALT" === t) y[s.ALT] = !0 === o.filter.operators[e];else if ("CAT" === t) y[s.CAT] = !0 === o.filter.operators[e];else if ("REP" === t) y[s.REP] = !0 === o.filter.operators[e];else if ("AND" === t) y[s.AND] = !0 === o.filter.operators[e];else if ("NOT" === t) y[s.NOT] = !0 === o.filter.operators[e];else if ("TLS" === t) y[s.TLS] = !0 === o.filter.operators[e];else if ("TBS" === t) y[s.TBS] = !0 === o.filter.operators[e];else if ("TRG" === t) y[s.TRG] = !0 === o.filter.operators[e];else if ("BKR" === t) y[s.BKR] = !0 === o.filter.operators[e];else if ("BKA" === t) y[s.BKA] = !0 === o.filter.operators[e];else if ("BKN" === t) y[s.BKN] = !0 === o.filter.operators[e];else if ("ABG" === t) y[s.ABG] = !0 === o.filter.operators[e];else {
                if ("AEN" !== t) throw new Error(`${i}initOpratorFilter: '${e}' not a valid operator name. Must be <all>, <none>, alt, cat, rep, tls, tbs, trg, and, not, bkr, bka or bkn`);
                y[s.AEN] = !0 === o.filter.operators[e];
              }
            }
          } else e(!1);
        }(), function () {
          const e = function (e) {
            y[s.RNM] = e, y[s.UDT] = e;
            const t = m.length + b.length;
            T.length = 0;
            for (let n = 0; n < t; n += 1) T.push(e);
          };
          let t, n;
          const r = [];
          for (n = 0; n < m.length; n += 1) r.push(m[n].lower);
          for (n = 0; n < b.length; n += 1) r.push(b[n].lower);
          T.length = 0, t = 0;
          for (const e in o.filter.rules) t += 1;
          if (0 !== t) {
            for (const t in o.filter.rules) {
              const n = t.toLowerCase();
              if ("<all>" === n) return void e(!0);
              if ("<none>" === n) return void e(!1);
            }
            e(!1), y[s.RNM] = !0, y[s.UDT] = !0;
            for (const e in o.filter.rules) {
              const t = e.toLowerCase();
              if (n = r.indexOf(t), n < 0) throw new Error(`${i}initRuleFilter: '${e}' not a valid rule or udt name`);
              T[n] = !0 === o.filter.rules[e];
            }
          } else e(!0);
        }(), r.init(p);
      };
      const A = function (e) {
          let t = !1;
          return t = e.type === s.RNM ? !(!y[e.type] || !T[e.index]) : e.type === s.UDT ? !(!y[e.type] || !T[m.length + e.index]) : y[e.type], t;
        },
        k = function (e) {
          return -1 === h || e <= h;
        };
      this.down = function (e, t, n, s, i, o) {
        k(u) && A(e) && (f.push(u), c[r.increment()] = {
          dirUp: !1,
          depth: d,
          thisLine: u,
          thatLine: void 0,
          opcode: e,
          state: t,
          phraseIndex: n,
          phraseLength: s,
          lookAnchor: i,
          lookAround: o
        }, u += 1, d += 1);
      }, this.up = function (e, t, n, s, i, o) {
        if (k(u) && A(e)) {
          const a = u,
            l = f.pop(),
            p = r.getListIndex(l);
          -1 !== p && (c[p].thatLine = a), d -= 1, c[r.increment()] = {
            dirUp: !0,
            depth: d,
            thisLine: a,
            thatLine: l,
            opcode: e,
            state: t,
            phraseIndex: n,
            phraseLength: s,
            lookAnchor: i,
            lookAround: o
          }, u += 1;
        }
      };
      this.toTree = function (e) {
        const n = function () {
          function e(e, n) {
            let r, i, o;
            if (n) switch (e.op = {
              id: n.type,
              name: t.opcodeToString(n.type)
            }, e.opData = void 0, n.type) {
              case s.RNM:
                e.opData = m[n.index].name;
                break;
              case s.UDT:
                e.opData = b[n.index].name;
                break;
              case s.BKR:
                r = n.index < m.length ? m[n.index].name : b[n.index - m.length].name, i = n.bkrCase === s.BKR_MODE_CI ? "%i" : "%s", o = n.bkrMode === s.BKR_MODE_UM ? "%u" : "%p", e.opData = `\\\\${i}${o}${r}`;
                break;
              case s.TLS:
                e.opData = [];
                for (let t = 0; t < n.string.length; t += 1) e.opData.push(n.string[t]);
                break;
              case s.TBS:
                e.opData = [];
                for (let t = 0; t < n.string.length; t += 1) e.opData.push(n.string[t]);
                break;
              case s.TRG:
              case s.REP:
                e.opData = [n.min, n.max];
                break;
              default:
                throw new Error("unrecognized opcode");
            } else e.op = {
              id: void 0,
              name: void 0
            }, e.opData = void 0;
          }
          function n(e, t, n) {
            return e === s.MATCH ? {
              index: t,
              length: n
            } : e === s.NOMATCH || e === s.EMPTY ? {
              index: t,
              length: 0
            } : null;
          }
          let i = -1;
          function o(r, s, o) {
            const a = {
              id: i++,
              branch: -1,
              parent: r,
              up: !1,
              down: !1,
              depth: o,
              children: []
            };
            return s ? (a.down = !0, a.state = {
              id: s.state,
              name: t.stateToString(s.state)
            }, a.phrase = null, e(a, s.opcode)) : (a.state = {
              id: void 0,
              name: void 0
            }, a.phrase = n(), e(a, void 0)), a;
          }
          function a(r, s) {
            s && (r.up = !0, r.state = {
              id: s.state,
              name: t.stateToString(s.state)
            }, r.phrase = n(s.state, s.phraseIndex, s.phraseLength), r.down || e(r, s.opcode));
          }
          let l = 0,
            p = -1,
            h = 1;
          const u = [];
          let f,
            y,
            T,
            E,
            x = !0;
          const w = o(null, null, -1);
          for (u.push(w), y = w, r.forEach(e => {
            if (E = c[e], x && (x = !1, E.depth > 0)) {
              const e = E.dirUp ? E.depth + 1 : E.depth;
              for (let t = 0; t < e; t += 1) T = y, y = o(y, null, t), u.push(y), T.children.push(y);
            }
            E.dirUp ? (y = u.pop(), a(y, E), y = u[u.length - 1]) : (T = y, y = o(y, E, E.depth), u.push(y), T.children.push(y));
          }); u.length > 1;) y = u.pop(), a(y, null);
          if (0 === w.children.length) throw new Error("trace.toTree(): parse tree has no nodes");
          if (0 === u.length) throw new Error("trace.toTree(): integrity check: dummy root node disappeared?");
          f = w.children[0];
          let A = f;
          for (; f && !f.down && !f.up;) A = f, f = f.children[0];
          f = A, f.leftMost = !0, f.rightMost = !0, function e(t) {
            if (p += 1, t.branch = h, p > d && (d = p), 0 === t.children.length) l += 1;else for (let n = 0; n < t.children.length; n += 1) n > 0 && (h += 1), t.children[n].leftMost = !1, t.children[n].rightMost = !1, t.leftMost && (t.children[n].leftMost = 0 === n), t.rightMost && (t.children[n].rightMost = n === t.children.length - 1), e(t.children[n]);
            p -= 1;
          }(f), f.branch = 0;
          const k = {
            string: []
          };
          for (let e = 0; e < g.length; e += 1) k.string[e] = g[e];
          k.rules = [];
          for (let e = 0; e < m.length; e += 1) k.rules[e] = m[e].name;
          k.udts = [];
          for (let e = 0; e < b.length; e += 1) k.udts[e] = b[e].name;
          let C;
          return k.id = {}, k.id.ALT = {
            id: s.ALT,
            name: "ALT"
          }, k.id.CAT = {
            id: s.CAT,
            name: "CAT"
          }, k.id.REP = {
            id: s.REP,
            name: "REP"
          }, k.id.RNM = {
            id: s.RNM,
            name: "RNM"
          }, k.id.TLS = {
            id: s.TLS,
            name: "TLS"
          }, k.id.TBS = {
            id: s.TBS,
            name: "TBS"
          }, k.id.TRG = {
            id: s.TRG,
            name: "TRG"
          }, k.id.UDT = {
            id: s.UDT,
            name: "UDT"
          }, k.id.AND = {
            id: s.AND,
            name: "AND"
          }, k.id.NOT = {
            id: s.NOT,
            name: "NOT"
          }, k.id.BKR = {
            id: s.BKR,
            name: "BKR"
          }, k.id.BKA = {
            id: s.BKA,
            name: "BKA"
          }, k.id.BKN = {
            id: s.BKN,
            name: "BKN"
          }, k.id.ABG = {
            id: s.ABG,
            name: "ABG"
          }, k.id.AEN = {
            id: s.AEN,
            name: "AEN"
          }, k.id.ACTIVE = {
            id: s.ACTIVE,
            name: "ACTIVE"
          }, k.id.MATCH = {
            id: s.MATCH,
            name: "MATCH"
          }, k.id.EMPTY = {
            id: s.EMPTY,
            name: "EMPTY"
          }, k.id.NOMATCH = {
            id: s.NOMATCH,
            name: "NOMATCH"
          }, k.treeDepth = d, k.leafNodes = l, C = f.down ? f.up ? "none" : "right" : f.up ? "left" : "both", k.branchesIncomplete = C, k.tree = function e(t, n) {
            let r;
            const s = {};
            if (s.id = t.id, s.branch = t.branch, s.leftMost = t.leftMost, s.rightMost = t.rightMost, r = t.state.name ? t.state.name : "ACTIVE", s.state = {
              id: t.state.id,
              name: r
            }, r = t.op.name ? t.op.name : "?", s.op = {
              id: t.op.id,
              name: r
            }, "string" == typeof t.opData) s.opData = t.opData;else if (Array.isArray(t.opData)) {
              s.opData = [];
              for (let e = 0; e < t.opData.length; e += 1) s.opData[e] = t.opData[e];
            } else s.opData = void 0;
            t.phrase ? s.phrase = {
              index: t.phrase.index,
              length: t.phrase.length
            } : s.phrase = null, s.depth = t.depth, s.children = [];
            for (let r = 0; r < t.children.length; r += 1) t.children.length, s.children[r] = e(t.children[r], n);
            return s;
          }(f, f.depth), k;
        }();
        return e ? JSON.stringify(n) : n;
      }, this.toHtmlPage = function (e, n, r) {
        return t.htmlToPage(this.toHtml(e, n), r);
      };
      this.indent = function (e) {
        let t = "";
        for (let n = 0; n < e; n += 1) t += ".";
        return t;
      };
      const C = function (e, n, r, s, i) {
          if (0 === s) return "";
          let o = "";
          const l = i ? "," : "";
          switch (e) {
            case a:
              o = l + t.charsToHex(n, r, s);
              break;
            case 10:
              if (i) return `,${t.charsToDec(n, r, s)}`;
              o = l + t.charsToDec(n, r, s);
              break;
            case 32:
              o = t.charsToUnicode(n, r, s);
              break;
            default:
              o = t.charsToAsciiHtml(n, r, s);
          }
          return o;
        },
        S = function (e, t, r, i, o, a) {
          let c,
            p,
            h,
            u,
            d = "",
            f = E;
          const g = `<span class="${n.CLASS_REMAINDER}">`,
            m = "</span>";
          let b = !1;
          switch (r) {
            case s.EMPTY:
              d += w;
            case s.NOMATCH:
            case s.ACTIVE:
              c = i, p = 0, h = i, u = t.length - h;
              break;
            case s.MATCH:
              c = i, p = o, h = i + p, u = t.length - h;
              break;
            default:
              throw new Error("unrecognized state");
          }
          return f = E, p > l ? (p = l, f = x, u = 0) : p + u > l && (f = x, u = l - p), p > 0 && (d += a, d += C(e, t, c, p, b), d += m, b = !0), u > 0 && (d += g, d += C(e, t, h, u, b), d += m), d + f;
        },
        M = function (e) {
          if (null === m) return "";
          let i,
            p,
            h,
            u,
            d,
            f,
            y = "";
          return y += "<tr><th>(a)</th><th>(b)</th><th>(c)</th><th>(d)</th><th>(e)</th><th>(f)</th>", y += "<th>operator</th><th>phrase</th></tr>\n", r.forEach(r => {
            const T = c[r];
            switch (i = T.thisLine, p = void 0 !== T.thatLine ? T.thatLine : "--", h = !1, u = !1, d = !1, T.lookAround === s.LOOKAROUND_AHEAD && (h = !0, d = !0, f = T.lookAnchor), T.opcode.type !== s.AND && T.opcode.type !== s.NOT || (h = !0, d = !0, f = T.phraseIndex), T.lookAround === s.LOOKAROUND_BEHIND && (u = !0, d = !0, f = T.lookAnchor), T.opcode.type !== s.BKA && T.opcode.type !== s.BKN || (u = !0, d = !0, f = T.phraseIndex), y += "<tr>", y += `<td>${i}</td><td>${p}</td>`, y += `<td>${T.phraseIndex}</td>`, y += `<td>${T.phraseLength}</td>`, y += `<td>${T.depth}</td>`, y += "<td>", T.state) {
              case s.ACTIVE:
                y += `<span class="${n.CLASS_ACTIVE}">&darr;&nbsp;</span>`;
                break;
              case s.MATCH:
                y += `<span class="${n.CLASS_MATCH}">&uarr;M</span>`;
                break;
              case s.NOMATCH:
                y += `<span class="${n.CLASS_NOMATCH}">&uarr;N</span>`;
                break;
              case s.EMPTY:
                y += `<span class="${n.CLASS_EMPTY}">&uarr;E</span>`;
                break;
              default:
                y += `<span class="${n.CLASS_ACTIVE}">--</span>`;
            }
            if (y += "</td>", y += "<td>", y += o.indent(T.depth), h ? y += `<span class="${n.CLASS_LOOKAHEAD}">` : u && (y += `<span class="${n.CLASS_LOOKBEHIND}">`), y += t.opcodeToString(T.opcode.type), T.opcode.type === s.RNM && (y += `(${m[T.opcode.index].name}) `), T.opcode.type === s.BKR) {
              const e = T.opcode.bkrCase === s.BKR_MODE_CI ? "%i" : "%s",
                t = T.opcode.bkrMode === s.BKR_MODE_UM ? "%u" : "%p";
              y += `(\\${e}${t}${m[T.opcode.index].name}) `;
            }
            T.opcode.type === s.UDT && (y += `(${b[T.opcode.index].name}) `), T.opcode.type === s.TRG && (y += `(${function (e, t) {
              let n = "";
              if (t.type === s.TRG) if (e === a || 32 === e) {
                let r = t.min.toString(16).toUpperCase();
                r.length % 2 != 0 && (r = `0${r}`), n += e === a ? "%x" : "U+", n += r, r = t.max.toString(16).toUpperCase(), r.length % 2 != 0 && (r = `0${r}`), n += `&ndash;${r}`;
              } else n = `%d${t.min.toString(10)}&ndash;${t.max.toString(10)}`;
              return n;
            }(e, T.opcode)}) `), T.opcode.type === s.TBS && (y += `(${function (e, t) {
              let n = "";
              if (t.type === s.TBS) {
                const r = Math.min(t.string.length, 10);
                if (e === a || 32 === e) {
                  n += e === a ? "%x" : "U+";
                  for (let e = 0; e < r; e += 1) {
                    let r;
                    e > 0 && (n += "."), r = t.string[e].toString(16).toUpperCase(), r.length % 2 != 0 && (r = `0${r}`), n += r;
                  }
                } else {
                  n = "%d";
                  for (let e = 0; e < r; e += 1) e > 0 && (n += "."), n += t.string[e].toString(10);
                }
                r < t.string.length && (n += x);
              }
              return n;
            }(e, T.opcode)}) `), T.opcode.type === s.TLS && (y += `(${function (e, n) {
              let r = "";
              if (n.type === s.TLS) {
                const s = Math.min(n.string.length, 5);
                if (e === a || 10 === e) {
                  let t, i, o;
                  e === a ? (r = "%x", o = 16) : (r = "%d", o = 10);
                  for (let e = 0; e < s; e += 1) e > 0 && (r += "."), i = n.string[e], i >= 97 && i <= 122 ? (t = i - 32, r += `${t.toString(o)}/${i.toString(o)}`.toUpperCase()) : i >= 65 && i <= 90 ? (t = i, i += 32, r += `${t.toString(o)}/${i.toString(o)}`.toUpperCase()) : r += i.toString(o).toUpperCase();
                  s < n.string.length && (r += x);
                } else {
                  r = '"';
                  for (let e = 0; e < s; e += 1) r += t.asciiChars[n.string[e]];
                  s < n.string.length && (r += x), r += '"';
                }
              }
              return r;
            }(e, T.opcode)}) `), T.opcode.type === s.REP && (y += `(${function (e, t) {
              let n = "";
              if (t.type === s.REP) if (e === a) {
                let e = t.min.toString(16).toUpperCase();
                e.length % 2 != 0 && (e = `0${e}`), n = `x${e}`, t.max < 1 / 0 ? (e = t.max.toString(16).toUpperCase(), e.length % 2 != 0 && (e = `0${e}`)) : e = "inf", n += `&ndash;${e}`;
              } else n = t.max < 1 / 0 ? `${t.min.toString(10)}&ndash;${t.max.toString(10)}` : `${t.min.toString(10)}&ndash;inf`;
              return n;
            }(e, T.opcode)}) `), d && (y += "</span>"), y += "</td>", y += "<td>", y += u ? function (e, t, r, i, o, a) {
              let c,
                p,
                h,
                u,
                d = "",
                f = E;
              const g = `<span class="${n.CLASS_LOOKBEHIND}">`,
                m = `<span class="${n.CLASS_REMAINDER}">`,
                b = "</span>";
              let y = !1;
              switch (r) {
                case s.EMPTY:
                  d += w;
                case s.NOMATCH:
                case s.MATCH:
                case s.ACTIVE:
                  c = i - o, p = a - c, h = a, u = t.length - h;
                  break;
                default:
                  throw new Error("unrecognized state");
              }
              return f = E, p > l ? (p = l, f = x, u = 0) : p + u > l && (f = x, u = l - p), p > 0 && (d += g, d += C(e, t, c, p, y), d += b, y = !0), u > 0 && (d += m, d += C(e, t, h, u, y), d += b), d + f;
            }(e, g, T.state, T.phraseIndex, T.phraseLength, f) : h ? function (e, t, r, s, i) {
              const o = `<span class="${n.CLASS_LOOKAHEAD}">`;
              return S(e, t, r, s, i, o);
            }(e, g, T.state, T.phraseIndex, T.phraseLength) : function (e, t, r, s, i) {
              const o = `<span class="${n.CLASS_MATCH}">`;
              return S(e, t, r, s, i, o);
            }(e, g, T.state, T.phraseIndex, T.phraseLength), y += "</td></tr>\n";
          }), y += "<tr><th>(a)</th><th>(b)</th><th>(c)</th><th>(d)</th><th>(e)</th><th>(f)</th>", y += "<th>operator</th><th>phrase</th></tr>\n", y += "</table>\n", y;
        };
      this.toHtml = function (e, t) {
        let r = 8;
        if ("string" == typeof e && e.length >= 3) {
          const t = e.toLowerCase().slice(0, 3);
          "hex" === t ? r = a : "dec" === t ? r = 10 : "uni" === t && (r = 32);
        }
        let s = "";
        return s += function (e, t) {
          let r;
          switch (e) {
            case a:
              r = "hexadecimal";
              break;
            case 10:
              r = "decimal";
              break;
            case 8:
              r = "ASCII";
              break;
            case 32:
              r = "UNICODE";
              break;
            default:
              throw new Error(`${i}htmlHeader: unrecognized mode: ${e}`);
          }
          let s = "";
          return s += `<p>display mode: ${r}</p>\n`, s += `<table class="${n.CLASS_TRACE}">\n`, "string" == typeof t && (s += `<caption>${t}</caption>`), s;
        }(r, t), s += M(r), s += function () {
          let e = "";
          return e += "</table>\n", e += `<p class="${n.CLASS_MONOSPACE}">legend:<br>\n`, e += "(a)&nbsp;-&nbsp;line number<br>\n", e += "(b)&nbsp;-&nbsp;matching line number<br>\n", e += "(c)&nbsp;-&nbsp;phrase offset<br>\n", e += "(d)&nbsp;-&nbsp;phrase length<br>\n", e += "(e)&nbsp;-&nbsp;tree depth<br>\n", e += "(f)&nbsp;-&nbsp;operator state<br>\n", e += `&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${n.CLASS_ACTIVE}">&darr;</span>&nbsp;&nbsp;phrase opened<br>\n`, e += `&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${n.CLASS_MATCH}">&uarr;M</span> phrase matched<br>\n`, e += `&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${n.CLASS_EMPTY}">&uarr;E</span> empty phrase matched<br>\n`, e += `&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${n.CLASS_NOMATCH}">&uarr;N</span> phrase not matched<br>\n`, e += "operator&nbsp;-&nbsp;ALT, CAT, REP, RNM, TRG, TLS, TBS<sup>&dagger;</sup>, UDT, AND, NOT, BKA, BKN, BKR, ABG, AEN<sup>&Dagger;</sup><br>\n", e += "phrase&nbsp;&nbsp;&nbsp;-&nbsp;up to 80 characters of the phrase being matched<br>\n", e += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${n.CLASS_MATCH}">matched characters</span><br>\n`, e += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${n.CLASS_LOOKAHEAD}">matched characters in look ahead mode</span><br>\n`, e += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${n.CLASS_LOOKBEHIND}">matched characters in look behind mode</span><br>\n`, e += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${n.CLASS_REMAINDER}">remainder characters(not yet examined by parser)</span><br>\n`, e += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;<span class="${n.CLASS_CTRLCHAR}">control characters, TAB, LF, CR, etc. (ASCII mode only)</span><br>\n`, e += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;${w} empty string<br>\n`, e += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;${E} end of input string<br>\n`, e += `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;${x} input string display truncated<br>\n`, e += "</p>\n", e += `<p class="${n.CLASS_MONOSPACE}">\n`, e += "<sup>&dagger;</sup>original ABNF operators:<br>\n", e += "ALT - alternation<br>\n", e += "CAT - concatenation<br>\n", e += "REP - repetition<br>\n", e += "RNM - rule name<br>\n", e += "TRG - terminal range<br>\n", e += "TLS - terminal literal string (case insensitive)<br>\n", e += "TBS - terminal binary string (case sensitive)<br>\n", e += "<br>\n", e += "<sup>&Dagger;</sup>super set SABNF operators:<br>\n", e += "UDT - user-defined terminal<br>\n", e += "AND - positive look ahead<br>\n", e += "NOT - negative look ahead<br>\n", e += "BKA - positive look behind<br>\n", e += "BKN - negative look behind<br>\n", e += "BKR - back reference<br>\n", e += "ABG - anchor - begin of input string<br>\n", e += "AEN - anchor - end of input string<br>\n", e += "</p>\n", e;
        }(), s;
      };
    };
  }, {
    "./circular-buffer": 21,
    "./identifiers": 23,
    "./style": 27,
    "./utilities": 29
  }],
  29: [function (e, t, n) {
    const r = e("./style"),
      s = e("../apg-conv-api/converter"),
      i = e("./emitcss"),
      o = e("./identifiers"),
      a = "utilities.js: ",
      l = function (e, t, n) {
        let r,
          s = t;
        for (;;) {
          if (e <= 0) {
            s = 0, r = 0;
            break;
          }
          if ("number" != typeof s) {
            s = 0, r = e;
            break;
          }
          if (s >= e) {
            s = e, r = e;
            break;
          }
          if ("number" != typeof n) {
            r = e;
            break;
          }
          if (r = s + n, r > e) {
            r = e;
            break;
          }
          break;
        }
        return {
          beg: s,
          end: r
        };
      };
    n.htmlToPage = function (e, t) {
      let n;
      if ("string" != typeof e) throw new Error(`${a}htmlToPage: input HTML is not a string`);
      n = "string" != typeof t ? "htmlToPage" : t;
      let r = "";
      return r += "<!DOCTYPE html>\n", r += '<html lang="en">\n', r += "<head>\n", r += '<meta charset="utf-8">\n', r += `<title>${n}</title>\n`, r += "<style>\n", r += i(), r += "</style>\n", r += "</head>\n<body>\n", r += `<p>${new Date()}</p>\n`, r += e, r += "</body>\n</html>\n", r;
    }, n.parserResultToHtml = function (e, t) {
      let n,
        s,
        i = null;
      "string" == typeof t && "" !== t && (i = t), n = !0 === e.success ? `<span class="${r.CLASS_MATCH}">true</span>` : `<span class="${r.CLASS_NOMATCH}">false</span>`, s = e.state === o.EMPTY ? `<span class="${r.CLASS_EMPTY}">EMPTY</span>` : e.state === o.MATCH ? `<span class="${r.CLASS_MATCH}">MATCH</span>` : e.state === o.NOMATCH ? `<span class="${r.CLASS_NOMATCH}">NOMATCH</span>` : `<span class="${r.CLASS_NOMATCH}">unrecognized</span>`;
      let a = "";
      return a += `<table class="${r.CLASS_STATE}">\n`, i && (a += `<caption>${i}</caption>\n`), a += "<tr><th>state item</th><th>value</th><th>description</th></tr>\n", a += `<tr><td>parser success</td><td>${n}</td>\n`, a += `<td><span class="${r.CLASS_MATCH}">true</span> if the parse succeeded,\n`, a += ` <span class="${r.CLASS_NOMATCH}">false</span> otherwise`, a += "<br><i>NOTE: for success, entire string must be matched</i></td></tr>\n", a += `<tr><td>parser state</td><td>${s}</td>\n`, a += `<td><span class="${r.CLASS_EMPTY}">EMPTY</span>, `, a += `<span class="${r.CLASS_MATCH}">MATCH</span> or \n`, a += `<span class="${r.CLASS_NOMATCH}">NOMATCH</span></td></tr>\n`, a += `<tr><td>string length</td><td>${e.length}</td><td>length of the input (sub)string</td></tr>\n`, a += `<tr><td>matched length</td><td>${e.matched}</td><td>number of input string characters matched</td></tr>\n`, a += `<tr><td>max matched</td><td>${e.maxMatched}</td><td>maximum number of input string characters matched</td></tr>\n`, a += `<tr><td>max tree depth</td><td>${e.maxTreeDepth}</td><td>maximum depth of the parse tree reached</td></tr>\n`, a += `<tr><td>node hits</td><td>${e.nodeHits}</td><td>number of parse tree node hits (opcode function calls)</td></tr>\n`, a += `<tr><td>input length</td><td>${e.inputLength}</td><td>length of full input string</td></tr>\n`, a += `<tr><td>sub-string begin</td><td>${e.subBegin}</td><td>sub-string first character index</td></tr>\n`, a += `<tr><td>sub-string end</td><td>${e.subEnd}</td><td>sub-string end-of-string index</td></tr>\n`, a += `<tr><td>sub-string length</td><td>${e.subLength}</td><td>sub-string length</td></tr>\n`, a += "</table>\n", a;
    }, n.charsToString = function (e, t, n) {
      let r, i;
      if ("number" == typeof t) {
        if (t >= e.length) return "";
        r = t < 0 ? 0 : t;
      } else r = 0;
      if ("number" == typeof n) {
        if (n <= 0) return "";
        i = n > e.length - r ? e.length : r + n;
      } else i = e.length;
      return r < i ? s.encode("UTF16LE", e.slice(r, i)).toString("utf16le") : "";
    }, n.stringToChars = function (e) {
      return s.decode("STRING", e);
    }, n.opcodeToString = function (e) {
      let t = "unknown";
      switch (e) {
        case o.ALT:
          t = "ALT";
          break;
        case o.CAT:
          t = "CAT";
          break;
        case o.RNM:
          t = "RNM";
          break;
        case o.UDT:
          t = "UDT";
          break;
        case o.AND:
          t = "AND";
          break;
        case o.NOT:
          t = "NOT";
          break;
        case o.REP:
          t = "REP";
          break;
        case o.TRG:
          t = "TRG";
          break;
        case o.TBS:
          t = "TBS";
          break;
        case o.TLS:
          t = "TLS";
          break;
        case o.BKR:
          t = "BKR";
          break;
        case o.BKA:
          t = "BKA";
          break;
        case o.BKN:
          t = "BKN";
          break;
        case o.ABG:
          t = "ABG";
          break;
        case o.AEN:
          t = "AEN";
          break;
        default:
          throw new Error("unrecognized opcode");
      }
      return t;
    }, n.stateToString = function (e) {
      let t = "unknown";
      switch (e) {
        case o.ACTIVE:
          t = "ACTIVE";
          break;
        case o.MATCH:
          t = "MATCH";
          break;
        case o.EMPTY:
          t = "EMPTY";
          break;
        case o.NOMATCH:
          t = "NOMATCH";
          break;
        default:
          throw new Error("unrecognized state");
      }
      return t;
    }, n.asciiChars = ["NUL", "SOH", "STX", "ETX", "EOT", "ENQ", "ACK", "BEL", "BS", "TAB", "LF", "VT", "FF", "CR", "SO", "SI", "DLE", "DC1", "DC2", "DC3", "DC4", "NAK", "SYN", "ETB", "CAN", "EM", "SUB", "ESC", "FS", "GS", "RS", "US", "&nbsp;", "!", "&#34;", "#", "$", "%", "&#38;", "&#39;", "(", ")", "*", "+", ",", "-", ".", "/", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ":", ";", "&#60;", "=", "&#62;", "?", "@", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "[", "&#92;", "]", "^", "_", "`", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "{", "|", "}", "~", "DEL"], n.charToHex = function (e) {
      let t = e.toString(16).toUpperCase();
      switch (t.length) {
        case 1:
        case 3:
        case 7:
          t = `0${t}`;
          break;
        case 2:
        case 6:
          t = `00${t}`;
          break;
        case 4:
          break;
        case 5:
          t = `000${t}`;
          break;
        default:
          throw new Error("unrecognized option");
      }
      return t;
    }, n.charsToDec = function (e, t, n) {
      let r = "";
      if (!Array.isArray(e)) throw new Error(`${a}charsToDec: input must be an array of integers`);
      const s = l(e.length, t, n);
      if (s.end > s.beg) {
        r += e[s.beg];
        for (let t = s.beg + 1; t < s.end; t += 1) r += `,${e[t]}`;
      }
      return r;
    }, n.charsToHex = function (e, t, r) {
      let s = "";
      if (!Array.isArray(e)) throw new Error(`${a}charsToHex: input must be an array of integers`);
      const i = l(e.length, t, r);
      if (i.end > i.beg) {
        s += `\\x${n.charToHex(e[i.beg])}`;
        for (let t = i.beg + 1; t < i.end; t += 1) s += `,\\x${n.charToHex(e[t])}`;
      }
      return s;
    }, n.charsToHtmlEntities = function (e, t, n) {
      let r = "";
      if (!Array.isArray(e)) throw new Error(`${a}charsToHex: input must be an array of integers`);
      const s = l(e.length, t, n);
      if (s.end > s.beg) for (let t = s.beg; t < s.end; t += 1) r += `&#x${e[t].toString(16)};`;
      return r;
    }, n.charsToUnicode = function (e, t, r) {
      let s = "";
      if (!Array.isArray(e)) throw new Error(`${a}charsToUnicode: input must be an array of integers`);
      const i = l(e.length, t, r);
      if (i.end > i.beg) for (let t = i.beg; t < i.end; t += 1) s += (o = e[t]) >= 55296 && o <= 57343 || o > 1114111 ? ` U+${n.charToHex(e[t])}` : `&#${e[t]};`;
      var o;
      return s;
    }, n.charsToJsUnicode = function (e, t, r) {
      let s = "";
      if (!Array.isArray(e)) throw new Error(`${a}charsToJsUnicode: input must be an array of integers`);
      const i = l(e.length, t, r);
      if (i.end > i.beg) {
        s += `\\u${n.charToHex(e[i.beg])}`;
        for (let t = i.beg + 1; t < i.end; t += 1) s += `,\\u${n.charToHex(e[t])}`;
      }
      return s;
    }, n.charsToAscii = function (e, t, r) {
      let s = "";
      if (!Array.isArray(e)) throw new Error(`${a}charsToAscii: input must be an array of integers`);
      const i = l(e.length, t, r);
      for (let t = i.beg; t < i.end; t += 1) {
        const r = e[t];
        s += r >= 32 && r <= 126 ? String.fromCharCode(r) : `\\x${n.charToHex(r)}`;
      }
      return s;
    }, n.charsToAsciiHtml = function (e, t, s) {
      if (!Array.isArray(e)) throw new Error(`${a}charsToAsciiHtml: input must be an array of integers`);
      let i,
        o = "";
      const c = l(e.length, t, s);
      for (let t = c.beg; t < c.end; t += 1) i = e[t], o += i < 32 || 127 === i ? `<span class="${r.CLASS_CTRLCHAR}">${n.asciiChars[i]}</span>` : i > 127 ? `<span class="${r.CLASS_CTRLCHAR}">U+${n.charToHex(i)}</span>` : n.asciiChars[i];
      return o;
    }, n.stringToAsciiHtml = function (e) {
      const t = s.decode("STRING", e);
      return this.charsToAsciiHtml(t);
    };
  }, {
    "../apg-conv-api/converter": 17,
    "./emitcss": 22,
    "./identifiers": 23,
    "./style": 27
  }]
}, {}, [16]);